<template>
  <div class="Bgc-white">
    <Header />
    <div  class="contentContacto">
      <div class="container contacto">
        <div class="row justify-content-center">
          <div  class="col-lg-8 col-12 mb-3 modify-reservation">
            <h1 class="title">{{ $t('language.posadasCorporate.reservacionesModificar.modificarReservacion') }}</h1>
          </div>
        </div>
         <Loader v-if="!initialLoader"/>
        <div v-if="initialLoader"  class="row justify-content-center">
          <div  class="col-lg-8 col-12 position-relative modify-reservation mb-5">
            <b-card-group  deck>
              <b-card header-tag="header" footer-tag="footer" class="no-border-bottom">
                <h2 slot="header" class="mb-0 text-right PC-text--size16 PC-text--semibold">
                  {{ $t('language.posadasCorporate.reservacionesModificar.numConfirmacion') }}:
                  <span class="referencia subtitle">{{noConfirmation}}</span>
                </h2>
                <!-- Datos de estancia -->
                <div>
                  <div class="row align-items-center">
                    <div class="col-6 col-lg-6">
                      <i class="icon-building fix-margin font-24 pr-1"></i>
                      <span class="estancia PC-text--size20">{{ $t('language.posadasCorporate.reservacionesModificar.datosEstancia') }}</span>
                    </div>
                    <div class="col-6 col-lg-6 text-right">
                      <a href="#" @click.prevent="$bvModal.show('modificarDatos'); see()"
                        class="PC-text--semibold PC-link--color v-align-elements"><span
                          class="PC-text--size14">{{ $t('language.posadasCorporate.reservacionesModificar.modificarDatosEstancia') }}</span> <i
                          class="icon-right font-18"></i></a>
                    </div>
                  </div>
                  
                </div>
                <div>
                  <span class="d-block PC-text--semibold pt-24 pb-16">{{hotelName}}</span>
                  <span class="d-block PC-text--semibold">{{roomName}}</span>
                </div>
                <div class="pt-16 pb-40">
                  <div class="row">
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <div class="col-1">
                          <i class="icon-calendar fix-margin font-18"></i>
                        </div>
                        <div class="col-10">
                          <span class="d-block">{{arrivalCDate}} - {{departureCDate}}</span>
                          <span class="notas d-block">{{numberOfNights}}  {{((numberOfNights==1)? ($t('language.posadasCorporate.reservacionesModificar.noche')) :  ($t('language.posadasCorporate.reservacionesModificar.noches'))    )}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 only-mobile-pt-16">
                      <div class="row">
                        <div class="col-1">
                          <i class="icon-bed fix-margin font-18"></i>
                        </div>
                        <div class="col-10">
                          <span class="d-inline">{{totalRooms}} {{((totalRooms==1)? ($t('language.posadasCorporate.reservacionesModificar.habitacion')) :  ($t('language.posadasCorporate.reservacionesModificar.habitaciones'))    )}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 only-mobile-py-16">
                      <div class="row">
                        <div class="col-1">
                          <i class="icon-user fix-margin font-18"></i>
                        </div>
                        <div class="col-10">
                          <span>{{totalGuests}} {{((totalGuests==1)? ($t('language.posadasCorporate.reservacionesModificar.huesped')) :  ($t('language.posadasCorporate.reservacionesModificar.huespedes'))    )}}</span>
                          <span class="notas d-block">{{totalAdults}}  {{((totalAdults==1)? ($t('language.posadasCorporate.reservacionesModificar.adulto')) :  ($t('language.posadasCorporate.reservacionesModificar.adultos'))    )}}, {{totalChildren}} {{((totalChildren==1)? ($t('language.posadasCorporate.reservacionesModificar.menor')) :  ($t('language.posadasCorporate.reservacionesModificar.menores'))    )}} {{y}} {{totalInfants}} {{((totalInfants==1)? ($t('language.posadasCorporate.reservacionesModificar.infante')) :  ($t('language.posadasCorporate.reservacionesModificar.infantes'))    )}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <div class="col-1">
                          <i class="icon-promo-code fix-margin font-18"></i>
                        </div>
                        <div class="col-10">
                          <span>{{desTe}}</span>
                          <span class="d-block notas">{{ $t('language.posadasCorporate.reservacionesModificar.codigoDescuento') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                <div class="pt-5 pb-4">
                  <div class="mb-4">
                    <i class="icon-user fix-margin font-24 pr-1"></i>
                    <h3 class="estancia PC-text--size20 d-inline">{{ $t('language.posadasCorporate.reservacionesModificar.datosPersonalesHuesped') }}</h3>
                  </div>
                  <div v-if="enableRewards" class="statusBar statusBar__error">
                    <i class="icon icon-close-rounded-outline"></i>
                    <span>{{$t('language.posadasCorporate.reservacionesRegistro.errorEw')}}</span>
                  </div>
                  <br v-if="enableRewards">
                  <div class="row">
                    <!-- Nombre -->
                    <div class="form-element mt-0 col-12 col-md-6 col-lg-4">
                      <label for="user-name" class="PC-text--size14">{{ $t('language.posadasCorporate.reservacionesModificar.nombreUsuario') }}</label>
                      <input disabled type="text" name="user-name" id="user-name" value="" v-model="name"
                        readonly>
                    </div>
                    <div class="form-element mt-0 col-12 col-md-6 col-lg-4">
                      <label for="fiesta-rewards" class="PC-text--size14">{{ $t('language.posadasCorporate.reservacionesModificar.numFiestaRewards') }}</label>
                      <input type="text" name="fiesta-rewards" id="fiesta-rewards" v-model="fiestaRewardsNumber" maxlength="12" :class="(fiestaRewardsNumber.length > 0 && fiestaRewardsNumber.length < 7 || enableRewards? true: false) ? 'error-code' : ''" @blur="consultFiestaRewards()" 
                      :placeholder="$t('language.posadasCorporate.generals.caracteresMax12')" v-alphanumeric v-uppercase>
                    </div>

                    
                        
                    <div class="form-element mt-0 col-12 col-md-6 col-lg-4">
                      <label for="apreciare-club" class="PC-text--size14">{{ $t('language.posadasCorporate.reservacionesModificar.numApreciareClub') }}</label>
                      <input type="text" name="apreciare-club" id="apreciare-club" v-model="apreciareClubNumber" maxlength="18"
                        :placeholder="$t('language.posadasCorporate.generals.caracteresMax18')">
                    </div>
                    <!-- Fiesta Rewards Card-->
                      <div v-if="banLoaderFR || banMemFR" class="fr-card-container">
                        <Loader v-if="banLoaderFR"/>
                        <div v-if="banMemFR" class="fr-card">
                          <div class="fr-card-section fr-card-section__type">
                            <b>{{infoFR.fiestaRewardsPartnerType}}</b>

                            <img v-if="srcImageFRCard === 1" src="../../../assets/img/fiesta_rewards_cards/clasica_es.png">
                            <img v-if="srcImageFRCard === 2" src="../../../assets/img/fiesta_rewards_cards/clasica_en.png">

                            <img v-if="srcImageFRCard === 3" src="../../../assets/img/fiesta_rewards_cards/oro_es.png">
                            <img v-if="srcImageFRCard === 4" src="../../../assets/img/fiesta_rewards_cards/oro_en.png">

                            <img v-if="srcImageFRCard === 5" src="../../../assets/img/fiesta_rewards_cards/platino_es.png">
                            <img v-if="srcImageFRCard === 6" src="../../../assets/img/fiesta_rewards_cards/platino_en.png">

                            <img v-if="srcImageFRCard === 7" src="../../../assets/img/fiesta_rewards_cards/black_es.png">
                            <img v-if="srcImageFRCard === 8" src="../../../assets/img/fiesta_rewards_cards/black_en.png">

                            <img v-if="srcImageFRCard === 9" src="../../../assets/img/fiesta_rewards_cards/omnia_es.png">
                            <img v-if="srcImageFRCard === 10" src="../../../assets/img/fiesta_rewards_cards/omnia_en.png">

                          </div>
                          <div class="fr-card-section fr-card-section__points">
                            <span class="PC-text--size12">{{$t('language.posadasCorporate.reservacionesRegistro.saldoActual')}}:</span>
                            <span class="bold link PC-text--size20">{{infoFR.fiestaRewardsBalance}}</span>
                            <span class="link PC-text--size12">{{$t('language.posadasCorporate.reservacionesRegistro.puntosFiestaRewards')}}</span>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>

                <hr>

                <!-- Suplementos -->
                <div class="pt-4 pb-5">
                  <i class="icon-bed fix-margin font-24 pr-1"></i>
                  <h3 class="estancia PC-text--size20 pb-16 d-inline">{{ $t('language.posadasCorporate.reservacionesCancelada.text14') }}</h3>
                  <div class="row pt-5">

                    <div v-if="banConsiEspe || considEspe || descriptionMS || (listRequeOpcionalesE.length != 0 && listRequeOpcionalesE != null)" class="col-12">
                      <p class="d-inline-block mb-0">
                        <b
                          class="subtitle"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.suplementos')}}</b>
                      </p>

                      <p v-if="considEspe"
                          class="PC-text--semibold"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.consiEspe')}}
                      </p>
                      <p v-if="considEspe">
                        <span>{{considEspe}}</span>
                      </p>

                      <p  v-if="descriptionMS"
                          class="PC-text--semibold"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.suMan')}}
                      </p>
                      <p v-if="descriptionMS">
                        <span>{{descriptionMS}}</span>
                      </p>

<p  v-if="listRequeOpcionalesE.length != 0 && listRequeOpcionalesE != null"
                          class="PC-text--semibold"
                        >{{$t('language.posadasCorporate.reservacionesRegistro.suplementosOpcionales')}}
                      </p>
                      
                           
                              <div    v-for="(reqOpcional, index) in listRequeOpcionalesE" :key="'_opcional' + index"> <!-- Add this to add tab class="col-xs-12 col-lg-6 mb-2" -->
                              <div class="d-flex flex-row">
                                <input class="mt-1 mr-2" type="checkbox" :id="'_RO' + index" disabled checked>
                                <span  v-if="listRequeOpcionalesE != null && listRequeOpcionalesE != '' && listRequeOpcionalesE.length != 0">
                                  {{reqOpcional.numSuppleCharged}} {{reqOpcional.supplementName}}
                                </span>
                              </div>
                            </div>
                    </div>
                    <!-- Requerimientos -->
                    <div v-if="hideRe" class="col-12 col-lg-9 mt-4">
                      <h3 class="PC-text--size16 PC-text--bold">{{ $t('language.posadasCorporate.reservacionesModificar.requerimientos') }}</h3>
                      <div class="PC-text PC-text--size14 py-16">{{ $t('language.posadasCorporate.reservacionesModificar.sinCostoAdicional') }}
                      </div>
                    </div>

                    <!-- Preferencias de habitacion -->
                    <div v-if="(listRequeriment===null || listRequeriment.habitacion===null?false:true) && hideRe" class="form-element col-12 col-lg-6"
                      v-click-outside="outsideRoomPreferents">
                      <label class="PC-text--size14" v-if="listRequeriment===null?false:true">{{listRequeriment.habitacion.requirementType}}</label>
                      <div class="__addIcon">
                        <span 
                          @click="habitacion1.roomPreferences = false">
                          <input type="text" class="inputTypeHabitaciones pointer" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                            v-model="habitacion1.typePreferent"  readonly
                            :class="habitacion1.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''">
                        </span>
                        <div class="typeRoom card"
                          :class="habitacion1.roomPreferences ? 'oculto' : ''">
                          <div class="d-block allRooms pb-2 mb-2">
                            <input type="checkbox" name="allTipo" id="allTipo" v-model="selectAll"
                              @click="habitacion1.roomPreferences = true"
                              @change="handleType($event)">
                            {{allRoomTypesT}}
                          </div>
                           <div class="listado-container vb" v-bar>
                            <div>
                              <div class="d-block"
                                v-for="typeRoomPreferent in habitacion1.typeRoomsPreferents"
                                :key="typeRoomPreferent.id">
                                <input type="checkbox" v-model="habitacion1.selected"
                                  :value="typeRoomPreferent.id"
                                  @change="handleTypeSelect($event, typeRoomPreferent.name)">
                                {{typeRoomPreferent.name}}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                            <p class="d-inline-block m-0 puntero"
                              @click="[selectAll = false, habitacion1.typePreferent = '']">{{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}
                            </p>
                            <p class="d-inline-block m-0 text-right puntero"
                              :class="[habitacion1.typePreferent == '' ? 'deshabilitado' : '']"
                              @click="habitacion1.roomPreferences = true; seeRoomsP()">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Preferencias extras -->
                    <div v-if="(listRequeriment===null || listRequeriment.extras===null?false:true) && hideRe" class="form-element col-12 col-lg-6"
                      v-click-outside="outsidePreferentsExtra">
                      <label class="PC-text--size14" v-if="listRequeriment===null?false:true">{{listRequeriment.extras.requirementType}}</label>
                      <div class="__addIcon">
                        <span 
                          @click="habitacion1.extraPreferences = false">
                          <input type="text" class="inputTypeHabitaciones pointer" readonly :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                            v-model="habitacion1.typePreferentExtra"
                            :class="habitacion1.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''">
                        </span>
                        <div class="typeRoom card"
                          :class="habitacion1.extraPreferences ? 'oculto' : ''">
                          <div class="d-block allRooms pb-2 mb-2">
                            <input type="checkbox" name="allExtrasH1" id="allExtrasH1"
                              v-model="selectAllExtra" @click="habitacion1.extraPreferences = true"
                              @change="handleTypeExtra($event)">
                            {{extraPreferencesT}}
                          </div>
                         <div class="listado-container vb" v-bar>
                            <div>
                              <div class="d-block"
                                v-for="typeExtraPreferent in habitacion1.typeExtrasPreferents"
                                :key="typeExtraPreferent.id">
                                <input type="checkbox" v-model="habitacion1.selectedExtra"
                                  :value="typeExtraPreferent.id"
                                  @change="handleTypeSelectExtra($event, typeExtraPreferent.name)">
                                {{typeExtraPreferent.name}}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                            <p class="d-inline-block m-0 puntero"
                              @click="[selectAllExtra = false, habitacion1.typePreferentExtra = '']">
                              {{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}</p>
                            <p class="d-inline-block m-0 text-right puntero"
                              :class="[habitacion1.typePreferentExtra == '' ? 'deshabilitado' : '']"
                              @click="habitacion1.extraPreferences = true; seeRoomsE()">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                     <!-- Preferencias de piso -->
                        <div v-if="hideRe" class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment===null || listRequeriment.piso===null?false:true)">
                            <label>{{listRequeriment.piso.requirementType}}</label><br>
                            <label  class="col-6 pl-0 radio">
                              <input @click="seeFloor(listRequeriment.piso.requirementResponseList[0].requirementCode,listRequeriment.piso.requirementResponseList[0].requirementName)" type="radio" :id="listRequeriment.piso.requirementResponseList[0].requirementCode" class="hidden" :value="listRequeriment.piso.requirementResponseList[0].requirementCode" v-model="habitacion1.pickedPiso">
                              <span class="label"></span><span class="moneda">{{listRequeriment.piso.requirementResponseList[0].requirementName}}</span>
                            </label>
                            <label v-if="listRequeriment.piso.requirementResponseList.length > 1" class="col-6 pl-0 radio">
                              <input @click="seeFloor(listRequeriment.piso.requirementResponseList[1].requirementCode,listRequeriment.piso.requirementResponseList[1].requirementName)" type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode" class="hidden" :value="listRequeriment.piso.requirementResponseList[1].requirementCode" v-model="habitacion1.pickedPiso">
                              <span class="label"></span><span class="moneda">{{listRequeriment.piso.requirementResponseList[1].requirementName}}</span>
                            </label>
                          </div>
                        </div>

                        <!-- Preferencias de áreas de fumar -->
                        <div v-if="hideRe" class="form-element col-12 col-lg-6">
                          <div v-if="(listRequeriment===null || listRequeriment.fumar===null?false:true)">
                            <label>{{listRequeriment.fumar.requirementType}}</label><br>
                            <label class="col-6 pl-0 radio">
                              <input @click="seeSmoke(listRequeriment.fumar.requirementResponseList[0].requirementCode,listRequeriment.fumar.requirementResponseList[0].requirementName)" type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode" class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode" v-model="habitacion1.pickedFumar">
                              <span class="label"></span><span class="moneda">{{listRequeriment.fumar.requirementResponseList[0].requirementName}}</span>
                            </label>
                            <label v-if="listRequeriment.fumar.requirementResponseList.length > 1" class="col-6 pl-0 radio">
                              <input @click="seeSmoke(listRequeriment.fumar.requirementResponseList[1].requirementCode,listRequeriment.fumar.requirementResponseList[1].requirementName)" type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode" class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode" v-model="habitacion1.pickedFumar">
                              <span class="label"></span><span class="moneda">{{listRequeriment.fumar.requirementResponseList[1].requirementName}}</span>
                            </label>
                          </div>
                        </div>
                  </div>
                </div>
              </b-card>
            </b-card-group>

            <!-- Pago y razon social -->
            <b-card-group>
              <b-card class="remove-top-radius">
                <div class="pt-8">
                  <i class="icon-currency fix-margin font-24 pr-1"></i>
                  <h3 class="estancia PC-text--size20 d-inline">{{ $t('language.posadasCorporate.reservacionesModificar.metPagoRazonSocial') }}</h3>
                  <div class="row pt-32">
                    <div class="col-12 col-lg-12">
                      <!-- Here -->
                      <div class="metodoBody" role="tablist">
                        <!-- Voucher -->
                        <div v-if="banVaucher" class="campos voucher pb-32">
                          <p class="tituloDatos" :class="(iconoActivo == 0) ? 'camposActive' : ''"
                            @click="(iconoActivo == 0) ? iconoActivo = 100 : iconoActivo = 0; generalReset(); sendVoucher()" 
                            v-b-toggle="'voucher'"> <!--  -->
                            <i class="navi icon-radiobutton-active"
                              :class="(iconoActivo == 0) ? '' : 'oculto'"></i>
                            <i class="navi icon-radiobutto-inactive"
                              :class="(iconoActivo == 0) ? 'oculto' : ''"></i>
                            <i class="icon-voucher font-18"></i>
                            Voucher
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleVoucher" class="datos" id="voucher" accordion="my-accordion"
                            role="tabpanel">
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">{{ $t('language.posadasCorporate.reservacionesModificar.text1') }}</span>
                            </div>
                            <div class="row">

                              <!-- Folio -->
                              <div class="form-element col-12">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.numFolioCupon') }}</label>
                                <input type="text" name="" id="" v-model="vaucher.folio">
                              </div>

                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaVoucher">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}*</label>

                                <div class="contenidoSearch" @click="[vaucher.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!vaucher.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="vaucher.tipoPolitica" @click="vaucher.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListPoliticasVoucher();"
                                    v-model="vaucher.politicaSeleccionada">
                                </div>
                                <div class="card buscadorCard vb" v-if="vaucher.tipoPolitica" v-bar>
                                  <div>
                                    <div class="buscador" v-for="politica in vaucher.politicasLista"
                                      :key="politica.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValuePoliticaVoucher(politica.nombre, politica.code), vaucher.tipoPolitica = 0]"
                                        v-html="$options.filters.resalt( politica.nombre , vaucher.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonVoucher">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}*</label>
                                <div class="contenidoSearch" @click="[vaucher.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!vaucher.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="vaucher.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListRazonesVoucher()"
                                    v-model="vaucher.razonSeleccionada" readonly>
                                </div>
                                <div class="card buscadorCard vb" v-if="vaucher.tipoRazon" v-bar>
                                  <div>
                                    <div class="buscador" v-for="perfil in vaucher.razonesLista"
                                      :key="perfil.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValueRazonVoucher(perfil.nombre, perfil.razonSe), vaucher.tipoRazon = 0, businessRa = perfil.razonSe]"
                                        v-html="$options.filters.resalt( perfil.nombre , vaucher.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>
                        <hr>
                        <!-- Tarjeta de crédito -->
                        <div v-if="banTarjCred" class="campos py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 1) ? 'camposActive' : ''"
                            @click="(iconoActivo == 1) ? iconoActivo = 100 : iconoActivo = 1; generalReset(); sendCreditCard(); modalToken(1)"
                            v-b-toggle="'credito'" accordion="my-accordion" role="tabpanel"> <!-- generalReset() -->
                            <i class="navi icon-radiobutton-active"
                              :class="(iconoActivo == 1) ? '' : 'oculto'"></i>
                            <i class="navi icon-radiobutto-inactive"
                              :class="(iconoActivo == 1) ? 'oculto' : ''"></i>
                            <i class="icon-credit-card font-18"></i>
                            {{ $t('language.posadasCorporate.reservacionesModificar.tarjetaCredito') }}
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleTC" class="datos" id="credito" accordion="my-accordion"
                            role="tabpanel">
                            <div class="pt-24 pb-16">
                              <div class="PC-text--size14">
                               {{ $t('language.posadasCorporate.reservacionesModificar.text2') }}
                              </div>
                            </div>
                            <div class="row">
                               <div class="form-element col-12 col-lg-6 m-0">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.tipoTarjeta') }}*</label>
                                <div class="contenidoSearch" @click="[credito.tipoTarjeta = true]"
                                  v-click-outside="outsideCredito">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!credito.tipoTarjeta"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="credito.tipoTarjeta"
                                    @click="credito.tarjetaSeleccionada = ''"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListCredito()"
                                    v-model="credito.tarjetaSeleccionada" onlyread>
                                </div>
                                <div class="card buscadorCard vb" v-if="credito.tipoTarjeta" v-bar>
                                  <div>
                                    <div class="buscador"
                                      v-for="tipoTarjeta in credito.tarjetasLista"
                                      :key="tipoTarjeta.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaCredito(tipoTarjeta.nombre, credito.tarjetaSeleccionada), cambiarMascara(tipoTarjeta.tipoT), tipoTarjeta = 0, credito.tipoTarjeta = false]"
                                        v-html="$options.filters.resalt( tipoTarjeta.nombre , credito.tarjetaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Número de tarjeta* -->
                              <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6 mt-0">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.numeroTarjeta') }}*</label>
                                <div class="contenidoSearchCard" @click.prevent="abrirTokenizador()">
                                  <i class="search-iconsCards icon-credit-card"></i>
                                    <input type="text" class="elipseCards" v-model="credito.numero" :disabled="isDisabledTokenizador">
                                </div>
                              </div>



                              <!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS -->
                        <modal v-show="modalTokenizador" @close="cerrarTokenizador()" maxWidth="max-w-500">
                          <template slot="header">
                            <b></b>
                          </template>
                          <template slot="body">
                            <div v-html="HTMLcontent">
                            </div>
                          </template>
                          <template slot="footer">
                            <b></b>
                          </template>
                        </modal>
                              <!-- Nombre de tarjetahabiente* -->
                              <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-8">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.nombreTarjetahabiente') }}*</label>
                                <input class="mayuscula" type="text" v-onlyText v-model="credito.nombre">
                              </div>
                              <!-- Fecha de expiración* -->
                              <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-4">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.fechaExpiracion') }}*</label>
                                  <cleave
                                    :class="{ 'is-invalid': (banTarCredExp)}"
                                    v-model="fechaExpiracionTarCred" 
                                    :raw="false" 
                                    :options="options.date"
                                    placeholder="MM/AAAA">
                                  </cleave>
                                  <span class="notas" v-if="credito.expiracion.length > 0 && credito.expiracion.length < 7" >
                                    {{$t('language.posadasCorporate.paymentMethods.text41')}}
                                  </span>
                                <span v-if="banTarCredExp && credito.expiracion.length == 7 && validDateExpirationTarCred.tipoError === 2" class="notas">{{$t('language.posadasCorporate.paymentMethods.text43')}}</span>
                                <span v-if="banTarCredExp && credito.expiracion.length == 7 && validDateExpirationTarCred.tipoError === 1" class="notas">{{$t('language.posadasCorporate.paymentMethods.text44')}}</span>
                              </div>
                              <!-- Politica -->
                              <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6"  v-click-outside="outsideSearchPoliticaCredito">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}</label>

                                <div class="contenidoSearch" @click="[credito.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!credito.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="credito.tipoPolitica" @click="credito.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListPoliticasCredito()"
                                    v-model="credito.politicaSeleccionada">
                                </div>
                                <div class="card buscadorCard vb" v-if="credito.tipoPolitica" v-bar>
                                  <div>
                                    <div class="buscador" v-for="politica in credito.politicasLista"
                                      :key="politica.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValuePoliticaCredito(politica.nombre), credito.tipoPolitica = 0]"
                                        v-html="$options.filters.resalt( politica.nombre , credito.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonCredito">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}</label>
                                <div class="contenidoSearch" @click="[credito.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!credito.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="credito.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListRazonesCredito()"
                                    v-model="credito.razonSeleccionada" readonly>
                                </div>
                                <div class="card buscadorCard vb" v-if="credito.tipoRazon" v-bar>
                                  <div>
                                    <div class="buscador" v-for="perfil in credito.razonesLista"
                                      :key="perfil.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValueRazonCredito(perfil.nombre), credito.tipoRazon = 0,businessRa = perfil.razonSe]"
                                        v-html="$options.filters.resalt( perfil.nombre , credito.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <!-- Token -->
                        <div v-if="banToken" class="campos py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 2) ? 'camposActive' : ''"
                            @click="(iconoActivo == 2) ? iconoActivo = 100 : iconoActivo = 2; sendToken();generalReset(); modalToken(2)"
                            v-b-toggle="'token'" accordion="my-accordion" role="tabpanel"> <!-- generalReset() -->
                            <i class="navi icon-radiobutton-active"
                              :class="(iconoActivo == 2) ? '' : 'oculto'"></i>
                            <i class="navi icon-radiobutto-inactive"
                              :class="(iconoActivo == 2) ? 'oculto' : ''"></i>
                            <i class="icon-key font-18"></i>
                            Token
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visible" class="datos" id="token" accordion="my-accordion"
                            role="tabpanel" > <!-- visible -->
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">
                               {{ $t('language.posadasCorporate.reservacionesModificar.text3') }}
                              </span>
                            </div>
                            <div class="row">

                              <!-- Tipo de tarjeta* -->
                              <div class="form-element col-12 col-lg-6 m-0">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.tipoTarjeta') }}*</label>
                                <div class="contenidoSearch" @click="[token.tipoTarjeta = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!token.tipoTarjeta"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="token.tipoTarjeta"
                                    @click="token.tarjetaSeleccionada = ''"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListToken()"
                                    v-model="token.tarjetaSeleccionada">
                                </div>

                                <div class="card buscadorCard vb" v-if="token.tipoTarjeta" v-bar>
                                  <div>
                                    <div class="buscador" v-for="tipoTarjeta in token.tarjetasLista"
                                      :key="tipoTarjeta.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaToken(tipoTarjeta.nombre), cambiarMascara(tipoTarjeta.tipoT), tipoTarjeta = 0, token.tipoTarjeta = false]"
                                        v-html="$options.filters.resalt( tipoTarjeta.nombre , token.tarjetaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Número de tarjeta* -->
                              <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6 mt-0">
                                <label>Token</label>
                                <div class="contenidoSearchCard">
                                  <i class="search-iconsCards icon-key"></i>
                                  <input type="text" class="elipseCards" v-model="token.numero"
                                    placeholder="0000000000000000" :disabled="isDisabledTokenizador" v-uppercase v-alphanumeric maxlength="16"/>
                                </div>

                              </div>
                              <!-- Nombre de tarjetahabiente* -->
                              <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-8">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.nombreTarjetahabiente') }}*</label>
                                <input class="mayuscula" type="text" v-onlyText v-model="token.nombre">
                              </div>
                              <!-- Fecha de expiración* -->
                              <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-4">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.fechaExpiracion') }}*</label>
                                  <cleave
                                    :class="{ 'is-invalid': (banTokenExp)}"
                                    v-model="fechaExpiracionToken" 
                                    :raw="false" 
                                    :options="options.date"
                                    placeholder="MM/AAAA">
                                  </cleave>
                                  <span class="notas" v-if="token.expiracion.length > 0 && token.expiracion.length < 7" >
                                    {{$t('language.posadasCorporate.paymentMethods.text41')}}
                                  </span>
                                <span v-if="banTokenExp && token.expiracion.length == 7 && validDateExpirationToken.tipoError === 2" class="notas">{{$t('language.posadasCorporate.paymentMethods.text42')}}</span>
                                <span v-if="banTokenExp && token.expiracion.length == 7 && validDateExpirationToken.tipoError === 1" class="notas">{{$t('language.posadasCorporate.paymentMethods.text44')}}</span>
                              </div>
                              <!-- Politica -->
                              <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaToken">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}</label>

                                <div class="contenidoSearch" @click="[token.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more" v-if="!token.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer" v-if="token.tipoPolitica" @click="token.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListPoliticasToken()"
                                    v-model="token.politicaSeleccionada">
                                </div>

                                <div class="card buscadorCard vb" v-if="token.tipoPolitica" v-bar>
                                  <div>
                                    <div class="buscador" v-for="politica in token.politicasLista"
                                      :key="politica.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValuePoliticaToken(politica.nombre), token.tipoPolitica = 0]"
                                        v-html="$options.filters.resalt( politica.nombre , token.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonToken">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}</label>
                                <div class="contenidoSearch" @click="[token.tipoRazon = true]">
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListRazonesToken()"
                                    v-model="token.razonSeleccionada" readonly>
                                </div>

                                <div class="card buscadorCard vb" v-if="token.tipoRazon" v-bar>
                                  <div>
                                    <div class="buscador" v-for="perfil in token.razonesLista"
                                      :key="perfil.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValueRazonToken(perfil.nombre), token.tipoRazon = 0, businessRa = perfil.razonSe]"
                                        v-html="$options.filters.resalt( perfil.nombre , token.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <!-- Tiempo límite -->
                        <div v-if="banTiemLim" class="campos limite py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 3) ? 'camposActive' : ''"
                            @click="(iconoActivo == 3) ? iconoActivo = 100 : iconoActivo = 3;  sendTimeLimit();generalReset() "
                            v-b-toggle="'tiempoLimite'" accordion="my-accordion" role="tabpanel">
                            <i class="navi icon-radiobutton-active"
                              :class="(iconoActivo == 3) ? '' : 'oculto'"></i>
                            <i class="navi icon-radiobutto-inactive"
                              :class="(iconoActivo == 3) ? 'oculto' : ''"></i>
                            <i class="icon-time font-18"></i>
                            {{ $t('language.posadasCorporate.reservacionesModificar.tiempoLimite') }}
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleLimit" class="datos" id="tiempoLimite" accordion="my-accordion"
                            role="tabpanel">
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">
                                 {{ $t('language.posadasCorporate.reservacionesModificar.text4') }}
                              </span>
                            </div>
                            <div class="row">

                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6 mt-0" v-click-outside="outsideSearchPoliticaTiempo">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}</label>

                                <div class="contenidoSearch" @click="[tiempoLimite.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more" v-if="!tiempoLimite.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer" v-if="tiempoLimite.tipoPolitica" @click="tiempoLimite.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListPoliticasTiempo()"
                                    v-model="tiempoLimite.politicaSeleccionada">
                                </div>
                                <div class="card buscadorCard vb" v-if="tiempoLimite.tipoPolitica"
                                  v-bar>
                                  <div>
                                    <div class="buscador"
                                      v-for="politica in tiempoLimite.politicasLista"
                                      :key="politica.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValuePoliticaTiempo(politica.nombre), tiempoLimite.tipoPolitica = 0]"
                                        v-html="$options.filters.resalt( politica.nombre , tiempoLimite.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6 mt-0" v-click-outside="outsideSearchRazonTiempo">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}</label>
                                <div class="contenidoSearch"
                                  @click="[tiempoLimite.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!tiempoLimite.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="tiempoLimite.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListRazonesTiempo()"
                                    v-model="tiempoLimite.razonSeleccionada" readonly>
                                </div>
                                <div class="card buscadorCard vb" v-if="tiempoLimite.tipoRazon"
                                  v-bar>
                                  <div>
                                    <div class="buscador"
                                      v-for="perfil in tiempoLimite.razonesLista" :key="perfil.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValueRazonTiempo(perfil.nombre), tiempoLimite.tipoRazon = 0, businessRa = perfil.razonSe]"
                                        v-html="$options.filters.resalt( perfil.nombre , tiempoLimite.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <!-- Credito -->
                        <div v-if="banCredito" class="campos voucher py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 4) ? 'camposActive' : ''"
                            @click="(iconoActivo == 4) ? iconoActivo = 100 : iconoActivo = 4;sendCreditPay(); generalReset()"
                            v-b-toggle="'creditoEmpresa'">
                            <i class="navi icon-radiobutton-active"
                              :class="(iconoActivo == 4) ? '' : 'oculto'"></i>
                            <i class="navi icon-radiobutto-inactive"
                              :class="(iconoActivo == 4) ? 'oculto' : ''"></i>
                            <i class="icon-currency"></i>
                            {{ $t('language.posadasCorporate.reservacionesModificar.credito') }}
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleCredit" class="datos" id="creditoEmpresa" accordion="my-accordion"
                            role="tabpanel">
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">
                                {{ $t('language.posadasCorporate.reservacionesModificar.text5') }}
                              </span>
                            </div>
                            <div class="row">

                              <!-- Folio -->
                              <div class="form-element col-12">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.numFolioCupon') }}</label>
                                <input type="text" name="" id="" v-model="creditoEmpresa.folio">
                              </div>

                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaCreditoEmpresa">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}*</label>

                                <div class="contenidoSearch"
                                  @click="[creditoEmpresa.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!creditoEmpresa.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="creditoEmpresa.tipoPolitica" @click="creditoEmpresa.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListPoliticasCreditoEmpresa()"
                                    v-model="creditoEmpresa.politicaSeleccionada">
                                </div>

                                <div class="card buscadorCard vb" v-if="creditoEmpresa.tipoPolitica"
                                  v-bar>
                                  <div>
                                    <div class="buscador"
                                      v-for="politica in creditoEmpresa.politicasLista"
                                      :key="politica.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValuePoliticaCreditoEmpresa(politica.nombre, politica.code), creditoEmpresa.tipoPolitica = 0]"
                                        v-html="$options.filters.resalt( politica.nombre , creditoEmpresa.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonCreditoEmpresa">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}*</label>

                                <div class="contenidoSearch"
                                  @click="[creditoEmpresa.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                    v-if="!creditoEmpresa.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                    v-if="creditoEmpresa.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                    @click="filteredListRazonesCreditoEmpresa()"
                                    v-model="creditoEmpresa.razonSeleccionada" readonly>
                                </div>

                                <div class="card buscadorCard vb" v-if="creditoEmpresa.tipoRazon"
                                  v-bar>
                                  <div>
                                    <div class="buscador"
                                      v-for="perfil in creditoEmpresa.razonesLista"
                                      :key="perfil.id">
                                      <p class="mb-1 nombre"
                                        @click="[cambiaValueRazonCreditoEmpresa(perfil.nombre, perfil.code), creditoEmpresa.tipoRazon = 0, businessRa = perfil.razonSe]"
                                        v-html="$options.filters.resalt( perfil.nombre , creditoEmpresa.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <div class="row pt-4">
                       
                          <div class="col-12">
                            <div class="d-flex flex-row">
                              <input class="mt-1 mr-2" type="checkbox" v-model="aceptoAviso" @click="modalCheckbox()" :disabled="isDisabledCheckbox">
                              <span class="">
                                {{ $t('language.posadasCorporate.paymentMethods.text37') }}
                                <span class="notaAzul cursor" @click="redirecAvisoPrivacidad">{{$t('language.posadasCorporate.reservacionesRegistro.privacy')}}.</span>*
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr class="mt-4">

                      </div>
                      <!-- end here -->
                    </div>

                  </div>

                </div>

                <div>
                  <div class="row no-gutters justify-content-end pt-32 pb-40">
                    <div class="col-lg-3 col-6">
                      <span class="subtitle">{{ $t('language.posadasCorporate.generals.totalEstanciaImpuestos') }} {{numberOfNights}} {{(numberOfNights==1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches'))}}:</span>
                      <span class="notasInfoReserva mt-0 d-block PC-text--semibold"></span>
                      <span class="notasInfoReserva d-block PC-text--semibold">{{totalRooms}} {{((totalRooms==1)? ($t('language.posadasCorporate.reservacionesModificar.habitacion')) :  ($t('language.posadasCorporate.reservacionesModificar.habitaciones'))    )}}</span>
                    </div>
                    <div class="col-lg-3 col-6 text-right">
                      <br>
                      <div class="subtitle mb-0">
                        $ {{((ls.get('Profile').data.profileId.toLowerCase()=="pyp"||ls.get('Profile').data.profileId.toLowerCase()=="pypsa"||!ls.get('Profile').data.ratesPermissionsResponse.showRates)&&(tabActiveFR=="Tarifa Negociada"||tabActiveFR=="Negotiated Rate")?guiones:totalStay )   }}
                        <span class="moneda">{{currencyM}}</span>
                      </div>
                      <span class="notasInfoReserva mt-0 d-block PC-text--size12">{{ $t('language.posadasCorporate.reservacionesModificar.ivaIncluido') }}</span>
                      <a href="" class="PC-text--semibold PC-link--color PC-text--size14"
                        @click.prevent="details(1)">{{ $t('language.posadasCorporate.reservacionesModificar.verDetalle') }}</a>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-card-group>

<Loader v-if="changeLoader"/>
            <div class="row">
              <div class="col-lg-12 col-12 mb-5">
                <div class="row">
                  <div class="col-12 col-lg-6 order-2 order-lg-1">
                    <button type="button" class="mt-3 secondary-button"
                      value="Regresar" @click="goBack()">{{ $t('language.posadasCorporate.reservacionesModificar.regresar') }}</button>
                  </div>
                 
                  <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
                    
                    <button type="button" class="mt-3 button"  :disabled="isDisabled"
                      value="Guardar modificaciones" @click="changeResCon()">{{ $t('language.posadasCorporate.reservacionesModificar.guardarModificaciones') }}</button>
                  </div>
                   
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetalleCostos v-if="banDetCost" :key="componentKey"></DetalleCostos>

    <Footer />

    
<!-- INICIA MODAL ERRORES DE CODIGOS DE PROMO -->  
  <modal v-show="isModalErroresCodigos" @close="closeModalErroresCodigos" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.tooManyKids.promoError')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}<br>{{paragraph2}}
        </p>

       

      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalErroresCodigos"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.recuperarPassword.continuar')}}
         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL ERRORES DE CODIGOS DE PROMO -->

    
<!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS -->
   <modal v-show="isModalNoTarifas" @close="closeModalNoTarifas" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResults.title')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}<br><br>{{paragraph2}}
        </p>

       

      </template>
      <template slot="footer">
       
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifas"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResults.ok')}}
         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL NO PUBLICAS Y NO NEGOCIADAS -->

    <modal v-show="isModalTarifas" @close="closeModalTarifas" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.tooManyKids.finalTitle')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
{{$t('language.posadasCorporate.modales.tooManyKids.bodyNotAva')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button order-2 order-lg-1 botonesSoloadultos"
          @click="closeModalTarifas" aria-label="Close modal">
          {{$t('language.posadasCorporate.modales.tooManyKids.back')}}

        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalTarifas2()" >
          {{$t('language.posadasCorporate.modales.tooManyKids.understood')}}

        </button>
      </template>
    </modal>

    <!-- INICIA MODAL ERRORES DE CODIGOS DE PROMO -->  
    <!-- Start kb48159   --> 
  <modal v-show="modalSpecialMessage" @close="closeModalSpecialMessage" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.detalleCosto.titleSP')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{$t('language.posadasCorporate.detalleCosto.textVaceje')}}
        </p>

       

      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalSpecialMessage"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.detalleCosto.entendido')}}
         
        </button>
      </template>
    </modal>
    <!-- End kb48159--> 
<!-- TERMINA MODAL ERRORES DE CODIGOS DE PROMO -->

    <!-- Modal Modificar datos de estancia-->
    <b-modal id="modificarDatos" footer-class="extra-light" hide-header hide-footer>
      <p class="text-right">
        <button class="PC-btn--closeModal" @click="$bvModal.hide('modificarDatos')">
          <i class="icon-Cerrar icon-close-rounded-outline"></i>
        </button>
      </p>
      <p class="PC-text--size18 PC-text--bold">{{ $t('language.posadasCorporate.reservacionesModificar.modificarDatosEstancia') }}</p>
      <div role="tablist">
        <b-card class="mb-1 PC-card--collapsible">
          <b-card-body>
            <div class="w-100 align-top">
              <div class="w-100 align-top">
                <div class="row">

                  <div class="col-12 mb-4">
                    <div class="form-element">
                      <label>{{ $t('language.posadasCorporate.reservacionesModificar.modificarDatosDeEstancia.fechas') }}</label>
                      <div class="d-block">
                        <div>
                          <div class="entradaInput position-relative d-inline-block w-50">
                            <i class="calendarIcon demo-icon icon-calendar position-absolute"
                              v-if="entrada.length < 1"></i>
                            <i class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute"
                              v-else @click="[entrada = '',salida = '']"></i>
                            <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="es"
                               :clearable="false"
                               :not-before="minDate" :not-after="salidaGrupo" :placeholder="dateTextIn" format="DD/MM/YYYY" v-if="tryingAgain == 'es'">
                            </datepicker>
                              <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="en"
                               :clearable="false"
                               :not-before="minDate" :not-after="salidaGrupo"  :placeholder="dateTextIn" format="MM/DD/YYYY" v-if="tryingAgain == 'en'">
                            </datepicker>
                
                          </div>
                          <div class="entradaInput position-relative d-inline-block w-50">
                            <i class="calendarIcon demo-icon icon-calendar position-absolute"
                              v-if="salida.length < 1"></i>
                            <i class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute"
                              v-else @click="salida = ''"></i>
                            <datepicker class="w-100 fechaSalida" v-model="salida" lang="es"
                              :clearable="false" :placeholder="dateTextOut" format="DD/MM/YYYY"
                              :not-before="minblockDate" :not-after="salidaGrupo" :disabled="!entrada" :special-days="entrada" v-if="tryingAgain == 'es'"></datepicker>

                               <datepicker class="w-100 fechaSalida" v-model="salida" lang="en"
                              :clearable="false" :placeholder="dateTextOut" format="MM/DD/YYYY"
                              :not-before="minblockDate" :not-after="salidaGrupo" :disabled="!entrada" :special-days="entrada" v-if="tryingAgain == 'en'"></datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mb-4">
                    <div class="form-element mt-0">
                      <label>{{ $t('language.posadasCorporate.reservacionesModificar.modificarDatosDeEstancia.habitaciones') }}</label>
                      <div class="d-block" v-click-outside="outsideRoom">
                         <!-- v-if="device == 'desktop'" -->
                          <span v-if="device == 'desktop'" @click="room = false">
                            <div class="__iconRoom entrada">
                            <input class="inputHabitaciones "
                              :class="room == false ? 'inputHabitacionesLeft' : ''" type="text"
                              placeholder="1" v-model="habitaciones" readonly="readonly">
                          </div>
                          <div class="__iconUser salida">
                            <input class="inputHabitaciones"
                              :class="room == false ? 'inputHabitacionesRight' : ''" type="text"
                              v-model="personas" placeholder="1" readonly="readonly">
                          </div>
                        </span> 
                        
                        <span v-else v-on:click="openRooms()">
                             <div class="__iconRoom entrada">
                            <input class="inputHabitaciones "
                              :class="room == false ? 'inputHabitacionesLeft' : ''" type="text"
                              placeholder="1" v-model="habitaciones" readonly="readonly">
                          </div>
                          <div class="__iconUser salida">
                            <input class="inputHabitaciones"
                              :class="room == false ? 'inputHabitacionesRight' : ''" type="text"
                              v-model="personas" placeholder="1" readonly="readonly">
                          </div>
                        </span>

                        <div class="room card" :class="room ? 'oculto' : ''" style="width: 60%">
                      
                      
                          <div
                            class="d-flex justify-content-between align-items-center row huesped-item">
                            <div class="d-inline-block col-12 col-sm-6">
                              <p class="m-0">{{ $t('language.posadasCorporate.reservacionesModificar.adultos2') }}</p>
                              <p class="notas m-0"> </p> <!-- A partir de 18 años -->
                            </div>
                            <div
                              class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0 select-none">
                              <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                                @click="[(adultos > 1) ? adultos-- : adultos, sumPersonas]">-</span>
                              <span
                                class="px-4 px-sm-3 py-2 p-sm-1 bordecito cursor-default">{{adultos}}</span>
                              <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                                @click="[(adultos < maxAdultsAllowed) ? adultos++ : adultos, sumPersonas]">+</span>
                            </div>
                          </div>

            <div v-if="ouiLesG == true && ouiLesF == false" class="d-block d-flex justify-content-between align-items-center row mb-2 huesped-item" >
              <div class="d-inline-block col-12 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0 select-none">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                  @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito cursor-default">{{menores}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                  @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
              </div>
            </div>

            
            <div v-if="ouiLesG == true && ouiLesF == true" class="d-block d-flex justify-content-between align-items-center row mb-2 huesped-item">
              <div class="d-inline-block col-12 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 5 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0 select-none">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                  @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito default">{{menores}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                  @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
              </div>
            </div>

            <div v-if="ouiLesF" class="d-block d-flex justify-content-between align-items-center row mb-2 huesped-item">
              <div class="d-inline-block col-12 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.infantes') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 4 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="d-inline-block col-12 col-sm-6 text-sm-right  my-3 my-sm-0 select-none">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                  @click="[(infantes > 0) ? infantes-- : infantes, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito cursor-default">{{infantes}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito pointer"
                  @click="[(infantes < 2) ? infantes++ : infantes, sumPersonas]">+</span>
              </div>
            </div>

                          <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                            <p class="d-inline-block m-0 puntero"
                              @click="[resetPersons, room = true]">
                              {{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}</p>
                            <p class="d-inline-block m-0 text-right puntero" @click="[room = true]">
                              {{ $t('language.posadasCorporate.sidebarTop.aplicar') }}
                            </p>
                          </div> 
                        </div>
                      </div>
                    </div> 
                  </div>

                  <div class="col-12">
                    <label  v-if="showDiscountCode2" class="PC-text--semibold w-100 mb-4">
                      {{ $t('language.posadasCorporate.reservacionesModificar.codigoDescuento') }}
                      <input class="form-control mayuscula" :value="descuento" @input="updateValueCodigo" v-on:keyup="validateCode" :disabled="getDiscountOff" type="text" v-uppercase>
                    </label>

                   
                    <label v-if="showPromoCode2" class="PC-text--semibold w-100 mb-4">
                      {{ $t('language.posadasCorporate.sidebarTop.promocion') }}
                      <input v-on:keyup="validateCode"  class="form-control mayuscula" :disabled="getPromoOff" type="text" :value="promocion" @input="updateValuePromocion" v-uppercase>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
                                    <Loader v-if="enableLoader"/>

      <div class="row">
        <div class="col-12 col-md-6 mt-2">
          <button class="secondary-button" @click="$bvModal.hide('modificarDatos')">
            {{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}
          </button>
        </div>
        <div class="col-12 col-md-6 mt-2">
          <button @click="changeRes();  enableLoader = true">{{ $t('language.posadasCorporate.reservacionesModificar.modificarDatosDeEstancia.modificar') }}</button>
        </div>
      </div>

      <!-- MOBILE -->
 <!-- Panel mobile Rooms -->
    <div v-if="device == 'mobile'" class="section-full" v-bind:class="{'section-full--open' : showRoomsMobile }">
      <div class="section-full__header">
        <button v-on:click="showRoomsMobile = false"><span class="icon-close"></span></button>
      </div>
      <div class="section-full__body">
        <div style="padding: 15px;">

          <div class="room">
            <div class="d-flex justify-content-between align-items-center row">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.reservacionesModificar.adultos2') }}</p>
                <p class="notas m-0"></p> <!-- A partir de 18 años -->
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(adultos > 1) ? adultos-- : adultos, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{adultos}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(adultos < maxAdultsAllowed) ? adultos++ : adultos, sumPersonas]">+</span>
              </div>
            </div>


            <div v-if="ouiLesG == true && ouiLesF == false" class="d-block d-flex justify-content-between align-items-center row mb-2">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{menores}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
              </div>
            </div>



            <div v-if="ouiLesG == true && ouiLesF == true" class="d-block d-flex justify-content-between align-items-center row mb-2">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.menores') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 5 {{ $t('language.posadasCorporate.sidebarTop.to') }} 12 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores > 0) ? menores-- : menores, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{menores}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(menores < 2) ? menores++ : menores, sumPersonas]">+</span>
              </div>
            </div> 


               <div  v-if="ouiLesF" class="d-block d-flex justify-content-between align-items-center row mb-2">
              <div class="d-inline-block col-6 col-sm-6">
                <p class="m-0">{{ $t('language.posadasCorporate.sidebarTop.infantes') }}</p>
                <p class="notas m-0">{{ $t('language.posadasCorporate.sidebarTop.from') }} 0 {{ $t('language.posadasCorporate.sidebarTop.to') }} 4 {{ $t('language.posadasCorporate.sidebarTop.yearsOld') }}</p>
              </div>
              <div class="col-6 col-sm-6 flex-end  my-3 my-sm-0">
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(infantes > 0) ? infantes-- : infantes, sumPersonas]">-</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito">{{infantes}}</span>
                <span class="px-4 px-sm-3 py-2 p-sm-1 bordecito"
                  @click="[(infantes < 2) ? infantes++ : infantes, sumPersonas]">+</span>
              </div>
            </div> 




          </div>
        </div>
      </div>
      <div class="section-full__footer">
        <button class="" v-on:click="aplicarRooms()">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</button>
        <button class="secondary-button"
          v-on:click="[showRoomsMobile = false, resetPersons, room = true]">{{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}</button>
      </div>
    </div>
      <!-- MOBILE -->
    </b-modal>
    <!--  -->
    
    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.modales.expiredSession.title') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{ $t('language.posadasCorporate.modales.expiredSession.body') }}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary"
          @click="closeExpiredModal"
          aria-label="Close modal"
        >{{ $t('language.posadasCorporate.modales.expiredSession.button') }}</button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

     <modal v-show="banModalTokenInexistente" @close="banModalTokenInexistente = false" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.title')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{$t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.body')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="primary-button" @click="banModalTokenInexistente = false" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.button')}}
        </button>
      </template>
    </modal>

    <modal v-show="isModalVisibleUsarToken" @close="closeModalToken" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{modalTokenCredito.title}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{modalTokenCredito.body}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="closeModalToken" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.no')}}
        </button>
        <button type="button" class="primary-button" @click="modalTokenCreditYes()" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.si')}}
        </button>
      </template>
    </modal>

        <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{modalTokenCreditoSaveUpdate.title}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{modalTokenCreditoSaveUpdate.body}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="modalSaveUpdate(2)" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.noGuardar')}}
        </button>
        <button type="button" class="primary-button" @click="modalSaveUpdate(1)" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.guardar')}}
        </button>
      </template>
    </modal>

    
                           <!-- Extra kids -->   
                               <modal v-show="isModalMayorInfantes" @close="closeModalMayorInfantes" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.tooManyKids.forKids')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{$t('language.posadasCorporate.modales.tooManyKids.body')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button order-2 order-lg-1 botonesSoloadultos" @click="closeModalMayorInfantes" aria-label="Close modal">
          {{$t('language.posadasCorporate.recuperarPassword.cancelar')}}
       
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalMayorInfantes"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.recuperarPassword.continuar')}}
         
        </button>
      </template>
    </modal>
<!-- Extra kids -->

<!-- INICIA MODAL NO DISPO EN ROOMS DE GRUPO : TARIFAS GRUPALES-->
<modal v-show="isModalNoTarifasGrpRooms" @close="closeModalNoTarifasGrpRooms2" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResultsRoomGpo.title')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{paragraph1}}{{roomCodesNotAvail}}{{paragraph2}}
        </p>
      </template>
      <template slot="footer">   
        <button type="button" class="secondary-button order-2 order-lg-1 botonesSoloadultos" @click="closeModalNoTarifasGrpRooms2" aria-label="Close modal">
          {{$t('language.posadasCorporate.recuperarPassword.cancelar')}}
       
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifasGrpRooms"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResultsRoomGpo.ok')}}         
        </button>
      </template>
    </modal>
    <!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS DIAS -->
<modal v-show="isModalNoTarifasDias" @close="closeModalNoTarifasDias" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResults.title')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}<br><br>{{roomCodesNotAvail}}<br><br>{{paragraph2}}
        </p>

       

      </template>
      <template slot="footer">
       
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifasDias"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResults.ok')}}
         
        </button>
      </template>
    </modal>
<!-- TERMINA MODAL NO PUBLICAS Y NO NEGOCIADAS -->

<!-- TERMINA MODAL NO DISPO EN ROOMS DE GRUPO --> 
    <modal v-show="banNewModal" @close="closeModalNew" maxWidth="max-w-500">
      <template slot="header">
        <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.reservacionesModificar.modalError.error') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalNewBody }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModalNew"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.reservacionesModificar.modalError.entendido') }}
        </button>
      </template>
    </modal>

    <modal v-show="banNewModal" @close="closeModalNew" maxWidth="max-w-500">
      <template slot="header">
        <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.reservacionesModificar.modalError.error') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalNewBody }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModalNew"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.reservacionesModificar.modalError.entendido') }}
        </button>
      </template>
    </modal>

    <modal v-if="modalCaution" @close="modalCaution = false" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.pasConfirmation.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalCautionBody }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="modalCaution = false"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.pasConfirmation.button') }}
        </button>
      </template>
    </modal>

    <modal v-if="banError6" @close="error6Modal" maxWidth="max-w-500">
    <template slot="header">
      <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.pasConfirmation.title') }}</b>
    </template>
    <template slot="body">
      <p class="Ta-left">
        {{ error6Body }}
      </p>
    </template>
    <template slot="footer">

      <button type="button" class="button btn-primary" @click="error6Modal"
              aria-label="Close modal">
        {{ $t('language.posadasCorporate.modales.pasConfirmation.button') }}
      </button>
    </template>
  </modal>

  </div>
</template>

<script>
  import * as GlobalServices from '../../../utils/GlobalServices';
  import * as GlobalFunctions from '../../../utils/GlobalFunctions';

  import Header from "../../generales/Header.vue";
  import Footer from "../../generales/Footer.vue";
  import axios from 'axios';
  import i18n from '../../../plugins/i18n';
  import Loader from '../../loader/Loader';
  import Modal from '../../addons/Modal.vue'
  import DetalleCostos from '../DetalleCostos';
  import Cleave from 'vue-cleave-component';
  import SecureLS from 'secure-ls';
  import moment from 'moment'
  import Datepicker from 'vue2-datepicker';
  export default {
    name: "ReservacionesModificacion",
    components: {
      Header,
      Footer,
      Loader,
      Datepicker,
      Modal,
      DetalleCostos,
      Cleave
    },
    data: () => {
      return {
        isModalNoTarifasDias: false,
        isModalNoTarifasGrpRooms: false,//Tarifas grupales
        availableRoomCodes: [],//Tarifas grupales
        groupRoomCodes: [],//Tarifas grupales
        groupRoomCodesNotAvail: [],//Tarifas grupales
        roomCodesNotAvail: '',//Tarifas grupales
        groupRoomsInfo: [], //Tarifas grupales
        roomListings: '',
        groupBool:'',
        salidaGrupo: '',
        emailAlternative: "",
        banError6: false,
        error6Body: '',
        modalCaution: false,
        modalCautionBody: '',
        isUserGeneric: false,
        politicasList: [],
        banSelectedPoliticaVaucher: false,
        banSelectedPoliticaCredito: false,
        banSelectedPoliticaToken: false,
        banSelectedPoliticaCreditoEmpresa: false,
        banSelectedPoliticaTiempoLimite: false,
        tipoClienteID: '',
        pyp: 'PYP', //no cambiar este valor
        pypsa: 'PYPSA', //no cambiar este valor
        tipoTarifa: 0,
        validRegex: /^[a-zA-Z\\1-9\\0]*$/,
        telephoneType: "",
        guiones: "------",
        tabActiveFR: "",
        modalNewBody: '',
        banNewModal: false,
        validDateExpirationTarCred: null,
        validDateExpirationToken: null,
        banConsiEspe: false,
        considEspe: '',
        mandaSuple: false,
        descriptionMS: "",
        listRequeOpcionalesE: [],
        specialMess: "",
        desTe: "",
        banLoaderFR: false,
        banMemFR: false,
        infoFR: null,
        enableRewards: false,
        banDetCost: false,
        showRoomsMobile: false,
        contPoliticaSelectedDefault: 0,
        banPoliticaSelectedDefault: false,
        contRazonSelectedDefault: 0,
        banRazonSelectedDefault: false,
        dCou: 0,
        curC: "",
        textPromo: "", 
        arrivalCDate: "",
        departureCDate: "",
        enableProfGH: false,
        //banGuardaToken: false,
        businessRa: "",
        montreModal: null,
        datosHabHotModalCosto: {
        habitacion: null,
        hotel: null,
        localStor: null,
        userClientID: false,
        tabActive: null
      },
        banMetodosPagos: false,
        banBan: false,
        contBanBan: 0,
        sumPersonas: 0,
        hideRe: false,
        isModalMayorInfantes: false,
        overwheminlyTooManyKids: false,
        banTarCredExp: false,
        goBackC: false,
        banIsTokenGuardado: false,
        fechaExpiracionTarCred: '',
        fechaExpiracionToken: '',
        banTokenExp: false,
        options: {
          date: {
            date: true,
            datePattern: ['m', 'Y'],
            delimiter: '/',
          },
        },
        banModalTokenInexistente: false,
        banTokenInexistente: false,
        dataCard: '',
        dataTokenExist: null,
        modalTokenCredito: {
          title: null,
          body: null,
          modalNumberToken: null,
          lugar: null
        },
        saveOrUpdate: '',
        isModalVisibleUsarToken: false,
        isModalVisible: false,
        modalTokenCreditoSaveUpdate: {
          title: null,
          body: null
        },
        hotelReservationByCode: null,
            componentKey: 0,

          politicas: {
        listPoliticas: null,
        privacyPolicyURL: null,
      },
        data1: {
        isCreditPayment: false,
        isTimeLimitPayment: false,
        isTokenPayment: false,
        isCreditCardPayment: false,
        isVoucherPayment: false,
roomType: null,   // NOT USED
selectedRooms: null,
brandCode: null,
hotelName: null,
beautiDateInput: null,
beautiDateOutput: null,
              hotelCode: null,
              arrivalDate: null,
              departureDate: null,
              currencyCode: null,
              totalAdults: null,
              totalChildren: null,
              totalInfants: null,
              totalRooms: null,
              agreementCode: null,
              iataCode: null,
              motivaCode: null,
              discountCode: null,
              promoCode: null,
              profileType: null,
              showPublicRates: null,
              showRates: null,
              contractCode: null,
              roomCodeList:null
  
        },
        ben: null,
        rem: null,
        roomContractTypeNameW: "",
          data : {
          confirmationNumber: "",
          profileType: "",
          hasEditCancelPermissions: true,
          fullReservationData: true
        },
        tabActive: 1,
        fatherSurname: "",
        motherSurname: "",
        middleName: "",
        responseHotel : {
              response: null
            },
        changeLoader: false,
        initialLoader: false,
        seeTextSmoke: "",
        seeTextFloor: "",
        mergeUpdate: false,
        arraySmoke: [],
        arrayFloors: [],
        totalPreferencesRoomsWS: [],
        address: "",
        address2: "",
        country: "",
        state: "",
        jobPhoneNumber: "",
        posCode: "",
        textPref: "",
        telephone22: "",
        totalPrefTexto: [],
        totalPreferences: [],
        employeeNumber: "",
realName: "",
fatherSurname: "",
motherSurname: "",
        costCenter: "",
companionMotherSurname: "",
companionFatherSurname: "",
        acompananteFirstName: "",
        guestProfileId: "",
        ratesResponse: {},
        hotelImage: "",
        isCreditCard: 0,
hotelName: "",
roomCode: "",
roomImage: "",
roomName: "",
        brandName: "",
        hotelFax: "",
        hotelAddress: "",
        brandImage: "",
        rateDescription: "",
        restrictionsFWS: "",
        emailAlter: "",
        bene: "",
        payMe: "",
        numConfirWS: "",
        briefD: "",
        amenityListWS: [],
        listRequeriment: null,
        requirementsByCode: null,
        lackingAgreement: "",
        lackingIata: "",
        getDiscount: false,
        urlTokenizado: '',
        HTMLcontent: "",
        modalTokenizador: false,
        roomContractCode: "",
        banVaucher : false,
        banTarjCred : false,
        banToken : false,
        banTiemLim : false,
        banCredito : false,
        clearHomeCounter: 0,
visible: false,
visibleVoucher: false,
visibleTC: false,
visibleLimit: false,
visibleCredit: false,
        IATAL: "IATA*",
        IATAObliga: false,
        IATANeeded: false,
           getAgreementCodeOff: false,
          getDiscountOff: false,
            getIataOff: false,
            getMotivaOff: false,
            getPromoOff: false,
        isModalErroresCodigos: false,
        modalSpecialMessage: false,
        isModalNoTarifas: false,
        paragraph1: "",
        paragraph2: "",
        enableLoader: false,
        isModalTarifas: false,
        contractCodes: [],
        specialMessageUp: false,
        responseSpecialMessageForDiscounts: "",
        gettingSpecialMessagePasP: '',
        roomCode: "",
        showDiscountCode2: false,
        showIATA2: false,
        showMotiva2: false,
        showPromoCode2: false,
        showAgreement2: false, 
        ouiLesF: false,
        ouiLesG: false,
        maxAdultsAllowed: 0,
        hotelCode: "",
        beautyDateInput: "",
        beautyDateOutput: "",
        couponNumber: "",
        motivaWS: "",
        contractTypeForPol: 0,
        maxRoomsAllowed: 5,
        extraPreferencesT : "Todas las preferencias extras",
        allRoomTypesT: "Todas las preferencias de habitación",
        totalTaxes: 0,
        totalCostWithoutTaxes: 0,
        currencyM: "MXN",
        totalStay: 0,
      //  roomName: "",
        hotelName: "",
        arrivalDate: "",
        departureDate: "",
        numberOfNights: 1,
        totalRooms: 1,
        totalAdults: 1,
        totalChildren: 1,
        totalInfants: 1,
        totalGuests: 1,
        codDiscount: "----",
        name: "",
        fiestaRewardsNumber: "",
        apreciareClubNumber: "",
        noConfirmation: "",
        isExpiredModalVisible: false,
        ls: new SecureLS({ encodingType: "aes" }),
        device: 'desktop',
        // Calendario
        entrada: '',
        salida: '',
        todayDate: new Date(),
        //tipo de habitacion
        tipoHabitacion: '',
        rooms: true,
        typeRooms: [{
            'id': '1',
            'checked': true,
            'name': 'Junior suite ocean front'
          },
          {
            'id': '2',
            'checked': true,
            'name': 'Junior suite ocean front Grand Club'
          },
          {
            'id': '3',
            'checked': true,
            'name': 'Junior suite ocean view'
          },
          {
            'id': '4',
            'checked': true,
            'name': 'Master suite ocean front'
          },
          {
            'id': '5',
            'checked': true,
            'name': 'Master suite ocean front Grand Club'
          },
          {
            'id': '6',
            'checked': true,
            'name': 'Suite governador'
          },
          {
            'id': '7',
            'checked': true,
            'name': 'Suite presidencial'
          },
        ],
        selected: [],
        selectedModal: [],
        //Habitaciones
        room: true,
        habitaciones: 1,
        personas: 1,
        adultos: 1,
        menores: 0,
        infantes: 0,
        ninos: 0,
        // codigo
        descuento: null,
        promocion: null,
        iata: null,
        agreementCode: null,
        motiva: null,
        habitacion1: {
          //Activador de Icono
          iconoHabitacion: 0,
          iconoActivo: 0,
          // Datos
          datosPersonales: true,
          datosContacto: true,
          datosAcompanante: true,
          datosProforma: true,
          datosRequerimientos: true,
          // buscador
          buscador: false,
          search: '',
          perfiles: [{
              'nombre': 'Pedro Zambrano Manager'
            },
            {
              'nombre': 'Ángel Lorenzo'
            },
            {
              'nombre': 'Nelly Almendarez'
            },
            {
              'nombre': 'Jorge Luna'
            },
            {
              'nombre': 'Alejandro Nava'
            },
            {
              'nombre': 'Grissel Calderón'
            },
            {
              'nombre': 'Diego Ramos'
            },
            {
              'nombre': 'Adrian Compagny'
            },
            {
              'nombre': 'Arturo Reyes'
            },
            {
              'nombre': 'Darth Vader'
            },
          ],
          perfilesLista: '',
          // Titulo
          titulo: false,
          tituloDado: '',
          titulos: [{
              'nombre': 'Sr.'
            },
            {
              'nombre': 'Sra.'
            },
            {
              'nombre': 'Srita.'
            },
          ],
          titulosLista: '',
          // Nombre
          nombres: '',
          apellidoP: '',
          apellidoM: '',
          // Numeros
          numEmp: '',
          numFiesta: '',
          numApreciare: '',
          numCentro: '',
          numTelefonico: '',
          // tipos de telefono
          pickedTelelefono: "",
          // tipos de direccion
          pickedDireccion: "",
          // tipos de Propocitos
          pickedPropositos: "",
          // tipos de Piso
          pickedPiso: "",
          // Área de fumar
          pickedFumar: "",
          // Contacto
          mailContacto: '',
          mailContactoConfirmacion: '',
          //paises
          pais: false,
          paisSeleccionado: '',
          paises: [{
              'nombre': 'México'
            },
            {
              'nombre': 'EEUU'
            },
            {
              'nombre': 'Canada'
            },
            {
              'nombre': 'Colombia'
            },
            {
              'nombre': 'España'
            },
          ],
          paisesLista: '',
          //estados
          estado: false,
          estadoSeleccionado: '',
          estados: [{
              'nombre': 'Estado de México'
            },
            {
              'nombre': 'Aguascalientes'
            },
            {
              'nombre': 'Baja California'
            },
            {
              'nombre': 'Baja California Sur'
            },
            {
              'nombre': 'Campeche'
            },
          ],
          estadosLista: '',
          //hora entrada
          horaIn: false,
          horaInSeleccionado: '',
          horasIn: [{
              'nombre': '10:00'
            },
            {
              'nombre': '11:00'
            },
            {
              'nombre': '12:00'
            },
            {
              'nombre': '13:00'
            },
            {
              'nombre': '14:00'
            },
          ],
          horasInLista: '',
          //hora de salida
          horaOut: false,
          horaOutSeleccionado: '',
          horasOut: [{
              'nombre': '10:00'
            },
            {
              'nombre': '11:00'
            },
            {
              'nombre': '12:00'
            },
            {
              'nombre': '13:00'
            },
            {
              'nombre': '14:00'
            },
          ],
          horasOutLista: '',
          // Requerimientos
          //tipo de preferencia
          typePreferent: 'Ver preferencias de habitación seleccionadas',
          roomPreferences: true,
          typeRoomsPreferents: [
          ],
          selected: [],
          showRoomTypeMobile: false,
          //tipo de preferencia extra
          typePreferentExtra: 'Ver preferencias extras seleccionadas',
          extraPreferences: true,
          typeExtrasPreferents: [
              
          ],
          selectedExtra: [],
          showExtraTypeMobile: false,
        },
        formulario1: {
          huesped: '',
          contacto: '',
          acompanante: '',
          proforma: '',
          requerimientos: '',
        },
        formulario2: {
          personales: '',
          contacto: '',
        },
        // 
        // Metodo de pago 
        //
        iconoActivo: 0,
        vaucher: {
          folio: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicaSeleccionadaCode: '',
          politicas: [{
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razonSeleccionadaCode: '',
          razones: [{
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        credito: {
          //tarjetas
          tipoTarjeta: false,
          tarjetaSeleccionada: '',
          tarjetas: [{
              'nombre': 'American Express',
              'tipoT': 1
            },
            {
              'nombre': 'Dinners Club',
              'tipoT': 2
            },
            {
              'nombre': 'Masterd Card',
              'tipoT': 3
            },
            {
              'nombre': 'Visa',
              'tipoT': 4
            },
          ],
          tarjetasLista: '',
          tipoDeMascara: '',
          numero: '',
          nombre: '',
          expiracion: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicas: [{
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razones: [{
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        token: {
          //tarjetas
          tipoTarjeta: false,
          tarjetaSeleccionada: '',
          tarjetas: [
          ],
          tarjetasLista: '',
          numero: '',
          nombre: '',
          expiracion: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicas: [,
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razones: [
          ],
          razonesLista: '',
        },
        tiempoLimite: {
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicas: [{
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razones: [{
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        creditoEmpresa: {
          folio: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicaSeleccionadaCode: '',
          politicas: [],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razonSeleccionadaCode: '',
          razones: [],
          razonesLista: '',
        },
        savedData: {},
        showDateMobile: false,
        aceptoAviso: false
      }
    },
    created() {
      
      var grupoInfoLs = this.ls.get('InfoGrupo')
      this.InfoGrupo = grupoInfoLs.data
     
      var groupInfo = '';
      groupInfo = this.InfoGrupo;
      
      if(groupInfo === undefined || groupInfo === '' ){
        this.groupBool = false;
        
      }
      else{
        this.groupBool = true;
      }
      this.isUserGeneric = this.ls.get('isUserGeneric').data;
      this.tipoClienteID = this.ls.get('ClientId').data;
      this.ls.set('supplDeta', false)
if(this.ls.get('Language').data == "en") {
              this.habitacion1.typePreferentExtra =  'See selected extra preferences';
            this.habitacion1.typePreferent =  'See selected room types';
                         this.allRoomTypesT = "All room types"
          this.extraPreferencesT = "All extra preferences"

}

     // Calling ByCode to populate component  
      this.noConfirmation = this.ls.get('noConForRm')
      this.callByCode(this.ls.get('noConForRm'))

      // ByCode is complete
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth);
        this.getWindowWidth();
      });
   this.sessionHome()
      if(this.ls.get('Profile').data.profileId == "POSADAS") {
        this.showDiscountCode2 = true
        this.showPromoCode2 = true

      } else {
        this.showDiscountCode2 = false
        this.showPromoCode2 = false

      }
     this.goBackC = this.ls.get('knowOrigin')
     if(this.groupBool){
     this.salidaGrupo = this.removeTimezoneFromDate(groupInfo.checkOut);
     }
    
    },
    methods: {
      removeTimezoneFromDate(originalDateString) {
      const originalDate = new Date(originalDateString);
      
      // Convert to local string without timezone information
      const dateWithoutTimezone = originalDate.toLocaleString('en-US', { timeZone: 'UTC' });

      return new Date(dateWithoutTimezone);
    },
      error6Modal(){
        this.banError6 = false;
        this.$router.push({ name: 'Reservaciones'});
      },
      filteredPolilticas() {
        switch (this.iconoActivo) {
          case 0:
            //vaucher
            return this.vaucher.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.vaucher.politicaSeleccionada.toLowerCase())
            });
            break;
          case 1:
            //credito
            return this.credito.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.credito.politicaSeleccionada.toLowerCase())
            });
            break;
          case 2:
            //token
            return this.token.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.token.politicaSeleccionada.toLowerCase())
            });
            break;
          case 3:
            //tiempo limite
            return this.tiempoLimite.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.tiempoLimite.politicaSeleccionada.toLowerCase())
            });
            break;
          case 4:
            //credito empresa
            return this.creditoEmpresa.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.creditoEmpresa.politicaSeleccionada.toLowerCase())
            });
            break;
        }
      },
      redirecAvisoPrivacidad(){
        (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
      },
      closeModalNoTarifas() {
        this.groupRoomCodesNotAvail = [];
        this.isModalNoTarifas = false;
        this.enableLoader = false;
        const pathname = window.location.pathname;
        
        if(pathname.length > 1)
        {
          console.log(this.$router.push({ name: "Reservaciones" }))
        }
      },
      closeModalNoTarifasDias() {
        this.groupRoomCodesNotAvail = [];
        this.isModalNoTarifasDias = false;
        this.enableLoader = false;
        const pathname = window.location.pathname;
        
        if(pathname.length > 1)
        {
          console.log(this.$router.push({ name: "Reservaciones" }))
        }
      },
      closeModalNoTarifasGrpRooms() {//Tarifas grupales
        this.isModalNoTarifasGrpRooms = false
        this.groupRoomCodesNotAvail = []
        this.codeDetailing()
        this.enableLoader = false;
        
      },
      closeModalNoTarifasGrpRooms2() {//Tarifas grupales
        this.isModalNoTarifasGrpRooms = false
        
        this.enableLoader = false;
        const pathname = window.location.pathname;
        
        if(pathname.length > 1)
        {
          console.log(this.$router.push({ name: "Reservaciones" }))
        }
      },
      closeModalTarifas2() {
        this.isModalTarifas = false
          this.codeDetailing()          
      },
      closeModalNew(){
        this.banNewModal = false;
        setTimeout(() => {
          this.$router.push({ name: 'Reservaciones'});
        }, 100);
      },
      chargeModalConfir(resObject) {
 this.componentKey += 1;
      var availibilityRequest = {
        totalRooms:   resObject.data.response.totalRooms,
        currencyCode:  resObject.data.response.currencyCode,
        beautiDateOutput: resObject.data.response.departureDate,
        beautiDateInput: resObject.data.response.arrivalDate

      }
      this.datosHabHotModalCosto.localStor = "datosHabHotSelected";
      this.datosHabHotModalCosto.hotel =     {

        benefitsRestrictions:  resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0],
        negotiatedRatesDetailPrice: {
        averageRatePerNight: resObject.data.response.ratesResponse.averageCostPerNight,
        nights: resObject.data.response.numberOfNights,
        rateType: resObject.data.response.roomContractTypeName,
        ratesDetailResponses: resObject.data.response.ratesResponse.ratesDetailResponseList,
        subTotalRateTaxes: resObject.data.response.ratesResponse.totalCostWithoutTaxes,
        totalRateWithTaxes: resObject.data.response.ratesResponse.totalCost,
        totalRateWithoutTaxes: resObject.data.response.ratesResponse.totalCostWithoutTaxes,
        totalSupplement: resObject.data.response.ratesResponse.totalSupplements,
        totalTaxes: resObject.data.response.ratesResponse.totalTaxesWithSupplements,
        totalCostWithoutTaxesWihtSupplements: resObject.data.response.ratesResponse.totalCostWithoutTaxes
        },
        nights: resObject.data.response.numberOfNights,

      }



      this.datosHabHotModalCosto.userClientID = this.ls.get('ClientId').data;


      if (resObject.data.response.roomContractTypeName == "Tarifa Negociada" || resObject.data.response.roomContractTypeName == "Negotiated Rate") {
        this.datosHabHotModalCosto.whichRates = "Negociadas";
        this.datosHabHotModalCosto.tabActive = 1
      }
      if (resObject.data.response.roomContractTypeName == "Tarifa Pública" || resObject.data.response.roomContractTypeName == "Public Rate") {
        this.datosHabHotModalCosto.whichRates = "Publicas";
        this.datosHabHotModalCosto.tabActive = 2
      }
      if (
        this.$store.getters.gettingLang == "es" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Public Rate"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Tarifa Pública";
      }
      if (
        this.$store.getters.gettingLang == "en" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Tarifa Pública"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Public Rate";
      }

      if (
        this.$store.getters.gettingLang == "es" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Negotiated Rate"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Tarifa Negociada";
      }
      if (
        this.$store.getters.gettingLang == "en" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Tarifa Negociada"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Negotiated Rate";
      }

      this.datosHabHotModalCosto.habitacion = availibilityRequest;
      this.ls.set("updateCostDetail", { data: this.datosHabHotModalCosto });
      },
      consultFiestaRewards() {
        this.enableRewards = false;
        this.banMemFR = false;
        var longRewards = this.fiestaRewardsNumber + '';
        if (longRewards.length >= 7) {
          this.banLoaderFR = true;
          var a = "";
          a = this.ls.get("Token");
          var token = a.data.substr(1);
          const lang = this.ls.get('Language').data;
          axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_REWARDSF + `${this.fiestaRewardsNumber}`,
            {
              withCredentials: true,
              credentials: "include",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
                "Accept-language": this.ls.get("Language").data
              }
            }
          )
          .then(response => {
            if (response.data.response.fiestaRewardsCode === 'FR' || response.data.response.fiestaRewardsCode === 'FRC') {
              this.srcImageFRCard = (lang==='es'?1:2);
            }
            if (response.data.response.fiestaRewardsCode === 'VRO') {
              this.srcImageFRCard = (lang==='es'?3:4);
            }
            if (response.data.response.fiestaRewardsCode === 'VRP') {
              this.srcImageFRCard = (lang==='es'?5:6);
            }
            if (response.data.response.fiestaRewardsCode === 'FRB') {
              this.srcImageFRCard = (lang==='es'?7:8);
            }
            if (response.data.response.fiestaRewardsCode === 'FRO') {
              this.srcImageFRCard = (lang==='es'?9:10);
            }
            this.infoFR = response.data.response;
            this.enableRewards = false;
            this.banLoaderFR = false;
            setTimeout(() => {
              this.banMemFR = true;
            }, 10);
          })
          .catch(error => {
            this.enableRewards = true;
            this.banLoaderFR = false;
                       // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          });
        }
      },
       openRooms() {
        this.showRoomsMobile = true;
      },
      aplicarRooms() {
        this.showRoomsMobile = false;
      },
      banban(){
        if (this.banBan && this.banMetodosPagos) {
          this.modalToken(3);
        } else{
          if (this.contBanBan <= 5) {
            this.contBanBan ++;
            setTimeout(() => {
              this.banban();
            }, 5000);
          }
        }
      },
       tooManyKids() {
      this.isModalMayorInfantes = true
    },
         // menores
      closeModalMayorInfantes() {
              this.overwheminlyTooManyKids = true
        this.isModalMayorInfantes = false;
      },
      goBack() {
        if(this.goBackC) {

          this.$router.push({ name:'Reservaciones'})
        } else {

          this.$router.push({ name:'MovimientosDia'})
        }
      },
      modalToken(lugar){
        if (!this.isUserGeneric && this.dataTokenExist != null) {
          if (this.hotelReservationByCode.paymentResponse.creditCard != null &&this.hotelReservationByCode.paymentResponse.creditCard.cardNumber === this.dataTokenExist.guaranteeNumber || this.dataTokenExist.guaranteeNumber === '') {
            this.banIsTokenGuardado = true;
          } else {
            this.banIsTokenGuardado = false;
          }
          /** lugar
           * 1: tarjeta credito
           * 2: token
           */
          this.modalTokenCredito.lugar = lugar;
          if (this.dataTokenExist.guaranteeNumber !== '' && (this.iconoActivo === 1 || this.iconoActivo === 2)) {
  
            if (this.dataTokenExist != null && this.dataTokenExist != '' && this.dataTokenExist != undefined && this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType) === undefined) {
              this.banModalTokenInexistente = true;
              this.banTokenInexistente = true;
            } else {
              if (lugar === 1 || lugar === 3) {
                this.modalTokenCredito.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.tarjetaGuardado');
                this.modalTokenCredito.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text2') + ' ' + this.dataTokenExist.guaranteeNumber.substring(0, this.dataTokenExist.guaranteeNumber.length - 4).replace(/./g,"*") + ' ' + this.dataTokenExist.guaranteeNumber.substring(this.dataTokenExist.guaranteeNumber.length - 4) + '?';
                this.modalTokenCredito.modalNumberToken = this.dataTokenExist.guaranteeNumber;
              }
              if (lugar === 2 || lugar === 4) {
                this.modalTokenCredito.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.tokenGuardado');
                this.modalTokenCredito.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text1') + ' ' + this.dataTokenExist.guaranteeNumber.substring(0, this.dataTokenExist.guaranteeNumber.length - 4).replace(/./g,"*") + ' ' + this.dataTokenExist.guaranteeNumber.substring(this.dataTokenExist.guaranteeNumber.length - 4) + '?';
                this.modalTokenCredito.modalNumberToken = this.dataTokenExist.guaranteeNumber;
              }
              if (lugar === 1 || lugar === 2) {
                this.banIsTokenGuardado = true;
                this.isModalVisibleUsarToken = true;
              }
            }
          }
        }
      },
      modalSaveUpdate(lugar){
        if (lugar === 1) {
          if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 3 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber !== '') {
            this.saveOrUpdate = 'UPDATE';
          }
          if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 3 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber === '') {
            this.saveOrUpdate = 'SAVE';
          }
        }
        if (lugar === 2) {
          this.saveOrUpdate = '';
        }

        this.closeModal();
      },
      mostrarTipoTarjetaAutocompleteToken(buscar){
        if (this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) {
          return this.credito.tarjetas.find( lista => lista.code === buscar );
        }
        if (this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) {
          return this.token.tarjetas.find( lista => lista.code === buscar );
        }

      },
      closeModalToken() {
        this.isModalVisibleUsarToken = false;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      modalTokenCreditYes(){
        if (this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) {
         //tarjeta de credito
         this.credito.tarjetaSeleccionada = this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType).nombre; //guaranteeType
         this.cardTypeForService = this.dataTokenExist.guaranteeType;
         this.credito.tipoDeMascara = this.dataTokenExist.guaranteeNumber;
         this.credito.numero = this.dataTokenExist.guaranteeNumber;
         this.credito.nombre = this.dataTokenExist.holderName;
         this.credito.expiracion = this.dataTokenExist.expirationDate.replace('/','');
         this.fechaExpiracionTarCred = this.dataTokenExist.expirationDate.replace('/','');
        }
        if (this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) {
          //token
         this.token.tarjetaSeleccionada = this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType).nombre; //guaranteeType
         this.tokenCreditCardType = this.dataTokenExist.guaranteeType;
         this.token.numero = this.dataTokenExist.guaranteeNumber;
         this.token.nombre = this.dataTokenExist.holderName;
         this.token.expiracion = this.dataTokenExist.expirationDate.replace('/','');
         this.fechaExpiracionToken = this.dataTokenExist.expirationDate.replace('/','');
        }
        this.closeModalToken();
      },
      modalCheckbox(){
        if (!this.isUserGeneric && this.dataTokenExist != null) {
          var ban = false;
          if (this.hotelReservationByCode.guestID === '' || this.hotelReservationByCode.guestID === null || this.hotelReservationByCode.guestID === 0) {
            ban = false;
          } else {
            ban = true; 
          }
          var tipoTar = '';
          for (let i = 0; i < this.credito.tarjetas.length; i++) {
            if (this.credito.tarjetas[i].code === this.dataTokenExist.guaranteeType) {
              tipoTar = this.credito.tarjetas[i].nombre
            }
          }
  
          var tipoTok = '';
          for (let ii = 0; ii < this.token.tarjetas.length; ii++) {
            if (this.token.tarjetas[ii].code === this.dataTokenExist.guaranteeType) {
              tipoTok = this.token.tarjetas[ii].nombre
            }
          }        
            if (!this.getBrowserForCheckbox(this.aceptoAviso) && (this.iconoActivo === 1 || this.iconoActivo === 2)
              && ((this.iconoActivo === 1 && (this.dataTokenExist.guaranteeNumber !== this.credito.numero || this.dataTokenExist.expirationDate !== this.credito.expiracion ||  this.dataTokenExist.holderName.toUpperCase() !== this.credito.nombre.toUpperCase() || tipoTar !== this.credito.tarjetaSeleccionada))
              || (this.iconoActivo === 2 && (this.dataTokenExist.guaranteeNumber !== this.token.numero || this.dataTokenExist.expirationDate !== this.token.expiracion ||  this.dataTokenExist.holderName.toUpperCase() !== this.token.nombre.toUpperCase() || tipoTok !== this.token.tarjetaSeleccionada)))
              && !(!ban && this.dataTokenExist.guaranteeNumber == '') && !this.banTokenInexistente && this.banIsTokenGuardado ) {
    
              if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) && this.dataTokenExist.guaranteeNumber !== '') {
                this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.actualizarTarjetaCredito');
                this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text4');
              }
              if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) && this.dataTokenExist.guaranteeNumber === '') {
                this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.guardadoTarjeta');
                this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text3');
              }
    
              if ((this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber !== '') {
                this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.actualizarToken');
                this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text6');
              }
              if ((this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber === '') {
                this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.guardadoToken');
                this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text5');
              }
              this.isModalVisible = true;
            }
        }
      },
      getBrowserForCheckbox(boleano){
        var navegador = GlobalFunctions.getBrowserInfo().toLowerCase();
        if (navegador.search('ie') > -1 || navegador.search('edge') > -1) {
          return !boleano;
        } else {
          return boleano;
        }
        
      },
      
    settingSuppl(resObject) {
// Deeper
this.ls.set('generalUp', true)
var toS = 0
var toIm = 0
for(var i=0; i < resObject.data.response.rateOptionalSupplementResponseList.length; i++) {
    toS += resObject.data.response.rateOptionalSupplementResponseList[i].amount
    for(var j = 0; j < resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList.length; j++) {
            if(resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                toIm += resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxAmount

            }}
}
this.ls.set('generalSuppl', toS)
this.ls.set('generalSupplIm', toIm)

var extraSupE = 0
var extraSupIE = 0
var extraToSE = 0 

var extraSupEFirstNight = 0
var extraSupIEFirstNight = 0
var extraToSEFirstNight = 0 
var ob = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
 var ob2 = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', ob2)
       
        this.ls.set('supleCondi', ob)
        

if(resObject.data.response.numberOfNights != null && resObject.data.response.numberOfNights != "") {

    var numNuits = resObject.data.response.numberOfNights
} else {
    var numNuits = 1
}
if(resObject.data.response.rateOptionalSupplementResponseList != null && resObject.data.response.rateOptionalSupplementResponseList.length != 0) {
var suplObject = resObject.data.response.rateOptionalSupplementResponseList
for(var i=0; i < suplObject.length; i++) {
switch(suplObject[i].quantityType) {
    case 5:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        break;

    case 3:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;
        
        
     case 1:  case 7:  // type 6 must be
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
    case 8:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
        case 2: case 6:
        extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
        
            break;

        case 4:
                 extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
        
    default:
        break;
} 

}
}

    },
      details(lugar) {
 var resObject =  this.montreModal
// Set data
  if(resObject.data.response.rateOptionalSupplementResponseList != null && resObject.data.response.rateOptionalSupplementResponseList.length != 0 && resObject.data.response.rateOptionalSupplementResponseList.length != "") {

        this.settingSuppl(resObject)
        
      }
 this.componentKey += 1;
      var availibilityRequest = {
        totalRooms:   resObject.data.response.totalRooms,
        currencyCode:  resObject.data.response.currencyCode,
        beautiDateOutput: resObject.data.response.departureDate,
        beautiDateInput: resObject.data.response.arrivalDate

      }
      this.datosHabHotModalCosto.localStor = "datosHabHotSelected";
      this.datosHabHotModalCosto.hotel =     {

        benefitsRestrictions:  resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0],
        negotiatedRatesDetailPrice: {
        averageRatePerNight: resObject.data.response.ratesResponse.averageCostPerNight,
        nights: resObject.data.response.numberOfNights,
        rateType: resObject.data.response.roomContractTypeName,
        ratesDetailResponses: resObject.data.response.ratesResponse.ratesDetailResponseList,
        subTotalRateTaxes: resObject.data.response.ratesResponse.totalCostWithoutTaxes,
        totalRateWithTaxes: resObject.data.response.ratesResponse.totalCost,
        totalRateWithoutTaxes: resObject.data.response.ratesResponse.totalCostWithoutTaxes,
        totalSupplement: resObject.data.response.ratesResponse.totalSupplements,
        totalTaxes: resObject.data.response.ratesResponse.totalTaxesWithSupplements
        },
        nights: resObject.data.response.numberOfNights,

      }



      this.datosHabHotModalCosto.userClientID = this.ls.get('ClientId').data;


      if (resObject.data.response.roomContractTypeName == "Tarifa Negociada" || resObject.data.response.roomContractTypeName == "Negotiated Rate") {
        this.datosHabHotModalCosto.whichRates = "Negociadas";
        this.datosHabHotModalCosto.tabActive = 1
      }
      if (resObject.data.response.roomContractTypeName == "Tarifa Pública" || resObject.data.response.roomContractTypeName == "Public Rate") {
        this.datosHabHotModalCosto.whichRates = "Publicas";
        this.datosHabHotModalCosto.tabActive = 2
      }
      if (
        this.$store.getters.gettingLang == "es" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Public Rate"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Tarifa Pública";
      }
      if (
        this.$store.getters.gettingLang == "en" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Tarifa Pública"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Public Rate";
      }

      if (
        this.$store.getters.gettingLang == "es" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Negotiated Rate"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Tarifa Negociada";
      }
      if (
        this.$store.getters.gettingLang == "en" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Tarifa Negociada"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Negotiated Rate";
      }

      this.datosHabHotModalCosto.habitacion = availibilityRequest;
     this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.totalCostWithoutTaxesWihtSupplements = resObject.data.response.ratesResponse.totalCostWithoutTaxes//WihtSupplements

      this.ls.set("updateCostDetail", { data: this.datosHabHotModalCosto }); // TEST
      this.banDetCost = true;

        if (lugar == 1) {
          setTimeout(() => {
            this.$bvModal.show('detalleDeCosto1');
          }, 5);
        }
      },
         sendVoucher() {
        this.isVoucherPayment = true

        this.isCreditCardPayment = false

        this.isTokenPayment = false

        this.isTimeLimitPayment = false

        this.isCreditPayment = false
      },
      sendCreditCard() {
        this.isVoucherPayment = false

        this.isCreditCardPayment = true

        this.isTokenPayment = false

        this.isTimeLimitPayment = false

        this.isCreditPayment = false
      },
      sendToken() {
        this.isVoucherPayment = false

        this.isCreditCardPayment = false

        this.isTokenPayment = true

        this.isTimeLimitPayment = false

        this.isCreditPayment = false
      },
      sendTimeLimit() {
        this.isVoucherPayment = false

        this.isCreditCardPayment = false

        this.isTokenPayment = false

        this.isTimeLimitPayment = true

        this.isCreditPayment = false
      },
      sendCreditPay() {
        this.isVoucherPayment = false

        this.isCreditCardPayment = false

        this.isTokenPayment = false

        this.isTimeLimitPayment = false

        this.isCreditPayment = true
      },
   
       setDataPersonalH1: function(){
        let ls = new SecureLS({encodingType: 'aes'});
        let dataPersonalH1 = {};
        dataPersonalH1.simpleName = this.realName;
        dataPersonalH1.fatherSurname = this.fatherSurname;
        dataPersonalH1.motherSurname = this.motherSurname;
        dataPersonalH1.agentNumber = "";  // Manquant de donnée
       
        if (this.banMemFR) {
          dataPersonalH1.rewardsNumber = this.fiestaRewardsNumber.toUpperCase();
        } else{
          dataPersonalH1.rewardsNumber = '';
        }
        
        dataPersonalH1.apreciation = this.apreciareClubNumber;
        dataPersonalH1.costCenter = this.costCenter.toUpperCase();


        ls.set('dataPersonalH1', dataPersonalH1);
      },
      seeFloor(code, name) {
          this.seeTextFloor = name
              if(this.totalPreferences.includes(this.arrayFloors[0].requirementCode || this.arrayFloors[1].requirementCode)) {

                  for(var i = 0; i <this.totalPreferences.length; i++) {
                    if(this.totalPreferences[i] ==this.arrayFloors[0].requirementCode || this.totalPreferences[i] ==this.arrayFloors[1].requirementCode) {

                      delete this.totalPreferences[i];
                    }

                  }
                  this.totalPreferences.push(code)
                var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.totalPreferences = a 
              } else {

                 for(var i = 0; i <this.totalPreferences.length; i++) {
                    if(this.totalPreferences[i] ==this.arrayFloors[0].requirementCode || this.totalPreferences[i] ==this.arrayFloors[1].requirementCode) {

                      delete this.totalPreferences[i];
                    }

                  }
               
                  this.totalPreferences.push(code)
                      var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.totalPreferences = a 
              }

                 var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.totalPreferences = a
      },
      seeSmoke(code, name) {
          this.seeTextSmoke= name
                if(this.totalPreferences.includes(this.arraySmoke[0].requirementCode || this.arraySmoke[1].requirementCode)) {
                  for(var i = 0; i <this.totalPreferences.length; i++) {
                    if(this.totalPreferences[i] ==this.arraySmoke[0].requirementCode || this.totalPreferences[i] ==this.arraySmoke[1].requirementCode) {

                      delete this.totalPreferences[i];
                    }
                  }
                  this.totalPreferences.push(code)
                   var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.totalPreferences = a 
               } else {

                    for(var i = 0; i <this.totalPreferences.length; i++) {
                    if(this.totalPreferences[i] ==this.arraySmoke[0].requirementCode || this.totalPreferences[i] ==this.arraySmoke[1].requirementCode) {

                      delete this.totalPreferences[i];
                    }
                  }
               
                
                  this.totalPreferences.push(code)
      var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.totalPreferences = a
                }     

                
                 var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.totalPreferences = a
      },
      seeRoomsP() {
        if(this.selectAll && this.$store.getters.gettingLang == 'es') {
             this.habitacion1.typePreferent = 'Todas las preferencias de habitación'
        }
         if(this.selectAll && this.$store.getters.gettingLang == 'en') {
         this.habitacion1.typePreferent = 'All room types'
        }


        this.mergeUpdate = true
this.totalPreferencesRoomsWS = []
          for(var i = 0; i < this.habitacion1.selected.length; i++) {
                for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
                  if(this.habitacion1.selected[i] == this.habitacion1.typeRoomsPreferents[ii].id) {
                      this.totalPreferencesRoomsWS.push(this.habitacion1.typeRoomsPreferents[ii].code)
                  }
                }  
           }      
      var a =    this.totalPreferencesRoomsWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.totalPreferencesRoomsWS = a
      },
         seeRoomsE() {
        this.mergeUpdate = true
        
if(this.selectAllExtra && this.$store.getters.gettingLang == 'es') {
             this.habitacion1.typePreferentExtra =  'Todas las preferencias extras'
        }
         if(this.selectAll && this.$store.getters.gettingLang == 'en') {
         this.habitacion1.typePreferentExtra = 'All extra preferences';
        }
this.totalPreferencesEWS = []
          for(var i = 0; i < this.habitacion1.selectedExtra.length; i++) {
                for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
                  if(this.habitacion1.selectedExtra[i] == this.habitacion1.typeExtrasPreferents[ii].id) {
                      this.totalPreferencesEWS.push(this.habitacion1.typeExtrasPreferents[ii].code)
                  }
                }  
           }      
      var b =    this.totalPreferencesEWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.totalPreferencesEWS = b
      },
      guestProfile() {
        var a = '';
        a = this.ls.get('Token');
        var token = a.data.substr(1);
        var language = this.ls.get('Language');
        if(this.guestProfileId == null) {
          this.guestProfileId = ""
        }
        
       axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_GUESTDETAIL, {
          guestProfileId:  this.guestProfileId,
          fiestaRewardsNumber: this.fiestaRewardsNumber
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ token,
            'Content-Type' : 'application/json',
            'Accept-Language': language.data,
          }
        })
        .then(res => {
          // GET MISSING DATA
          this.dataCard = res.data.response;
          this.dataTokenExist =  res.data.response.cardInfoResponse;
          this.ls.set('hotelDetailModd', res.data.response.cardInfoResponse);

this.banban();
          this.address = res.data.response.cardInfoResponse.street1
           if(this.address == null) {
            this.address = ""
          }
          this.address2 = res.data.response.cardInfoResponse.street2
           if(this.address2 == null) {
            this.address2 = ""
          }
          this.country = res.data.response.cardInfoResponse.countryCode
          if(this.country == null) {
            this.country = ""
          }
          this.state = res.data.response.cardInfoResponse.stateCode
          if(this.state == null) {
            this.state = ""
          }

          //  PHONE

           if(res.data.response.phone != null && res.data.response.phone.length != 0 ) {
             for(let i = 0; i < res.data.response.phone.length; i++) {
               if (res.data.response.phone[i].number != null && res.data.response.phone[i].number != undefined) {
                  this.telephoneType = res.data.response.phone[i].type;
                  this.jobPhoneNumber = res.data.response.phone[i].number;
                }
              }
            }


        //  this.jobPhoneNumber   = res.data.response.phone.phoneNumber
        })
        .catch(error=>{
          // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
        })
      },
      changeResCon() {
        this.setDataPersonalH1()
        if (!this.banMemFR) {
          this.fiestaRewardsNumber = '';
        }

        this.changeLoader = true
        var policieId = ""
        var razonKey = '';

        if (this.iconoActivo === 0) {
          for(var i = 0; i < this.vaucher.politicas.length; i++) {
              if(this.vaucher.politicaSeleccionada == this.vaucher.politicas[i].nombre) {
                policieId = this.vaucher.politicas[i].code
              } 
          }

          for(var i = 0; i < this.vaucher.razones.length; i++) {
            if(this.vaucher.razones[i].nombre == this.vaucher.razonSeleccionada) {
              razonKey = this.vaucher.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 1) {
          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(this.credito.politicaSeleccionada == this.credito.politicas[i].nombre) {
              policieId = this.credito.politicas[i].code
            } 
          }

          for(var i = 0; i < this.credito.razones.length; i++) {
            if(this.credito.razones[i].nombre == this.credito.razonSeleccionada) {
              razonKey = this.credito.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 2) {
          for(var i = 0; i < this.token.politicas.length; i++) {
            if(this.token.politicaSeleccionada == this.token.politicas[i].nombre) {
              policieId = this.token.politicas[i].code
            } 
          }

          for(var i = 0; i < this.token.razones.length; i++) {
            if(this.token.razones[i].nombre == this.token.razonSeleccionada) {
              razonKey = this.token.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 3) {
          for(var i = 0; i < this.tiempoLimite.politicas.length; i++) {
            if(this.tiempoLimite.politicaSeleccionada == this.tiempoLimite.politicas[i].nombre) {
              policieId = this.tiempoLimite.politicas[i].code
            } 
          }

          for(var i = 0; i < this.tiempoLimite.razones.length; i++) {
            if(this.tiempoLimite.razones[i].nombre == this.tiempoLimite.razonSeleccionada) {
              razonKey = this.tiempoLimite.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 4) {
          for(var i = 0; i < this.creditoEmpresa.politicas.length; i++) {
            if(this.creditoEmpresa.politicaSeleccionada == this.creditoEmpresa.politicas[i].nombre) {
              policieId = this.creditoEmpresa.politicas[i].code
            } 
          }

          for(var i = 0; i < this.creditoEmpresa.razones.length; i++) {
            if(this.creditoEmpresa.razones[i].nombre == this.creditoEmpresa.razonSeleccionada) {
              razonKey = this.creditoEmpresa.razones[i].code
            }
          }
        }
        if(this.mergeUpdate) {

      var a = this.totalPreferencesRoomsWS.concat(this.totalPreferencesEWS)
      a.push(this.habitacion1.pickedFumar)
      a.push(this.habitacion1.pickedPiso)
      this.totalPreferences = a
      var textWS = []
      textWS.push(this.seeTextFloor)
      textWS.push(this.seeTextSmoke)
       for(var i = 0; i < a.length; i++) {
       for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
        if(a[i] == this.habitacion1.typeRoomsPreferents[ii].code) {
            textWS.push(this.habitacion1.typeRoomsPreferents[ii].name)
        }
      } 
      }
       for(var i = 0; i < a.length; i++) {
       for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
        if(a[i] == this.habitacion1.typeExtrasPreferents[ii].code) {
            textWS.push(this.habitacion1.typeExtrasPreferents[ii].name)
        }
      } 
      }
       var aO =  textWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.textPref = aO.join(", ");
       this.ls.set('preTe', this.textPref)
      }

        // Getting profile
        var ls = new SecureLS({encodingType: 'aes'});
      if(String(ls.get('Profile').data.parentUsername) == "null" || String(ls.get('Profile').data.parentUsername) == "undefined") {
  var parendId22 = ''
} else {
  var parendId22 = String(ls.get('Profile').data.parentUsername)
}

if(this.jobPhoneNumber == null) {
  this.jobPhoneNumber = ""
}
if(this.emailAlter != null|| this.emailAlter.length != 0) {
 var a = this.emailAlter[0]
 this.emailAlter = a
}
 if(this.guestProfileId == null) {
          this.guestProfileId = ""
        }
       
    var  profileRequest22 = [
        {
     acompananteEmail: "",
     acompananteFirstName: this.acompananteFirstName.toUpperCase(),
     acompananteLastName: this.companionFatherSurname.toUpperCase(), 
     acompananteMaternalLastName: this.companionMotherSurname.toUpperCase(),  
     address: this.address,
     address2: this.address2, 
     addressType: "",
     codigoPostal: this.posCode,
     costCenter: this.costCenter, 
     country: this.country,
     emailProfile: this.emailAlter, 
     email: this.emailAlter,
     emailAlter: this.emailAlternative,
     excellencePin: this.apreciareClubNumber,  
     fiestaRewardsNumber: this.fiestaRewardsNumber.toUpperCase(), 
     firstName: this.realName, 
     guardar: false, 
     guestProfileId: this.guestProfileId, 
   
     jobPhoneExt: "52",  
     jobPhoneNumber: this.jobPhoneNumber, 
     lastName: this.fatherSurname.toUpperCase(),
     middleName: "",
     numberEmpl:  this.employeeNumber, 
     parendId: parendId22,
     preferencias: this.totalPreferences, 
     preferenciasTexto: this.textPref, 
     profileId: String(ls.get('Profile').data.profileId),
     profileType: String(ls.get('Profile').data.profileType),
     secondLastName: this.motherSurname,
     showPublicRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:ls.get('Profile').data.ratesPermissionsResponse.showPublicRates),
     showRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:ls.get('Profile').data.ratesPermissionsResponse.showRates),
     state: this.state,
     suplementos: "",  
     suplements: [  ], 
     telephoneType: this.telephoneType,
     userId: String(ls.get('userIdForReservationRequest').data)
        }
      ] 

        // Getting profile
if(this.descuento == null) {
  this.descuento = ""
}
if(this.promocion == null) {
  this.promocion = ""
}
        
        if(this.bene == null) {
          this.bene = ""
        }
 if(this.guestProfileId == null) {
          this.guestProfileId = ""
        }

        var holdersName = '';
        var str = '';
        var month = '';
        var year = '';
        var payCode = '';
        var tkn= '';
        var payCode = ""
        
        if (this.iconoActivo === 1) {
          holdersName = this.credito.nombre;
          str = this.credito.expiracion;
          month = this.credito.expiracion.substring(0, 2);
          year = this.credito.expiracion.substring(3,7);
          tkn = this.credito.numero;
          for(var i = 0; i < this.credito.tarjetas.length; i++) {
            if(this.credito.tarjetas[i].nombre == this.credito.tarjetaSeleccionada) {
                  payCode = this.credito.tarjetas[i].code
            }
          }
        }
        if (this.iconoActivo === 2) {
          holdersName = this.token.nombre;
          str = this.token.expiracion;
          month = this.token.expiracion.substring(0, 2);
          year = this.token.expiracion.substring(3,7);
          tkn = this.token.numero;
          for(var i = 0; i < this.token.tarjetas.length; i++) {
            if(this.token.tarjetas[i].nombre == this.token.tarjetaSeleccionada) {
                  payCode = this.token.tarjetas[i].code;
            }
          }
        }
       
       if(this.iconoActivo == 1 || this.iconoActivo == 2) {
var cardValidationW = true
       } else {
var cardValidationW = false
       }
var vaoucherOrCredEmpresa = (this.iconoActivo===0?this.vaucher.folio:this.iconoActivo===4?this.creditoEmpresa.folio:'')

      // this.vaucher.folio = "test"
        var reservationRequest = {

  creditCard: {
    cardHoldersName: holdersName.toUpperCase(),
    expirationMonth: month,  
    expirationYear: year,
    paymentCardType: payCode,
    token: tkn,      
    cardValidation: String(cardValidationW),
    tokenAction: this.saveOrUpdate     
  },
  datos: {
    amenityList: this.amenityListWS,  
    arriveTime: "",
    beneficios: this.bene,  
    briefDescription: this.briefD,
    centralId: this.numConfirWS,        
    checkInDate: this.arrivalDate,
    checkOutDate: this.departureDate,
    commentType: "GRL",  
    confirmationInfants: "Infantes", 
    contractCode: this.roomContractCode,
    contractType: this.contractTypeForPol,
    cuponCXC: vaoucherOrCredEmpresa, 
    cuponCxCDesc: "", 
    currencyCode: this.currencyM,
    descuento: this.descuento, 
    iata: this.lackingIata,
    infants: "0",
    language: this.$store.getters.gettingLang,
    leaveTime: "", 
    nights: this.numberOfNights,
    numberAdults: String(this.adultos),
    numberChildren: String(this.menores),
    numberRooms: String(this.habitaciones),
    paymentMethod: this.payMe,  
    paymentType: "0", 
    pif: this.motivaWS,
    policieId: (policieId==='-1'?'':policieId),
    policieText: this.rateDescription,
    promoCode: this.promocion,
    reservDetailVOConfirm: "",
    restricciones: this.restrictionsFWS,
    sendCopyTo: this.emailAlter,
    sendProformGranted: this.enableProfGH,
    tradeName: (razonKey==='-1'?'':razonKey),
    yieldType: "",
   sendSpecialConsiderations: this.banConsiEspe
  },
  hotel: {
    brandCode: this.brandCode,
    brandImage: this.brandImage,
    brandName: this.brandName, 
    hotelAddress: this.hotelAddress,
    hotelCode: this.hotelCode,
    hotelFax: this.hotelFax,
    hotelImage: this.hotelImage, 
    hotelName: this.hotelName,
    hotelPhone: this.telephone22,
    hotelurl: "", 
    roomCode: this.roomCode,
    roomImage: this.roomImage,
    roomName: this.roomName,
  },
  isCreditCard: String(this.isCreditCard), 
  profile: profileRequest22,
  profileIdUser: this.guestProfileId,
   userId: String(ls.get('userIdForReservationRequest').data),
     profileId: String(ls.get('Profile').data.profileId),
  rates: this.ratesResponse
         
   }


this.rem = reservationRequest.rates.ratesDetailResponseList
if(this.rem[0].rateMandatorySupplementResponseList == null) {
  this.rem[0].rateMandatorySupplementResponseList = []
}
     var responseSup = {
                supplementMandatoryResponseList: this.rem[0].rateMandatorySupplementResponseList,
                supplementNotMandatoryResponseList: []
              }
              this.ls.set('supplement', {data:responseSup});
   // Eliminar null en rates
  
   if(reservationRequest.rates.ratesDetailResponseList[0].originalContract == null) {

     reservationRequest.rates.ratesDetailResponseList[0].originalContract = ""
   }

    if(reservationRequest.rates.ratesDetailResponseList[0].originalCurrency == null) {

     reservationRequest.rates.ratesDetailResponseList[0].originalCurrency = ""
   }
     if(reservationRequest.rates.ratesDetailResponseList[0].levelCode == null) {

     reservationRequest.rates.ratesDetailResponseList[0].levelCode = ""
   }
     if(reservationRequest.rates.ratesDetailResponseList[0].exchangeCurrency == null) {

     reservationRequest.rates.ratesDetailResponseList[0].exchangeCurrency = ""
   }
     if(reservationRequest.rates.ratesDetailResponseList[0].commissionResponse == null) {

     reservationRequest.rates.ratesDetailResponseList[0].commissionResponse = {}
   }
   if(reservationRequest.rates.ratesDetailResponseList[0].ratesTaxesList == null) {

     reservationRequest.rates.ratesDetailResponseList[0].ratesTaxesList = []
   }
    if(reservationRequest.rates.ratesDetailResponseList[0].rateMandatorySupplementResponseList == null) {

     reservationRequest.rates.ratesDetailResponseList[0].rateMandatorySupplementResponseList = []
   }

   // Eliminar null en rates
reservationRequest.updateRate = false
   
if(this.iconoActivo == 0) {
          reservationRequest.datos.paymentMethod = 'VO'
        }

        if(this.iconoActivo == 1 ) {
          reservationRequest.datos.paymentMethod = 'CC'
        }
        if(this.iconoActivo == 2) {
          reservationRequest.datos.paymentMethod = 'TK'
        }

         if(this.iconoActivo == 3) {
          reservationRequest.datos.paymentMethod = 'DP'
        }

        //  Starting limit time for reservation request
        if(this.iconoActivo == 4) {
          reservationRequest.datos.paymentMethod = 'CXC'
        }

        var a = '';
        a = this.ls.get('Token');
        var token = a.data.substr(1);
        var language = this.ls.get('Language');
        ls.set("reservationRequestEdition", reservationRequest)
        ls.set('requirementsDataH1', reservationRequest.profile[0].preferenciasTexto)
        ls.set('fixA', true)
      var updNeg = []
      for(var i = 0; i < reservationRequest.profile.length; i++) {
      reservationRequest.profile[i].profileId = []
      reservationRequest.profile[i].profileId.push(String(ls.get('Profile').data.profileId))
      if(reservationRequest.datos.descuento != '') {
      reservationRequest.profile[i].profileId.push(reservationRequest.datos.descuento)
      }
      var a =    reservationRequest.profile[i].profileId.filter(function(item, pos) {
          return reservationRequest.profile[i].profileId.indexOf(item) == pos;
      })
      reservationRequest.profile[i].profileId = a

      }

// Setting motiva
if(this.motivaWS != "" && this.motivaWS != null) {
reservationRequest.datos.pif = this.motivaWS
}

do {
  let index = reservationRequest.profile[0].preferencias.indexOf("");
if (index > -1) {
 reservationRequest.profile[0].preferencias.splice(index, 1);
}
}
while (reservationRequest.profile[0].preferencias.includes(""));

// Supplements
if(this.listRequeOpcionalesE != null && this.listRequeOpcionalesE != "") {
    reservationRequest.rateOptionalSupplementResponseList = this.listRequeOpcionalesE
} else {
    reservationRequest.rateOptionalSupplementResponseList = []
}
this.ls.set("opSuE", this.listRequeOpcionalesE)
// Supplements
if(reservationRequest.profile[0].preferencias.includes(null)) {
  var filtered = reservationRequest.profile[0].preferencias.filter(function (el) {
  return el != null;
});
reservationRequest.profile[0].preferencias = filtered
}


        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RESERVATION , reservationRequest
          , {
            withCredentials: true,
            credentials: 'include',
            headers: {'Authorization': 'Bearer ' + token,
              'Content-Type' : 'application/json',
              'Accept-Language' : language.data
            }
          })

        .then(res => {
            this.changeLoader = false
          if(((res.status == 200 || res.status == 201) && res.data.code == "RSP_HOTEL_RESERV_00") && (res.data.response[0].numReservation == 0 || res.data.response[0].numReservation == "0" || res.data.response[0].numReservation == null || res.data.response[0].numReservation == []) ) {
           
          } if((res.status == 200 || res.status == 201) && res.data.code == "RSP_HOTEL_RESERV_00") {

             var ls = new SecureLS({encodingType: 'aes'});
             ls.set('responseReservation', {data: res.data.response})
           
 var politicas = {
        listPoliticas: [],
        privacyPolicyURL: "",
      }

// Call policies
                const profileW = this.ls.get('Profile').data;
var dailyRate = this.ls.get('dailyRate');
                var totalRate = this.ls.get('totalCostWithTaxesF');

    let bodyRatePolicy = {
        hotelCode:this.hotelCode,
                    arrivalDate:this.arrivalDate,
                    departureDate:this.departureDate,
                    contractCode:this.roomContractCode,
                    contractType: this.contractTypeForPol,
                    currencyCode:this.currencyM,
                    showRates: profileW.ratesPermissionsResponse.showRates,
                    showPublicRates: profileW.ratesPermissionsResponse.showPublicRates,
                    hasCombinedRate: false,
                    dailyRate: dailyRate,
                    totalRate:Number(totalRate)
      };
  GlobalServices._consultaPoliticasTarifas(this.ls.get('Token').data, this.ls.get('Language').data, bodyRatePolicy).then(response => {
        if (response.status === 200) {
          this.politicas.listPoliticas = response.data.ratePolicyElementResponseList;
          this.politicas.privacyPolicyURL = response.data.privacyPolicyURL;
        }
      }).catch(error => {});
 var hotel = {
                  title: this.hotelName,
                  img: this.hotelImage,
                  nights: this.numberOfNights,
                  negotiatedRatesDetailPrice: {
                    rateType: this.roomContractTypeNameW,
                    totalRateWithTaxes: this.totalStay,
                    ratesDetailResponses: this.rem,
                    
                  }, 
                  benefitsRestrictions: this.ben

                }

             var datosHabHot = {
                  habitacion: this.data1,
                  hotel: hotel,
                  politicas: this.politicas,  
                  hotelName: this.hotelName,
                  localStor: 'datosHabHotSelected',
                  countryDir: "hotelCountry",
                  cityDir: "hotelCity",
                  userClientID: this.ls.get('ClientId').data,
                  tabActive: this.tabActive,
                  specialMessage: this.hotelReservationByCode.hotelDetailResponse.specialMessage
                }
      this.ls.set('datosHabHotSelected', {data: datosHabHot});
if(this.isVoucherPayment) {


          var metodosPagoData = {
            voucherFolio :  this.vaucher.folio,
            politicaSeleccionada: this.vaucher.politicaSeleccionada,
            razonSeleccionada: this.vaucher.razonSeleccionada,
            metodoPago: "Voucher",
            isCreditCard: 0

          }

          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
              metodosPagoData.policieId = this.credito.politicas[i].code
            }
          }


        } if (this.isCreditCardPayment) {


          var metodosPagoData = {

            creditoTarjetaSeleccionada: this.credito.tarjetaSeleccionada,
            creditoTipoDeMascara : this.credito.tipoDeMascara,
            creditoNombre: this.credito.nombre,
            creditoExpiracion: this.credito.expiracion,
            politicaSeleccionada: this.credito.politicaSeleccionada,
            razonSeleccionada: this.credito.razonSeleccionada,
            metodoPago: "Tarjeta de Crédito",
            isCreditCard: 1,
            creditCardType: this.cardTypeForService


          }

          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
              metodosPagoData.policieId = this.credito.politicas[i].code
            }
          }


        } if(this.isTokenPayment) {


          var metodosPagoData = {


            creditoTarjetaSeleccionada: this.token.tarjetaSeleccionada,
            creditoTipoDeMascara: this.token.numero,
            creditoNombre: this.token.nombre,
            creditoExpiracion : this.token.expiracion,
            creditoPoliticaSeleccionada: this.token.politicaSeleccionada,
            razonSeleccionada: this.token.razonSeleccionada,


            metodoPago: "Token",
            isCreditCard: 1,
            creditCardType: this.tokenCreditCardType



          }


          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(metodosPagoData.creditoPoliticaSeleccionada == this.credito.politicas[i].nombre) {
              metodosPagoData.policieId = this.credito.politicas[i].code
            }
          }


        } if(this.isTimeLimitPayment) {


          var metodosPagoData = {


            politicaSeleccionada: this.tiempoLimite.politicaSeleccionada,
            razonSeleccionada: this.tiempoLimite.razonSeleccionada,
            metodoPago: "Tiempo límite",
            isCreditCard: 0



          }

          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
              metodosPagoData.policieId = this.credito.politicas[i].code
            }
          }
        } if(this.isCreditPayment) {


          var metodosPagoData = {

            creditoEmpresaFolio: this.creditoEmpresa.folio,
            politicaSeleccionada: this.creditoEmpresa.politicaSeleccionada,
            razonSeleccionada: this.creditoEmpresa.razonSeleccionada,
            metodoPago: "Credito",
            isCreditCard: 0


          }

          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
              metodosPagoData.policieId = this.credito.politicas[i].code
            }
          }

        }


        // Here I must add socialReason
        for(var i = 0; i < this.credito.razones.length; i++) {
          if(this.credito.razones[i].nombre == metodosPagoData.razonSeleccionada) {
            metodosPagoData.agencyKey = this.credito.razones[i].code
            metodosPagoData.agencyAddress = this.credito.razones[i].agencyAddress
            metodosPagoData.agencyPhone = this.credito.razones[i].agencyPhone
            metodosPagoData.agencyRFC = this.credito.razones[i].agencyRFC
            metodosPagoData.agencyType = this.credito.razones[i].agencyType
          }
        }

        if(metodosPagoData.metodoPago == 'Voucher') {
          metodosPagoData.paymentMethodForReservationRequest = 'VO'
        }

        if(metodosPagoData.metodoPago == 'Tarjeta de Crédito') {
          metodosPagoData.paymentMethodForReservationRequest = 'CC'
        }
        if(metodosPagoData.metodoPago == 'Token') {
          metodosPagoData.paymentMethodForReservationRequest = 'TK'
        }

         if(metodosPagoData.metodoPago == 'Credito') {
          metodosPagoData.paymentMethodForReservationRequest = 'CXC'
        }

        //  Starting limit time for reservation request
   if(metodosPagoData.metodoPago == 'Tiempo límite') {
          metodosPagoData.paymentMethodForReservationRequest = 'DP'
        }
metodosPagoData.businessRa = this.businessRa
// Set policieText in confir
 metodosPagoData.creditoPoliticaSeleccionada = ""
    switch (this.iconoActivo) {
          case 0:
            if(this.vaucher.politicaSeleccionada != null && this.vaucher.politicaSeleccionada != "") {
metodosPagoData.creditoPoliticaSeleccionada = this.vaucher.politicaSeleccionada
}
            break;
          case 1:
if(this.credito.politicaSeleccionada != null && this.credito.politicaSeleccionada != "") {
metodosPagoData.creditoPoliticaSeleccionada = this.credito.politicaSeleccionada
}
            break;
          case 2:
if(this.token.politicaSeleccionada != null && this.token.politicaSeleccionada != "") {
metodosPagoData.creditoPoliticaSeleccionada = this.token.politicaSeleccionada
}
            break;
          case 3:
if(this.tiempoLimite.politicaSeleccionada != null && this.tiempoLimite.politicaSeleccionada != "") {
metodosPagoData.creditoPoliticaSeleccionada = this.tiempoLimite.politicaSeleccionada
}
            break;
          case 4:
if(this.creditoEmpresa.politicaSeleccionada != null && this.creditoEmpresa.politicaSeleccionada != "") {
metodosPagoData.creditoPoliticaSeleccionada = this.creditoEmpresa.politicaSeleccionada
}
            break;
          default:
            break;
        }

        this.ls.set('metodosPagoData', {data: metodosPagoData})
this.ls.set('changeTitleMod', true)
             // Saving data for ratePolicy
var saveDataI = this.ls.get('availibilityRequest')
saveDataI.data.discountCode = this.descuento
this.ls.set('rateNameDiscountCode', this.textPromo)

this.ls.set('availibilityRequest', saveDataI)
             this.$router.push({ name:'ReservacionesConfirmacion'})

          }
        })
        .catch(error=>{
          this.changeLoader = false;
          if (error.response.data.errorCode == 'RSP_HOTEL_AVAIL_06' || error.response.data.errorCode == 'RSP_HOTEL_AVAIL_07') {
            GlobalFunctions.cleanLocalStorageOfReserva();
            this.banError6 = true;
            this.error6Body = error.response.data.message;
          } else {
            if(error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_CODE_03') {
              this.modalCautionBody = error.response.data.message;
              this.modalCaution = true;
            } else{
              if (error.response != undefined && error.response.status == 409 && error.response.data.errorCode == 'RSP_HOTEL_RESERV_1300') {
                this.modalNewBody = error.response.data.message;
                this.banNewModal = true;
              }
            }

          }
        })
      },
           requeriment(dataReq){
                var totalCodeRooms = []
            var totalTextRooms = []
               var totalCodeExtras = []
            var totalTextExtras = []
          var smokeText = ""
          var floorText = ""

        var lisTem = {
          habitacion: null,
          extras: null,
          piso: null,
          fumar: null
        };
        var listTemp2 = [];
        if (dataReq.length > 0) {
          for (var dat of dataReq) {
          listTemp2 = [];
          for (let i = 0; i < dat.requirementResponseList.length; i++) {
            var tem = {id: i+1, name: dat.requirementResponseList[i].requirementName, code: dat.requirementResponseList[i].requirementCode};
            listTemp2.push(tem);
          }
          if (dat.requirementType.toLowerCase().search('habitación') > -1 || dat.requirementType.toLowerCase().search('room') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.habitacion = dat;
              this.habitacion1.selected = []
              this.habitacion1.typeRoomsPreferents = listTemp2;
                for(var i = 0; i < this.requirementsByCode.length; i++) {
                for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
                  if(this.requirementsByCode[i].requirementCode == this.habitacion1.typeRoomsPreferents[ii].code) {
                      this.habitacion1.selected.push(this.habitacion1.typeRoomsPreferents[ii].id)
                  }
                }              
            }
         
            for(var i = 0; i < this.habitacion1.selected.length; i++) {
              for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
                if(this.habitacion1.typeRoomsPreferents[ii].id == this.habitacion1.selected[i]) {
                  totalCodeRooms.push(this.habitacion1.typeRoomsPreferents[ii].code)
                  totalTextRooms.push(this.habitacion1.typeRoomsPreferents[ii].name)

                }
              }
            }
          }
          if (dat.requirementType.toLowerCase().search('extras') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.extras = dat;
             this.habitacion1.typeExtrasPreferents = listTemp2;
             this.habitacion1.selectedExtra = []
               for(var i = 0; i < this.requirementsByCode.length; i++) {
                for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
                  if(this.requirementsByCode[i].requirementCode == this.habitacion1.typeExtrasPreferents[ii].code) {
                      this.habitacion1.selectedExtra.push(this.habitacion1.typeExtrasPreferents[ii].id)
                  }
                }              
            }


            for(var i = 0; i < this.habitacion1.selectedExtra.length; i++) {
              for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
                if(this.habitacion1.typeExtrasPreferents[ii].id == this.habitacion1.selectedExtra[i]) {
                  totalCodeExtras.push(this.habitacion1.typeExtrasPreferents[ii].code)
                  totalTextExtras.push(this.habitacion1.typeExtrasPreferents[ii].name)
                }
              }
            }
          }
          if (dat.requirementType.toLowerCase().search('piso') > -1 || dat.requirementType.toLowerCase().search('floor') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.piso = dat;
            this.arrayFloors = dat.requirementResponseList;
            for(var i = 0; i < this.requirementsByCode.length; i++) {
                for(var ii = 0; ii < dat.requirementResponseList.length; ii++) {
                  if(this.requirementsByCode[i].requirementCode == dat.requirementResponseList[ii].requirementCode) {
                      this.habitacion1.pickedPiso = this.requirementsByCode[i].requirementCode
                      floorText = this.requirementsByCode[i].requirementName
                      this.seeTextFloor = floorText
                  }
                }              
            }

          }
          if (dat.requirementType.toLowerCase().search('fumar') > -1 || dat.requirementType.toLowerCase().search('smoking') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.fumar = dat;
            this.arraySmoke = dat.requirementResponseList;
            for(var i = 0; i < this.requirementsByCode.length; i++) {
                for(var ii = 0; ii < dat.requirementResponseList.length; ii++) {
                  if(this.requirementsByCode[i].requirementCode == dat.requirementResponseList[ii].requirementCode) {
                      this.habitacion1.pickedFumar = this.requirementsByCode[i].requirementCode
                      smokeText = this.requirementsByCode[i].requirementName
                      this.seeTextSmoke = smokeText
                  }
                }              
            }
          }
        }
        this.listRequeriment = lisTem;
      }
if(this.listRequeriment.fumar == null && this.listRequeriment.habitacion == null && this.listRequeriment.extras == null && this.listRequeriment.piso == null) {
  this.hideRe = false
} else {
  this.hideRe = true
}
        // Getting total code preferences
      this.totalPreferences =   totalCodeRooms.concat(totalCodeExtras)
      if(this.habitacion1.pickedPiso != null && this.habitacion1.pickedPiso != "") {

        this.totalPreferences.push(this.habitacion1.pickedPiso)
      }
        if(this.habitacion1.pickedFumar != null && this.habitacion1.pickedFumar != "") {

          this.totalPreferences.push(this.habitacion1.pickedFumar)
        }
       this.totalPrefTexto =  totalTextExtras.concat(totalTextRooms)
    if(floorText != null && floorText != "") {

      this.totalPrefTexto.push(floorText) 
    }
if(smokeText != null && smokeText != "") {
  this.totalPrefTexto.push(smokeText) 

}
   this.textPref  =   this.totalPrefTexto.join(", ");
      },
      getRequirements() {
       GlobalServices._consultaRequerimientos(this.hotelCode, this.ls.get('Token').data, this.ls.get('Language').data).then(responseReq => {
            if (responseReq.status === 200) {
              this.requeriment(responseReq.data);
            }
          }).catch(error => {
                                // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
          });
      },
       getPoliticasTarifas(){
           //     this.enableLoader = true;
                let ls = new SecureLS({encodingType: 'aes'});
                var language = this.ls.get('Language');
                var dailyRate = this.ls.get('dailyRate');
                var totalRate = this.ls.get('totalCostWithTaxesF');
                var a = '';
                a = this.ls.get('Token');
                var token = a.data.substr(1);
                const profile = this.ls.get('Profile').data;
                // Changer les nouvelles dates d'accord formats

if(this.data1.currencyCode == "MXN" && this.$store.getters.gettingLang == "en") {
var d1 = this.arrivalDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/,"$2$1$3");
var d2 = this.departureDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/,"$2$1$3");
this.arrivalDate = d1
this.departureDate = d2


} 

if(this.data1.currencyCode == "USD" && this.$store.getters.gettingLang == "es") {
var d1 = this.arrivalDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/,"$2$1$3");
var d2 = this.departureDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/,"$2$1$3");
this.arrivalDate = d1
this.departureDate = d2

} 
                axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RP, {
                    hotelCode:this.hotelCode,
                    arrivalDate:this.beautyDateInput,
                    departureDate:this.beautyDateOutput,
                    contractCode:this.roomContractCode,
                    contractType: this.contractTypeForPol,
                    currencyCode:this.currencyM,
                    showRates: profile.ratesPermissionsResponse.showRates,
                    showPublicRates: profile.ratesPermissionsResponse.showPublicRates,
                    hasCombinedRate: false,
                    dailyRate: dailyRate,
                    totalRate:Number(totalRate)
                }, {
                    withCredentials: true,
                    credentials: 'include',
                    headers: {'Authorization': 'Bearer '+ token,
                        'Accept-Language': language.data,
                        'Content-Type' : 'application/json'
                    }
                })
                    .then(res => {
                        let resObject = JSON.parse(JSON.stringify(res));
                        let response = resObject.data.response;
                        if ( resObject.status === 200 || resObject.status === 201) {
                          this.politicas.listPoliticas = res.data.response.ratePolicyElementResponseList;
          this.politicas.privacyPolicyURL = res.data.response.privacyPolicyURL;
                            this.ls.set('HotelDetailDataPoliticas', {data: resObject.data});
                        }
                    })
                    .catch(error=>{
                      // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
                    })
            },
     generalReset() {
                   this.vaucher.folio = ""
          this.credito.tarjetaSeleccionada = ""
          this.credito.numero = ""
          this.credito.tipoDeMascara = ""
          this.credito.nombre= ""
          this.credito.expiracion = ""
          this.fechaExpiracionTarCred = ''
          this.credito.tarjetaSeleccionada = ""
          this.credito.numero = ""
          this.credito.nombre = ""
          this.credito.expiracion = ""
          this.token.numero = ''
          this.token.tarjetaSeleccionada = ''
          this.token.nombre = ''
          this.token.expiracion = ''
          this.fechaExpiracionToken = ''
          this.creditoEmpresa.folio = ""
      },
       requestTokenizador(){
        return new Promise ((resolve, reject) => {
          let urlTokenizado = process.env.VUE_APP_TOKENIZER + this.ls.get('Language').data;
          window.addEventListener("message", function(event) {
            if ( urlTokenizado.startsWith(event.origin)) {
              this.credito.numero =  event.data;
              resolve(event.data);
            }else{
              reject(event);
            }
          });
        });
      },
       cancelarTokeninzador(){
        this.credito.numero = '';
        this.credito.tipoDeMascara ='';
        this.HTMLcontent = '';
        this.modalTokenizador = false;
      },
      cargaToken(){
        let urlToken = process.env.VUE_APP_TOKENIZER + this.ls.get('Language').data;
        this.urlTokenizado = urlToken;
        this.HTMLcontent = '<iframe id="iframeTokenizador" style="border: none; width: 100%; height: 380px;" src="'+ urlToken+'"></iframe>';
      },
      cerrarTokenizador(){
        this.HTMLcontent = '';
        this.modalTokenizador = false;
      },
        abrirTokenizador(){
        if (this.credito.tarjetaSeleccionada != '') {
          this.HTMLcontent= '';
          this.cargaToken();
  
          this.modalTokenizador = true;
          this.requestTokenizador().then(response=> {
            this.credito.numero = response;
            this.credito.tipoDeMascara = response;
            this.cerrarTokenizador();
          }).catch(error => {
            //error ___Tokenizador respondio null o undefined o vacio
          });
        }
      },
      see() {
        this.a()
     },
       consultaMetodosPago(){
        const userProperties = this.ls.get('userProperties');

        var dataMetPag = {
          hotelCode: null,
          arrivalDate: null,
          departureDate: null,
          currencyCode: null,
          contractCode: null,
          contractType: null,
          agreementCode: null,
          iataCode: null,
          motivaCode: null,
          userProperties: [],
        };
        dataMetPag.agreementCode = this.lackingAgreement
        dataMetPag.arrivalDate = this.arrivalDate
        dataMetPag.departureDate = this.departureDate
        dataMetPag.hotelCode = this.hotelCode;
        dataMetPag.currencyCode = this.currencyM;
        dataMetPag.contractCode = this.roomContractCode;
        dataMetPag.contractType = this.contractTypeForPol
        dataMetPag.iataCode = this.lackingIata
        dataMetPag.motivaCode = this.motivaWS
        var userPropertiesTemp = [];
        for(var usProp of userProperties.data) {
          userPropertiesTemp.push(Number(usProp.propertyId))
        }
        dataMetPag.userProperties = userPropertiesTemp.sort().join();
        GlobalServices._consultaMetodosPagos(dataMetPag, this.ls.get('Token').data, this.ls.get('Language').data).then(responseMetPag => {
          this.banMetodosPagos = true;
          var listTarjTemp = [];
          for (var res of responseMetPag.data.paymentCardTypeResponseList) {
            if (res.paymentCardType.toLowerCase() === 'amexco') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 1, code: res.paymentCardType});
            }
            if (res.paymentCardType.toLowerCase() === 'diners') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 2, code: res.paymentCardType});
            }
            if (res.paymentCardType.toLowerCase() === 'master') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 3, code: res.paymentCardType});
            }
            if (res.paymentCardType.toLowerCase() === 'visa') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 4, code: res.paymentCardType});
            }
          }
          this.credito.tarjetas = listTarjTemp;
          this.token.tarjetas = listTarjTemp;

          if (responseMetPag.data.paymentMethodTypeResponseList === 0) {
            this.banVaucher = false;
            this.banTarjCred = false;
            this.banToken = false;
            this.banTiemLim = false;
            this.banCredito = false;
          } else{
            const array = responseMetPag.data.paymentMethodTypeResponseList;

            for (var res1 of array) {
              switch (res1.paymentMethodType.toLowerCase()) {
                case 'vo':
                  this.banVaucher = true;                
                  break;
                case 'cc':
                  this.banTarjCred = true;
                  break;
                case 'tk':
                  this.banToken = true;
                  break;
                case 'dp':
                  this.banTiemLim = true;
                  break;
                case 'cxc':
                  this.banCredito = true;
                  break;
              }
            }
          }
        }).catch(error => {
                              // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if (error.status === 401) {
            this.clearLocalStorage();
          }
        });

      },
      a() {
           switch (this.iconoActivo) {
          case 0:
            this.ls.set("paymentMethodRO", {data: {
              folio: this.vaucher.folio,
              razonSocial: this.vaucher.razonSeleccionada , 
              politicaSeleccionada: this.vaucher.politicaSeleccionada,
              paymentMethod: 0
            }})
            this.sendVoucher()
            return this.visibleVoucher = true
            break;
          case 1:
            this.ls.set("paymentMethodRO", {data: {
              creditoCardType :this.credito.tarjetaSeleccionada,
              creditoNumber :this.credito.numero,
              creditoMask :this.credito.tipoDeMascara,
              creditoName :this.credito.nombre,
              creditoExpire :this.credito.expiracion,
              creditoPolicy :this.credito.politicaSeleccionada,
              creditoSocial :this.credito.razonSeleccionada,
              paymentMethod: 1
            }})
            this.sendCreditCard()
            return this.visibleTC = true
            break;
            case 2:
            this.ls.set("paymentMethodRO", {data: {
              tokenTarjetaSeleccionada: this.credito.tarjetaSeleccionada,
              tokenNumero: this.credito.numero,
              tokenNombre: this.credito.nombre,
              tokenExpiracion: this.credito.expiracion,
              tokenPoliticaSeleccionada: this.token.politicaSeleccionada,
              tokenRazonSeleccionada: this.token.razonSeleccionada,
              paymentMethod: 2
            }})
            this.sendToken()
            return this.visible = true
            break;
            case 3:
            this.ls.set("paymentMethodRO", {data: {
              tiempoPolitica: this.tiempoLimite.politicaSeleccionada,
              tiempoRazon: this.tiempoLimite.razonSeleccionada,
              paymentMethod: 3
            }})
            this.sendTimeLimit()
            return this.visibleLimit = true
            break;
            case 4:
            this.ls.set("paymentMethodRO", {data: {
              creditFolio: this.creditoEmpresa.folio,
              creditPolicy: this.creditoEmpresa.politicaSeleccionada,
              creditReason: this.creditoEmpresa.razonSeleccionada,
              paymentMethod: 4
            }})
            this.sendCreditPay()
            return this.visibleCredit = true
            break;
          default:
            return null
            break;
        }
      },
       sessionHome() {
        var picked = ''
        if(this.$store.getters.gettingLang == 'es') {
          picked = 'MXN'

        } else {
          picked = 'USD'
        }
        // Reservaciones
        var availibilityRequest = {

          hotelName: '',
          hotelCode: '',
          arrivalDate: '',
          departureDate: '',
          currencyCode: this.curC,
          totalAdults: 1,
          totalChildren: 0,
          totalInfants: 0,
          totalRooms: 1,
          agreementCode: '',
          iataCode: '',
          motivaCode: '',
          discountCode: '',
          promoCode: '',
          profileType: '',
          roomCodeList: [],
          selectedRooms: [],
          beautiDateInput:   '',
          beautiDateOutput:   ''
        }
        var ls = new SecureLS({encodingType: 'aes'});
        ls.set('availibilityRequest', {data: availibilityRequest});
        ls.set('specialMessageR',{data: 'N/A'})
        this.clearHomeCounter++
        ls.set('clearHome', {data: this.clearHomeCounter})
        this.$store.commit('countSpecialMessages')
        this.$store.commit('gettingClearHome')
      this.$store.commit('blockLanguages', {turn: false})
    this.ls.set('blocklanguages',{data: false, data1: 0}) // data1 = (0: noBlock, 1: block)
    var reset = null 
    this.ls.set('rateNameDiscountCode',  reset);
      },
       // Codigos
      updateValueCodigo(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.descuento = value
        }
        this.$forceUpdate()
      },
      updateValuePromocion(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.promocion = value
        }
        this.$forceUpdate()
      },
      updateValueIata(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.iata = value
        }
        this.$forceUpdate()
      },
      updateValueMotiva(event) {
        const value = event.target.value
        if (String(value).length <= 25) {
          this.motiva = value
        }
        this.$forceUpdate()
      },
      updateValueAgreement() {
 const value = event.target.value
        if (String(value).length <= 25) {
          this.agreementCode = value
        }
        this.$forceUpdate()
      },
     
           validateCode() {
//Obtener referencias a los inputs
        var comDesc=  this.descuento
        var comProm=  this.promocion
        var comIata=  this.iata 
        var comPif =  this.motiva
        var compConv= this.agreementCode
        
        //Validar si están todos vacíos (dependiendo los que tenga disponibles cada usuario)
        if ((comIata ==''||comIata ==null) && (comPif ==''||comPif ==null) && (compConv ==''||compConv ==null) && (comDesc ==''||comDesc ==null) && (comProm ==''||comProm ==null)){        
            //DESBLOQUEAR CADA INPUT PARA ESCRITURA
            this.getAgreementCodeOff = false
            this.getDiscountOff = false
            this.getIataOff = false
            this.getMotivaOff = false
            this.getPromoOff = false
        }else if(comProm !='' && comProm !=null){
            //SI PROMOCODE TIENE ALGO ESCRITO ENTONCES BLOQUEAR LOS 4 INPUTS RESTANTES
            this.getAgreementCodeOff = true
            this.getDiscountOff = true
            this.getIataOff = true
            this.getMotivaOff = true
        }else if((comDesc !=''&&comDesc !=null) || (comIata !=''&&comIata !=null) || (comPif !=''&&comPif!=null) || (compConv !=''&&compConv != null) ){
            //SI CUALQUIERA DE LOS 4 INPUTS RESTANTES TIENE ALGO ESCRITO, ENTONCES BLOQUEAR EL INPUT DE PROMOCODE
                        this.getPromoOff = true

        }
 



      },
       closeModalErroresCodigos() {
        this.isModalErroresCodigos = false
      },
        closeModalSpecialMessage() {
        this.modalSpecialMessage = false
       this.$router.push({ name: 'BusquedaPorTarifa'})

      },
        copyMounted() {
            
      var ls = new SecureLS({encodingType: 'aes'});

      var specialMessageR = ls.get('specialMessageR')
// Start kb48159
  if(specialMessageR.data == 'N/A' || specialMessageR.data == '' || specialMessageR.data == null) {
      this.modalSpecialMessage = false
       this.$router.push({ name: 'BusquedaPorTarifa'})

  } else if(this.descuento == 'VACEJE') {
    this.modalSpecialMessage = true
  }
  else{
    this.modalSpecialMessage = false
    this.$router.push({ name: 'BusquedaPorTarifa'})
  
// End kb48159     
  }
    
      },
       closeModalNoTarifas() {
        this.isModalNoTarifas = false
      },
      codeDetailing() {
      var a = "";
      a = this.ls.get("Token");
      var token = a.data.substr(1);
        
// Consultar detalle de hotel
var ls = new SecureLS({encodingType: 'aes'});
ls.set('mesContractCodesForReservation', {data: this.contractCodes})
ls.set('brandCodeForReservationService', {data: this.brandCode})

// When I send hotelDetail request in Spanish
if(this.$store.getters.gettingLang == "es") {
  var dateInHotelDetail = this.arrivalDate;
  var dateOutHotelDetail = this.departureDate;
  var datearray = dateInHotelDetail.split("/");
  var datearray2 = dateOutHotelDetail.split("/");
  var newdateHotelDetail = datearray[2] + '-' + datearray[1] + '-' + datearray[0];
  var newdate2HotelDetail = datearray2[2] + '-' + datearray2[1] + '-' + datearray2[0];
  
} else {    // When I send hotelDetail request in Spanish
  var dateInHotelDetail = this.arrivalDate;
  var dateOutHotelDetail = this.departureDate;
  var datearray = dateInHotelDetail.split("/");
  var datearray2 = dateOutHotelDetail.split("/");
  var newdateHotelDetail = datearray[2] + '-' + datearray[0] + '-' + datearray[1];
  var newdate2HotelDetail = datearray2[2] + '-' + datearray2[0] + '-' + datearray2[1];

}

axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DETAILDHOTEL, {
  brandCode: this.brandCode,
	hotelCode: this.hotelCode,
  contractCodes: this.contractCodes,
  checkInDate: newdateHotelDetail,
	checkOutDate: newdate2HotelDetail
  
}, {
     withCredentials: true,
       credentials: 'include',
    headers: {'Authorization': 'Bearer ' + token,
                'Content-Type' : 'application/json',
                'Accept-Language' : this.ls.get("Language").data
                }
       })
.then(res => {
       var resObject=JSON.parse(JSON.stringify(res));
       if ( resObject.status == 200 || resObject.status == 201) {
       var ls = new SecureLS({encodingType: 'aes'});
       ls.set('DetailHotelInfo', {data: resObject.data});
      var codeProm = '';
      if (this.descuento != '') {
        codeProm = this.descuento
      }
      if (this.promocion != '' && this.promocion === 'BUSINESS') {
        codeProm = 'CCR114'
      }
       for(var iterator = 0; iterator < resObject.data.response.ratePolicyInfoResponseList.length; iterator++) {
         if(codeProm == resObject.data.response.ratePolicyInfoResponseList[iterator].contractCode) {
           ls.set('rateNameDiscountCode',  resObject.data.response.ratePolicyInfoResponseList[iterator].rateName);
         } 
       }  
       this.enableLoader= false
        this.isModalNoTarifas = false
        this.isModalTarifas = false
       
                 this.$store.commit('hotelInfoIsSet');
                 this.$store.commit('reloadCostDetail')
        this.ls.set("choosingEditing", true)
        this.getPoliticasTarifas()
var saveData = this.ls.get('availibilityRequest')
console.log(saveData)
saveData.data.beautiDateInput = this.beautyDateInput
saveData.data.discountCode = this.descuento

saveData.data.beautiDateOutput = this.beautyDateOutput
saveData.data.currencyCode = this.curC

this.ls.set('availibilityRequest', saveData)
              // Saving data for ratePolicy
this.ls.set("opSuE", this.listRequeOpcionalesE)
var nouDayes = this.ls.get("updateCostDetail").data

  if (nouDayes === '' && nouDayes === undefined && nouDayes === null) {
    nouDayes.habitacion.beautiDateInput = this.beautyDateInput
    nouDayes.habitacion.beautiDateOutput = this.beautyDateOutput 
  }
this.ls.set("updateCostDetail", {data: nouDayes})
this.$store.commit('firstChange', {enable: true})
                  if( (this.responseSpecialMessageForDiscounts != '' || this.responseSpecialMessageForDiscounts != null || this.responseSpecialMessageForDiscounts != 'N/A')) {
    this.copyMounted()
  } else {
       this.$router.push({ name: 'BusquedaPorTarifa'})
  }

    
   }    
   if(resObject.status == 404) {
             this.isModalTarifas = false
          this.isModalNoTarifas = false
   }
   if(resObject.status == 401) {
             this.isModalNoTarifas = false
          this.isModalTarifas = false
   this.clearLocalStorage()
   }
         })
    .catch(error=>{
      // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
       this.enableLoader= false
let errorObject=JSON.parse(JSON.stringify(error));
if (errorObject.message == 'Request failed with status code 401') {
          this.isModalNoTarifas = false
          this.isModalTarifas = false
   this.clearLocalStorage()
} else {}
})
// Finir Consultation d'hotel

      },
       closeModalTarifas2() {
        this.isModalTarifas = false
          this.codeDetailing()          
      },
        closeModalTarifas() {
                 var ls = new SecureLS({encodingType: 'aes'});
                 this.$store.commit('clickPublicFalse')
  ls.set('justPublicSir', {data: false});
        this.enableLoader = false
        this.isModalTarifas = false;
      },
        onlyPublicModal(errorMessage) {
   
 
      var n = errorMessage.indexOf("\n\n")
      var paragraph1 = errorMessage.substring(0,n)
      var paragraph2 = errorMessage.substring(n+1)
      this.isModalTarifas = true
    },
      
      changeRes() {
          this.ls.set('dernierDM', GlobalFunctions.convertBeautifulDate(this.salida, this.ls.get('Language').data))
        this.setDataPersonalH1()
        if (!this.banMemFR) {
          this.fiestaRewardsNumber = '';
        }
      var a = "";
      a = this.ls.get("Token");
      var token = a.data.substr(1);
      var roomCodesListings = []
      roomCodesListings.push(this.roomCode)
      if(this.agreementCode == null) {
        this.agreementCode = ""
      } else {
        this.agreementCode.toUpperCase()
      }
            if(this.iata == null) {
        this.iata = ""
      } else {
        this.iata.toUpperCase()
      }
            if(this.motiva == null) {
        this.motiva = ""
      } else {
        this.motiva.toUpperCase()
      }
            if(this.descuento == null) {
        this.descuento = ""
      } else {
        this.descuento.toUpperCase()
      }
            if(this.promocion == null) {
        this.promocion = ""
      } else {
        this.promocion.toUpperCase()
      }


// Get change request for read-only screen

       var policieId = ""
       var razonKey = ''
         if (this.iconoActivo === 0) {
          for(var i = 0; i < this.vaucher.politicas.length; i++) {
              if(this.vaucher.politicaSeleccionada == this.vaucher.politicas[i].nombre) {
                policieId = this.vaucher.politicas[i].code
              } 
          }

          for(var i = 0; i < this.vaucher.razones.length; i++) {
            if(this.vaucher.razones[i].nombre == this.vaucher.razonSeleccionada) {
              razonKey = this.vaucher.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 1) {
          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(this.credito.politicaSeleccionada == this.credito.politicas[i].nombre) {
              policieId = this.credito.politicas[i].code
            } 
          }

          for(var i = 0; i < this.credito.razones.length; i++) {
            if(this.credito.razones[i].nombre == this.credito.razonSeleccionada) {
              razonKey = this.credito.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 2) {
          for(var i = 0; i < this.token.politicas.length; i++) {
            if(this.token.politicaSeleccionada == this.token.politicas[i].nombre) {
              policieId = this.token.politicas[i].code
            } 
          }

          for(var i = 0; i < this.token.razones.length; i++) {
            if(this.token.razones[i].nombre == this.token.razonSeleccionada) {
              razonKey = this.token.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 3) {
          for(var i = 0; i < this.tiempoLimite.politicas.length; i++) {
            if(this.tiempoLimite.politicaSeleccionada == this.tiempoLimite.politicas[i].nombre) {
              policieId = this.tiempoLimite.politicas[i].code
            } 
          }

          for(var i = 0; i < this.tiempoLimite.razones.length; i++) {
            if(this.tiempoLimite.razones[i].nombre == this.tiempoLimite.razonSeleccionada) {
              razonKey = this.tiempoLimite.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 4) {
          for(var i = 0; i < this.creditoEmpresa.politicas.length; i++) {
            if(this.creditoEmpresa.politicaSeleccionada == this.creditoEmpresa.politicas[i].nombre) {
              policieId = this.creditoEmpresa.politicas[i].code
            } 
          }

          for(var i = 0; i < this.creditoEmpresa.razones.length; i++) {
            if(this.creditoEmpresa.razones[i].nombre == this.creditoEmpresa.razonSeleccionada) {
              razonKey = this.creditoEmpresa.razones[i].code
            }
          }
        }
        if(this.mergeUpdate) {

      var a = this.totalPreferencesRoomsWS.concat(this.totalPreferencesEWS)
      a.push(this.habitacion1.pickedFumar)
      a.push(this.habitacion1.pickedPiso)
      this.totalPreferences = a
      var textWS = []
      textWS.push(this.seeTextFloor)
      textWS.push(this.seeTextSmoke)
      for(var i = 0; i < a.length; i++) {
       for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
        if(a[i] == this.habitacion1.typeRoomsPreferents[ii].code) {
            textWS.push(this.habitacion1.typeRoomsPreferents[ii].name)
        }
      } 
      }
       for(var i = 0; i < a.length; i++) {
       for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
        if(a[i] == this.habitacion1.typeExtrasPreferents[ii].code) {
            textWS.push(this.habitacion1.typeExtrasPreferents[ii].name)
        }
      } 
      }
       var aO =  textWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      this.textPref = aO.join(", ");
       this.ls.set('preTe', this.textPref)
      }

        // Getting profile
        var ls = new SecureLS({encodingType: 'aes'});
      if(String(ls.get('Profile').data.parentUsername) == "null" || String(ls.get('Profile').data.parentUsername) == "undefined") {
  var parendId22 = ''
} else {
  var parendId22 = String(ls.get('Profile').data.parentUsername)
}
if(this.jobPhoneNumber == null) {
  this.jobPhoneNumber = ""
}

if(this.emailAlter != null|| this.emailAlter.length != 0) {
 var a = this.emailAlter[0]
 this.emailAlter = a
}
 if(this.guestProfileId == null) {
          this.guestProfileId = ""
        }
       
    var  profileRequest22 = [
        {
     acompananteEmail: "",
     acompananteFirstName: this.acompananteFirstName.toUpperCase(),
     acompananteLastName: this.companionFatherSurname.toUpperCase(), 
     acompananteMaternalLastName: this.companionMotherSurname.toUpperCase(),  
     address: this.address,
     address2: this.address2, 
     addressType: "",
     codigoPostal: this.posCode,
     costCenter: this.costCenter, 
     country: this.country,
     emailProfile: this.emailAlter, 
     email: this.emailAlter,
     emailAlter: this.emailAlternative, 
     excellencePin: this.apreciareClubNumber,  
     fiestaRewardsNumber: this.fiestaRewardsNumber.toUpperCase(), 
     firstName: this.realName, 
     guardar: false, 
     guestProfileId: this.guestProfileId, 
   
     jobPhoneExt: "52",  
     jobPhoneNumber: this.jobPhoneNumber, 
     lastName: this.fatherSurname.toUpperCase(),
     middleName: "",
     numberEmpl:  this.employeeNumber, 
     parendId: parendId22,
     preferencias: this.totalPreferences, 
     preferenciasTexto: this.textPref, 
     profileId: String(ls.get('Profile').data.profileId),
     profileType: String(ls.get('Profile').data.profileType),
     secondLastName: this.motherSurname,
     showPublicRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:ls.get('Profile').data.ratesPermissionsResponse.showPublicRates),
     showRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:ls.get('Profile').data.ratesPermissionsResponse.showRates),
     state: this.state,
     suplementos: "",  
     suplements: [  ], 
     telephoneType: this.telephoneType,
     userId: String(ls.get('userIdForReservationRequest').data)
        }
      ] 

        // Getting profile
if(this.descuento == null) {
  this.descuento = ""
}
if(this.promocion == null) {
  this.promocion = ""
}
        var str = this.credito.expiracion;
        var month = this.credito.expiracion.substring(0, 2);
        var year = this.credito.expiracion.substring(2);
        if(this.bene == null) {
          this.bene = ""
        }
var payCode = ""
for(var i = 0; i < this.credito.tarjetas.length; i++) {
  if(this.credito.tarjetas[i].nombre == this.credito.tarjetaSeleccionada) {
        payCode = this.credito.tarjetas[i].code
  }
}
 if(this.guestProfileId == null) {
          this.guestProfileId = ""
        }
           if(this.iconoActivo == 1 || this.iconoActivo == 2) {
var cardValidationW = true
       } else {
var cardValidationW = false
       }

//       this.vaucher.folio = "test"
var vaoucherOrCredEmpresa = (this.iconoActivo===0?this.vaucher.folio:this.iconoActivo===4?this.creditoEmpresa.folio:'')

        var reservationRequest = {

  creditCard: {
    cardHoldersName: this.credito.nombre.toUpperCase(),
    expirationMonth: month,  
    expirationYear: year,
    paymentCardType: payCode,
    token: this.credito.numero,      
    cardValidation: String(cardValidationW),
    tokenAction: ""     
  },
  datos: {
    amenityList: this.amenityListWS,  
    arriveTime: "",
    beneficios: this.bene,  
    briefDescription: this.briefD,
    centralId: this.numConfirWS,        
    checkInDate: this.beautyDateInput,
    checkOutDate: this.beautyDateOutput,
    commentType: "GRL",  
    confirmationInfants: "Infantes", 
    contractCode: this.roomContractCode,
    contractType: this.contractTypeForPol,
    cuponCXC: vaoucherOrCredEmpresa,
    cuponCxCDesc: "", 
    currencyCode: this.currencyM,
    descuento: this.descuento, 
    iata: this.lackingIata,
    infants: "0",
    language: this.$store.getters.gettingLang,
    leaveTime: "", 
    nights: this.numberOfNights,
    numberAdults: String(this.adultos),
    numberChildren: String(this.menores),
    numberRooms: String(this.habitaciones),
    paymentMethod: this.payMe,  
    paymentType: "0", 
    pif: this.motivaWS,
    policieId: (policieId==='-1'?'':policieId),
    policieText: this.rateDescription,
    promoCode: this.promocion,
    reservDetailVOConfirm: "",
    restricciones: this.restrictionsFWS,
    sendCopyTo: this.emailAlter,
    sendProformGranted: this.enableProfGH,
    tradeName: (razonKey==='-1'?'':razonKey),
    yieldType: "",
   sendSpecialConsiderations: this.banConsiEspe
  },
  hotel: {
    brandCode: this.brandCode,
    brandImage: this.brandImage,
    brandName: this.brandName, 
    hotelAddress: this.hotelAddress,
    hotelCode: this.hotelCode,
    hotelFax: this.hotelFax,
    hotelImage: this.hotelImage, 
    hotelName: this.hotelName,
    hotelPhone: this.telephone22,
    hotelurl: "", 
    roomCode: this.roomCode,
    roomImage: this.roomImage,
    roomName: this.roomName,
  },
  isCreditCard: String(this.isCreditCard), 
  profile: profileRequest22,
  profileIdUser: this.guestProfileId,
       userId: String(ls.get('userIdForReservationRequest').data),

     profileId: String(ls.get('Profile').data.profileId),

  rates: this.ratesResponse
         
   }
this.rem = reservationRequest.rates.ratesDetailResponseList
  if(this.rem[0].rateMandatorySupplementResponseList == null) {
  this.rem[0].rateMandatorySupplementResponseList = []
}
        var responseSup = {
                supplementMandatoryResponseList: this.rem[0].rateMandatorySupplementResponseList,
                supplementNotMandatoryResponseList: []
              }
              this.ls.set('supplement', {data:responseSup});
   // Eliminar null en rates
 
   if(reservationRequest.rates.ratesDetailResponseList[0].originalContract == null) {

     reservationRequest.rates.ratesDetailResponseList[0].originalContract = ""
   }

    if(reservationRequest.rates.ratesDetailResponseList[0].originalCurrency == null) {

     reservationRequest.rates.ratesDetailResponseList[0].originalCurrency = ""
   }
     if(reservationRequest.rates.ratesDetailResponseList[0].levelCode == null) {

     reservationRequest.rates.ratesDetailResponseList[0].levelCode = ""
   }
     if(reservationRequest.rates.ratesDetailResponseList[0].exchangeCurrency == null) {

     reservationRequest.rates.ratesDetailResponseList[0].exchangeCurrency = ""
   }
     if(reservationRequest.rates.ratesDetailResponseList[0].commissionResponse == null) {

     reservationRequest.rates.ratesDetailResponseList[0].commissionResponse = {}
   }
   if(reservationRequest.rates.ratesDetailResponseList[0].ratesTaxesList == null) {

     reservationRequest.rates.ratesDetailResponseList[0].ratesTaxesList = []
   }
    if(reservationRequest.rates.ratesDetailResponseList[0].rateMandatorySupplementResponseList == null) {

     reservationRequest.rates.ratesDetailResponseList[0].rateMandatorySupplementResponseList = []
   }

   // Eliminar null en rates
this.ls.set("arrivalForm", this.beautyDateInput)
       this.ls.set("departureForm", this.beautyDateOutput)

// Changer les nouvelles dates d'accord formats
for(var i = 0; i < reservationRequest.profile.length; i++) {
      reservationRequest.profile[i].profileId = []
      reservationRequest.profile[i].profileId.push(String(ls.get('Profile').data.profileId))
      if(reservationRequest.datos.descuento != '') {
      reservationRequest.profile[i].profileId.push(reservationRequest.datos.descuento)
      }
      var a =    reservationRequest.profile[i].profileId.filter(function(item, pos) {
          return reservationRequest.profile[i].profileId.indexOf(item) == pos;
      })
      reservationRequest.profile[i].profileId = a

      }
       
    this.ls.set("reservationRequestEdition", reservationRequest)
this.ls.set("disModDa", this.descuento)

  axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_HOTEL + `/` + process.env.VUE_APP_AVAILIBILITY, {
  hotelCode: this.hotelCode,
	arrivalDate:  this.beautyDateInput,
	departureDate: this.beautyDateOutput,
	currencyCode: this.currencyM,
	totalAdults: this.adultos,
	totalChildren: this.menores,
	totalInfants: this.infantes,
	totalRooms: this.habitaciones,
	agreementCode: this.agreementCode.toUpperCase().trim(),  
	iataCode: this.iata.toUpperCase().trim(),
	motivaCode: this.motiva.toUpperCase().trim(),
	discountCode: this.descuento.toUpperCase().trim(),
	promoCode: this.promocion.toUpperCase().trim(),
	profileType: this.ls.get('Profile').data.profileType,
  roomCodeList: [],
  contractCode: "",
  showPublicRates: this.ls.get('Profile').data.ratesPermissionsResponse.showPublicRates,
  showRates:  this.ls.get('Profile').data.ratesPermissionsResponse.showRates,
  groupCode: this.groupBool
}, {
     withCredentials: true,
       credentials: 'include',
    headers: {'Authorization': 'Bearer ' + token,
                'Content-Type' : 'application/json',
                'Accept-Language' : this.ls.get('Language').data
                }
       })
.then(res => {
       var resObject=JSON.parse(JSON.stringify(res));
   if ( resObject.status == 200 || resObject.status == 201) {
        this.ls.set('BusquedaPorTarifaInfo', {data: resObject.data});
        this.gettingSpecialMessagePasP = resObject.data.response.specialMessageForDiscounts
        var availableCategories = [];
    if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0 && !this.groupBool) {
       this.isModalNoTarifas = true;
       this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body1');
       this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body2');
     } else {
    if(resObject.data.response.unavailableRates.length != 0  && this.groupBool){
    //Inicia bloque modal de no disponibilidad Tarifas grupales
    this.availableRoomCodes = [];
        this.groupRoomCodes = [];
        this.groupRoomCodesNotAvail = [];
        this.groupRoomsInfo = [];
        var codePrev = '';
        var unavailRateDates = [];
        var unavailRates = [];
        
       
        resObject.data.response.unavailableRates.forEach(tarifa => {
            const roomCode = tarifa.roomCode;
            const dates = tarifa.ratesDetailResponses.map(detalle => detalle.reservationDate);
            unavailRates.push({ roomCode, dates });
        }); 
        

        for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
          if(codePrev !== resObject.data.response.negotiatedRates[i].roomCode){
            this.availableRoomCodes.push(resObject.data.response.negotiatedRates[i].roomCode)
          }          
          codePrev = resObject.data.response.negotiatedRates[i].roomCode;
        }
        console.log("ROOM AVAILANBEL",this.roomListings)
        
        this.roomListings.forEach(item => {
            if (item.roomCodes.some(code => this.availableRoomCodes.includes(code))) {
              availableCategories = item.categoryName;
            }
        });
        console.log(">>>> Availability Rooms: "+ availableCategories);

        for(var i = 0; i < this.InfoGrupo.roomCodes.length; i++) {
          this.groupRoomCodes.push(this.InfoGrupo.roomCodes[i])
        }
        
       
        this.typeRooms.forEach(function (typeRoom) {
          console.log(">>>> Categorias: "+typeRoom.name)});
        for(var k = 0; k < unavailRates.length; k++) {   
            for(var i = 0; i < this.roomListings.length ; i++) {
                for(var j = 0; j < this.roomListings[i].roomCodes.length ; j++) {                     
                  if(this.roomListings[i].roomCodes[j] === unavailRates[k].roomCode){
                    var dates = '';
                    for(var z = 0; z < unavailRates[k].dates.length ; z++)
                    {
                       dates = dates +','+unavailRates[k].dates[z];
                    }
                    console.log(">>>>> Array Dates: "+dates);
                    
                    if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0){
                      this.groupRoomCodesNotAvail.push({'roomName':this.roomListings[i].categoryName,'dates':dates});
                    }else{                      
                      this.groupRoomCodesNotAvail.push(this.roomListings[i].categoryName);
                    }
                    
                  }                
               }
             }                   
     }    
    }     
     if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0 && resObject.data.response.unavailableRates.length === 0) {
       if(this.groupBool){
       console.log("<<<<<<<Primer modal>>>>>>>>>");
       this.roomCodesNotAvail = "";
       this.isModalNoTarifas = true;
       this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body1');
       this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
       }
       else{
        console.log("HOLA")
       this.roomCodesNotAvail = "";
       this.isModalNoTarifas = true;
       this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body1');
       this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body2');
       }
     }
     else{        
        
       //Termina bloque modal de no disponibilidad Tarifas grupales
       var ls = new SecureLS({encodingType: 'aes'});
       ls.set('BusquedaPorTarifaInfo', {data: resObject.data});
       this.gettingSpecialMessagePasP = resObject.data.response.specialMessageForDiscounts
       if( (resObject.data.response.negotiatedRates == [] || resObject.data.response.negotiatedRates.length == 0 ) && resObject.data.response.publicRates.length != 0) {
        var ls = new SecureLS({encodingType: 'aes'});
        this.responseSpecialMessageForDiscounts = resObject.data.response.specialMessageForDiscounts
 ls.set('specialMessageR',{data: resObject.data.response.specialMessageForDiscounts})
        if(resObject.data.response.specialMessageForDiscounts == "N/A") {
          this.specialMessageUp = false
          this.$store.commit("specialMessageForDiscounts", {data: "N/A"})
        } else {
                   this.specialMessageUp = true
          this.$store.commit("specialMessageForDiscounts", {data: resObject.data.response.specialMessageForDiscounts})

        }
        
 this.$store.commit('clickPublic')
 ls.set('justPublicSir', {data: true});
      this.contractCodes = []                                                                  
       for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
         this.contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
         }
       for(var i = 0; i < resObject.data.response.publicRates.length; i++) {
         this.contractCodes.push(resObject.data.response.publicRates[i].contractCode)
         }
var names = this.contractCodes.reduce(function (a, b) {
 if (a.indexOf(b) == -1) {
   a.push(b)
 }
 return a;
}, []);
this.contractCodes = names
ls.set('contractCodesLangProblem', {data: this.contractCodes})
             this.onlyPublicModal(resObject.data.message)
       } 

// Seulment negociatedRates, NO publicRates
if( (resObject.data.response.negotiatedRates != [] || resObject.data.response.negotiatedRates.length != 0 ) && resObject.data.response.publicRates.length == 0) {
   
  var ls = new SecureLS({encodingType: 'aes'});
        this.responseSpecialMessageForDiscounts = resObject.data.response.specialMessageForDiscounts
        ls.set('specialMessageR',{data: resObject.data.response.specialMessageForDiscounts})
        if(resObject.data.response.specialMessageForDiscounts == "N/A") {
          this.specialMessageUp = false
          this.$store.commit("specialMessageForDiscounts", {data: "N/A"})
        } else {
                   this.specialMessageUp = true
          this.$store.commit("specialMessageForDiscounts", {data: resObject.data.response.specialMessageForDiscounts})

        }
        
 ls.set('seulNegotiated', {data: true});
      this.contractCodes = []                                                                  
       for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
         this.contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
         }
       
var names = this.contractCodes.reduce(function (a, b) {
 if (a.indexOf(b) == -1) {
   a.push(b)
 }
 return a;
}, []);
this.contractCodes = names
ls.set('contractCodesLangProblem', {data: this.contractCodes})
//Inicio CRTarifas Grupales
const dias = {};
      console.log("NOT AVAILABLE",this.groupRoomCodesNotAvail);
      if(this.groupRoomCodesNotAvail.length > 0){
          const roomcodedays= [];
          var stringUnavailableRates='';
          if (resObject.data.response.publicRates.length === 0 && resObject.data.response.negotiatedRates.length === 0){
            
            if(this.groupRoomCodesNotAvail.length > 1){
              let resultado = "";
             
              
              this.groupRoomCodesNotAvail.forEach(item => {
              const roomName = item.roomName;
              const datesArray = item.dates.split(',').filter(date => date !== "");

              const dias = {}; // Usamos un objeto para almacenar los días únicos
              if(this.language.data == 'es') {
              datesArray.forEach(date => {
                  const day = date.substring(0, 2); // Extraemos los dos primeros caracteres que representan el día
                  dias[day] = true; // Utilizamos el día como clave del objeto
              });
            }
            else{
              datesArray.forEach(date => {
                  const day = date.substring(3, 5); // Extraemos los dos primeros caracteres que representan el día
                  dias[day] = true; // Utilizamos el día como clave del objeto
              });
            }
              const diasAgrupadosOrdenados = Object.keys(dias).sort((a, b) => parseInt(a) - parseInt(b)); // Ordenamos los días
              roomcodedays.push({'roomName':roomName,'dia':diasAgrupadosOrdenados});
            
              resultado += "\n" + roomName + ": ";
              diasAgrupadosOrdenados.forEach(dia => resultado += dia + ", ");
              
              });
              console.log("RESULTADO",roomcodedays)
              const diasIguales = roomcodedays.every((item, index, array) => {
                  return JSON.stringify(item.dia) === JSON.stringify(array[0].dia);
              });
              console.log(diasIguales)
              if(diasIguales){
                this.isModalNoTarifas = true;
                const diasModal = roomcodedays[0].dia.join(', ');
                console.log(diasModal)
                this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body3');
                this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
                this.roomCodesNotAvail = diasModal;
              }
              else{
                const resultado = {};
                roomcodedays.forEach(item => {
                    const roomName = item.roomName;
                    const dias = new Set(item.dia); // Convertimos el array de días en un Set para eliminar los días repetidos

                    // Si el roomName ya existe en el objeto resultado, agregamos los días al Set existente
                    // Si no existe, creamos un nuevo Set con los días
                    if (resultado[roomName]) {
                        dias.forEach(dia => resultado[roomName].add(dia));
                    } else {
                        resultado[roomName] = new Set(dias);
                    }
                });
                
                var soloDias = '';
                // Convertimos el objeto resultado en un formato legible
                const stringResultado = Object.entries(resultado).map(([roomName, dias]) => {
                    const diasString = [...dias].join(', '); // Convertimos el Set de días en un string separado por coma y espacio
                    soloDias = diasString;
                    return `${roomName}: ${diasString}`;
                }).join('\n'); // Unimos cada elemento con un salto de línea
                console.log("RESI:TADP",resultado)
                if(Object.keys(resultado).length > 1){
                this.isModalNoTarifasDias = true;
                this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body5');
                this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
                this.roomCodesNotAvail = stringResultado; 
                }
                else
                {
                  this.isModalNoTarifas = true;
                  this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body3');
                  this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
                  this.roomCodesNotAvail = soloDias;
                }
              }
              
            }
            else{

            console.log(this.paragraph1);
              
            this.isModalNoTarifas = true
            
            this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResults.body3');
            this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResults.body4');
            
                        // Dividir la cadena en fechas usando la coma como delimitador
            const fechasArray =  dates.split(',');
            console.log(fechasArray);
            const dias = fechasArray.map(fecha => {
                // Dividir la fecha en día, mes y año
                const partesFecha = fecha.split("/");
                // Obtener el día (la primera parte)
                return partesFecha[0];
            });
            // Filtrar elementos vacíos y convertir los días en un conjunto para obtener valores únicos
            const diasUnicos = new Set(dias.filter(dia => dia !== ""));

            // Convertir el conjunto de días únicos nuevamente en un array y ordenarlo de menor a mayor
            const diasAgrupadosOrdenados = Array.from(diasUnicos).sort((a, b) => parseInt(a) - parseInt(b));

            console.log(diasAgrupadosOrdenados);
            this.roomCodesNotAvail = diasAgrupadosOrdenados.toString().concat(",");
            console.log(">>>> Mensaje Categoria y dates: "+ diasAgrupadosOrdenados);
          }
            // this.roomCodesNotAvail = this.groupRoomCodesNotAvail;
            
          }else{
            console.log(">>>> categorias disponibles: "+ availableCategories);
            stringUnavailableRates = this.groupRoomCodesNotAvail;
            const itemsFound =   stringUnavailableRates.filter(item => !availableCategories.includes(item));     
            console.log("No disponibles",itemsFound)
            
            const groupedArray = itemsFound.reduce((accumulator, currentValue) => {
                  if (!accumulator.includes(currentValue)) {
                      accumulator.push(currentValue);
                  }
                  return accumulator;
              }, []);
              console.log(groupedArray);
              this.roomCodesNotAvail = groupedArray; 
              
            if(Object.keys(itemsFound).length > 0){
            this.isModalNoTarifasGrpRooms = true;
            if(this.groupRoomCodesNotAvail.length > 1){
              
            console.log("<<<<<<<modal not availables rooms>>>>>>>>>");
              this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body1');
              this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body3');
            }else{
              
              this.paragraph1 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body2');
              this.paragraph2 = i18n.t('language.posadasCorporate.modales.noResultsRoomGpo.body4');
            }
          }
          else{
            this.codeDetailing()
          }
          }
           
            
       } 
       else{
        console.log("Code detailing 2")
        this.codeDetailing()
       }
       //Fin CRTarifas Grupales
      }    
// Fin de Seulment negociatedRates, NO publicRates

       if(resObject.data.response.negotiatedRates.length != 0 && resObject.data.response.publicRates.length != 0) {
          var ls = new SecureLS({encodingType: 'aes'});
        this.responseSpecialMessageForDiscounts = resObject.data.response.specialMessageForDiscounts

 ls.set('specialMessageR',{data: resObject.data.response.specialMessageForDiscounts})
 
          if(resObject.data.response.specialMessageForDiscounts == "N/A") {
          this.specialMessageUp = false
          this.$store.commit("specialMessageForDiscounts", {data: "N/A"})
        } else {
                   this.specialMessageUp = true
          this.$store.commit("specialMessageForDiscounts", {data: resObject.data.response.specialMessageForDiscounts})

        }
       this.contractCodes = []                                                                  
       for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
         this.contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
         }
       for(var i = 0; i < resObject.data.response.publicRates.length; i++) {
         this.contractCodes.push(resObject.data.response.publicRates[i].contractCode)
         }
var names = this.contractCodes.reduce(function (a, b) {
 if (a.indexOf(b) == -1) {
   a.push(b)
 }
 return a;
}, []);
this.contractCodes = names
ls.set('contractCodesLangProblem', {data: this.contractCodes})
         this.codeDetailing()
       }
      }
      }
  }    
 
   if(resObject.status == 401 || resObject.status == 403) {
     this.isExpiredModalVisible = true
     this.clearLocalStorage()
   }
         })
    .catch(error=>{
      console.log(error)
    let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 404 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
       this.$router.push({ name: "Error" });
} 
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
      this.enableLoader = false
if (error.response.status == 401 || error.response.status == 403) {
   this.clearLocalStorage()
} 
      var n = error.response.data.message.indexOf("\n\n")
      this.paragraph1 = error.response.data.message.substring(0,n)
      this.paragraph2 = error.response.data.message.substring(n+1)
      if(error.response.status == 400 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_05')  {
        this.isModalErroresCodigos = true
      } 
      if(error.response.status == 400 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_04')  {
        this.isModalErroresCodigos = true
      }  
      if(error.response.status == 400 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_03')  {
        this.isModalErroresCodigos = true
      }  
      if( (error.response.status == 404) && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_01')  {
        this.isModalNoTarifas = true
this.entrada = ''
 this.salida = ''
 this.adultos = 1
 this.menores = 0
 this.infantes = 0
this.habitaciones = 1
 this.agreementCode = ''  
 this.iata = ''
 this.motiva = ''
this.descuento = ''
 this.promocion = ''
this.roomCodesListings = []
 var picked = ''
 
      // Reservaciones
      var availibilityRequest = {
    
    hotelName: '',
      hotelCode: '',
	arrivalDate: '',
	departureDate: '',
currencyCode: this.curC,
	totalAdults: 1,
	totalChildren: 0,
	totalInfants: 0,
	totalRooms: 1,
	agreementCode: '',  
	iataCode: '',
	motivaCode: '',
	discountCode: '',
	promoCode: '',
	profileType: '',
  roomCodeList: [],
  selectedRooms: [],
  beautiDateInput:   '',
    beautiDateOutput:   ''
  }
         var ls = new SecureLS({encodingType: 'aes'});
  ls.set('availibilityRequest', {data: availibilityRequest});
      }  
      
      this.validateCode()

})
      },
      discounts() {
    
    var a = "";
    a = this.ls.get("Token");
    var token = a.data.substr(1);
    axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_USER + `${this.ls.get('Profile').data.username}` + process.env.VUE_APP_HOMECONFIG, {
    userType:  this.ls.get('Profile').data.userType,
    profileType: this.ls.get('Profile').data.profileType
  }, {
       withCredentials: true,
         credentials: 'include',
      headers: {'Authorization': 'Bearer ' + token,
                  'Content-Type' : 'application/json',
                  'Accept-Language' : this.ls.get("Language").data
                  }
         })
  .then(res => {
         var resObject=JSON.parse(JSON.stringify(res));
     if ( resObject.status == 200 || resObject.status == 201) {
       this.showIATA2 = resObject.data.response.showIATA
       this.showMotiva2 = resObject.data.response.showMotiva
       this.showAgreement2 = resObject.data.response.showAgreement 
       
      if(resObject.data.response.requiredIATA) {
          this.IATAL = "IATA*"
        this.IATANeeded = true

        
            this.IATAObliga = true
                    this.ls.set('IATAREQUIRED', {data: true}); // set key1
         
      } else {
          this.IATAL = "IATA"

                    this.IATAObliga = false
            this.IATANeeded = false
                    this.ls.set('IATAREQUIRED', {data: true}); // set key1
      }
     }    
     if(resObject.status == 401) {
     this.clearLocalStorage()
     }
           })
      .catch(error=>{
        // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
let errorObject=JSON.parse(JSON.stringify(error));
if (errorObject.message == 'Request failed with status code 401') {
     this.clearLocalStorage()
}
})
      },
       configAvailibility() {
      var a = "";
      a = this.ls.get("Token");
      var token = a.data.substr(1);
  
      // Modify modal "Rooms" section configuaration
      axios
        .get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_HOTEL +
            `/${this.hotelCode}/` +
            process.env.VUE_APP_CONFIG,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + token,
              "Accept-language": this.ls.get("Language").data
            }
          }
        )
        .then(res => {
          if (res.status == 200 || res.status == 201) {
            this.personas = this.adultos + this.menores + this.infantes;
            this.ouiLesF = res.data.response.infantsAllowed;
            this.ouiLesG = res.data.response.childrenAllowed;
           
            this.maxRoomsAllowed = res.data.response.maxRooms;
            this.maxAdultsAllowed = res.data.response.maxAdults;
          this.ls.set("hotelConfiguration", res.data.response.roomList)
          this.roomListings = res.data.response.roomList;
          }
          if (res.status == 401) {
            this.clearLocalStorage();
          }
        })
        .catch(error => {
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
      politicaViajeRazonSocial(){
        const profile = this.ls.get('Profile').data;
      
        var dataPoliticas = {
          userType: profile.userType,
          contractType: this.contractTypeForPol, 
          discountCode: this.codDiscount  
        };
        GlobalServices._consultaPoliticasViaje(dataPoliticas, this.ls.get('Token').data, this.ls.get('Language').data).then(reponsePoliticas => {
          if( reponsePoliticas.data.length == 0) {
            var listTemp = [];
            listTemp.push({ nombre: "", code: ""});
          this.vaucher.politicas = listTemp;
          this.credito.politicas = listTemp;
          this.tiempoLimite.politicas = listTemp;
          this.creditoEmpresa.politicas = listTemp;
          this.token.politicas = listTemp;
          
          this.politicasList = listTemp;
              
          } else {
          var listTemp = [];
          for (let  pol of reponsePoliticas.data) {
            listTemp.push({ nombre: pol.policyName, code: pol.policyCode});
          }
          this.vaucher.politicas = listTemp;
          this.credito.politicas = listTemp;
          this.tiempoLimite.politicas = listTemp;
          this.creditoEmpresa.politicas = listTemp;
          this.token.politicas = listTemp;

          this.politicasList = listTemp;
          } 
          this.politicaSelectedDefault(listTemp);
        }).catch(error => {
            var listTemp = [];
            listTemp.push({ nombre: "", code: ""});
          this.vaucher.politicas = listTemp;
          this.credito.politicas = listTemp;
          this.tiempoLimite.politicas = listTemp;
          this.creditoEmpresa.politicas = listTemp;
          this.token.politicas = listTemp;
                            // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if (error.status === 401) {
            this.clearLocalStorage();
          }
        });
        //Start KB44128  (profile.ratesPermissionsResponse.showINT) 
        var contractTypeProfile = "";
        if (profile.profileId == "POSADAS" ){
          contractTypeProfile= "1";
        }else{
          contractTypeProfile= this.hotelReservationByCode.roomContractTypeCode;
        }
        var dataRazones = {
          iata: this.lackingIata,      // Get this
          agreement: this.lackingAgreement, 
          discount: this.codDiscount ,
          showINT: false,
          contractType: contractTypeProfile
        //End KB44128 
        };
        GlobalServices._consultaRazonesSociales(dataRazones, this.ls.get('Token').data, this.ls.get('Language').data).then(responseRazones => {
          var listTemp = [];
          for (let raz of responseRazones.data) {
            listTemp.push({ razonSe: raz.agencyBusinessName, nombre: raz.agencyName, code: raz.agencyKey, agencyAddress: raz.agencyAddress, agencyPhone: raz.agencyPhone, agencyRFC: raz.agencyRFC, agencyType: raz.agencyType});
          }
          this.vaucher.razones = listTemp;
          this.credito.razones = listTemp;
          this.tiempoLimite.razones = listTemp;
          this.creditoEmpresa.razones = listTemp;
          this.token.razones = listTemp;
          this.razonSelectedDefault(listTemp);
        }).catch(error => {
                              // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if (error.status === 401) {
            this.clearLocalStorage();
          }
        }); 
      },
      politicaSelectedDefault(listPoliticas){
        if (listPoliticas.length > 0) {
          this.politicaSelectedDefault2(listPoliticas);
          for (var list of listPoliticas) {
            if (list.code === '-1') {
              this.banPoliticaSelectedDefault = true;
              this.vaucher.politicaSeleccionada = list.nombre;
              this.vaucher.politicaSeleccionadaCode = '-1';

              this.creditoEmpresa.politicaSeleccionada = list.nombre;
              this.creditoEmpresa.politicaSeleccionadaCode = '-1';

              this.credito.politicaSeleccionada = list.nombre;
              this.tiempoLimite.politicaSeleccionada = list.nombre;
              this.token.politicaSeleccionada = list.nombre;

              this.banSelectedPoliticaVaucher =  true;
              this.banSelectedPoliticaCredito =  true;
              this.banSelectedPoliticaToken = true;
              this.banSelectedPoliticaCreditoEmpresa =  true;
              this.banSelectedPoliticaTiempoLimite =  true;
            }
          }
        }
      },
      razonSelectedDefault(listRazones){
        if (listRazones.length > 0) {
          this.razonSelectedDefault2(listRazones);
          for (var list of listRazones) {
        	//Inicio KB25711-26937
        	//Responsable: Denise Mendez
        	//Seleccionar razon social seleccionada en la creacion
              if(this.hotelReservationByCode.socialReasonResponse != null 
            		  && this.hotelReservationByCode.socialReasonResponse.agencyName === list.nombre){
                this.vaucher.razonSeleccionada = list.nombre;
                this.vaucher.razonSeleccionadaCode = list.code;

                this.creditoEmpresa.razonSeleccionada = list.nombre;
                this.creditoEmpresa.razonSeleccionadaCode = list.code;

                this.credito.razonSeleccionada = list.nombre;
                this.tiempoLimite.razonSeleccionada = list.nombre;
                this.token.razonSeleccionada = list.nombre;

                 this.banRazonSelectedDefault = true;
              }
              //Fin KB25711-26937
            if (!this.banRazonSelectedDefault) {  //Inicio KB25711-26937 prevenir seleccion Ninguna
              if (list.code === '-1') {
                this.banRazonSelectedDefault = true;
                this.vaucher.razonSeleccionada = list.nombre;
                this.vaucher.razonSeleccionadaCode = '-1';

                this.creditoEmpresa.razonSeleccionada = list.nombre;
                this.creditoEmpresa.razonSeleccionadaCode = '-1';

                this.credito.razonSeleccionada = list.nombre;
                this.tiempoLimite.razonSeleccionada = list.nombre;
                this.token.razonSeleccionada = list.nombre;
              }
            } //Fin KB25711-26937  
          }
        }
      },
      politicaSelectedDefault2(listPoliticas){
        if (listPoliticas.length === this.contPoliticaSelectedDefault) {
          if (!this.banPoliticaSelectedDefault) {
            this.vaucher.politicaSeleccionada = listPoliticas[0].nombre;
            this.vaucher.politicaSeleccionadaCode = listPoliticas[0].code;

            this.creditoEmpresa.politicaSeleccionada = listPoliticas[0].nombre;
            this.creditoEmpresa.politicaSeleccionadaCode = listPoliticas[0].code;

            this.credito.politicaSeleccionada = listPoliticas[0].nombre;
            this.tiempoLimite.politicaSeleccionada = listPoliticas[0].nombre;
            this.token.politicaSeleccionada = listPoliticas[0].nombre;

            this.banSelectedPoliticaVaucher =  true;
            this.banSelectedPoliticaCredito =  true;
            this.banSelectedPoliticaToken = true;
            this.banSelectedPoliticaCreditoEmpresa =  true;
            this.banSelectedPoliticaTiempoLimite =  true;
          }
        } else {
          setTimeout(() => {
            this.politicaSelectedDefault2(listPoliticas);
            this.contPoliticaSelectedDefault++;
          }, 10);
        }
      },
      razonSelectedDefault2(listRazon){
        if (listRazon.length === this.contRazonSelectedDefault) {
          if (!this.banRazonSelectedDefault) {
            this.vaucher.razonSeleccionada = listRazon[0].nombre;
            this.vaucher.razonSeleccionadaCode = listRazon[0].code;

            this.creditoEmpresa.razonSeleccionada = listRazon[0].nombre;
            this.creditoEmpresa.razonSeleccionadaCode = listRazon[0].code;

            this.credito.razonSeleccionada = listRazon[0].nombre;
            this.tiempoLimite.razonSeleccionada = listRazon[0].nombre;
            this.token.razonSeleccionada = listRazon[0].nombre;
          }
        } else {
          setTimeout(() => {
            this.razonSelectedDefault2(listRazon);
            this.contRazonSelectedDefault++;
          }, 10);
        }
      },
      closeExpiredModal() {
      this.isExpiredModalVisible = false;
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
       clearLocalStorage() {
      this.isExpiredModalVisible = true;
    },
    setCompanyDataH1(data) {
        let companyDataH1 = {};
        companyDataH1.name = (data.companionName==null?'':data.companionName);
        companyDataH1.lastName = (data.companionFatherSurname==null?'':data.companionFatherSurname);
        companyDataH1.secondLastName = (data.companionMotherSurname==null?'':data.companionMotherSurname);
        companyDataH1.email = (data.companionMail==null?'':data.companionMail);
        this.ls.set('CompanyDataH1', companyDataH1);
      },
      callByCode(numConfir) {
        this.dCou = 1;
              var a = "";
      a = this.ls.get("Token");
      var token = a.data.substr(1);
      this.numConfirWS = numConfir
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_CODE,
          {
            confirmationNumber: numConfir,
            profileType: this.ls.get("Profile").data.profileType,
            hasEditCancelPermissions: this.ls.get("editCancelPermissions"),
            fullReservationData: true
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + token,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.setCompanyDataH1(res.data.response);
          this.hotelReservationByCode = res.data.response;
          this.ls.set('hotelReservationByCodeModd', res.data.response);
          var resObject = JSON.parse(JSON.stringify(res));
          this.montreModal = resObject
          setTimeout(() => {
            this.details(2)
          }, 10);
          if (resObject.data.response.roomContractTypeName == "Tarifa Negociada" || resObject.data.response.roomContractTypeName == "Negotiated Rate") {
            this.tipoTarifa = 1
          }
          if (resObject.data.response.roomContractTypeName == "Tarifa Pública" || resObject.data.response.roomContractTypeName == "Public Rate") {
            this.tipoTarifa = 2
          }
          this.chargeModalConfir(resObject)
          var arrow = []
          this.tabActiveFR = resObject.data.response.roomContractTypeName
          if(this.montreModal.data.response.rateOptionalSupplementResponseList != null) {
            for(var i =0; i < this.montreModal.data.response.rateOptionalSupplementResponseList.length; i++) {
              arrow.push({reqOpcional: this.montreModal.data.response.rateOptionalSupplementResponseList[i]})
            }
          }
          this.$store.commit('listRequeOpcionalesSeleccionadosForConfir', arrow)
          this.ls.set('updateTotalStay', []) 
          if (resObject.status == 200 || resObject.status == 201) {
              this.initialLoader = true

            var datSelected = resObject.data.response.hotelDetailResponse;
            if (datSelected.specialMessage != null && datSelected.specialMessage.length > 0) {
              this.banConsiEspe = true;
              this.considEspe = datSelected.specialMessage[0];
            }
            if(res.data.response.specialMessage != null) {
              this.specialMess = res.data.response.specialMessage
            }
this.enableProfGH = res.data.response.showSendProform
this.textPromo = res.data.response.roomContractTextName


// GET MANDATORY SUPPLEMENTS

var manSuppF = res.data.response.ratesResponse.ratesDetailResponseList
var inter = [
      {
        "supplementCode": "HL",
        "supplementName": "HL",
        "date": "24/03/2020",
        "startDate": null,
        "endDate": null,
        "quantityType": 8,
        "quantityValue": 1,
        "quantityTypeText": "",
        "unitPriceType": "F",
        "unitPriceValue": 99.8,
        "numSuppleCharged": 1,
        "commOffsetType": "N",
        "commOffsetValue": 0.0,
        "commAmount": 0.0,
        "mandatory": false,
        "rateIncluded": false,
        "supplementDescription": "HL",
        "amount": 99.8,
        "rateSupplementTaxesResponseList": [
          {
            "taxCode": "IVA",
            "taxValue": 0.0,
            "taxAmount": 15.968
          }
        ]
      },
      {
        "supplementCode": "SPA",
        "supplementName": "Masaje por estancia",
        "date": "25/03/2020",
        "startDate": null,
        "endDate": null,
        "quantityType": 2,
        "quantityValue": 1,
        "quantityTypeText": "",
        "unitPriceType": "F",
        "unitPriceValue": 1200.55,
        "numSuppleCharged": 1,
        "commOffsetType": "N",
        "commOffsetValue": 0.0,
        "commAmount": 0.0,
        "mandatory": false,
        "rateIncluded": false,
        "supplementDescription": "Masaje por estancia",
        "amount": 1200.55,
        "rateSupplementTaxesResponseList": [
          {
            "taxCode": "IVA",
            "taxValue": 0.0,
            "taxAmount": 15.968
          }
        ]
      },
      {
        "supplementCode": "TOUR",
        "supplementName": "Transportación",
        "date": "25/03/2020",
        "startDate": null,
        "endDate": null,
        "quantityType": 6,
        "quantityValue": 1,
        "quantityTypeText": "",
        "unitPriceType": "F",
        "unitPriceValue": 550.0,
        "numSuppleCharged": 1,
        "commOffsetType": "N",
        "commOffsetValue": 0.0,
        "commAmount": 0.0,
        "mandatory": false,
        "rateIncluded": false,
        "supplementDescription": "Transportación",
        "amount": 550.0,
        "rateSupplementTaxesResponseList": [
          {
            "taxCode": "IVA",
            "taxValue": 0.0,
            "taxAmount": 15.968
          }
        ]
      }
    ]
this.descriptionMS = ""
var obSupp = [] 
for(var i = 0; i < manSuppF.length; i++) {
  if(manSuppF[i].rateMandatorySupplementResponseList != null) {
    for(var j = 0; j < manSuppF[i].rateMandatorySupplementResponseList.length; j++) {
      // Get all supplemets
      obSupp.push({ quantity: manSuppF[i].rateMandatorySupplementResponseList[j].numSuppleCharged, name: manSuppF[i].rateMandatorySupplementResponseList[j].supplementName})
  
   }   
  } 
}
var obSupp2 = obSupp
let uniqueSupp = obSupp.map(item => item.name)
  .filter((value, index, self) => self.indexOf(value) === index)
    var counter = {}
    obSupp2.forEach(function(obj) {
    var key = JSON.stringify(obj)
    counter[key] = (counter[key] || 0) + 1
    })
// Assign number to specific key
for(var i = 0; i < Object.keys(counter).length; i++) {
            var letJson = JSON.parse(Object.entries(counter)[i][0])
            var timesS = Object.entries(counter)[i][1]
           this.descriptionMS += letJson.quantity * timesS 
           this.descriptionMS += " "
           this.descriptionMS += letJson.name
           this.descriptionMS += ", "
}
// Print mandatory texts

           this.descriptionMS = this.descriptionMS.trim()
           this.descriptionMS = this.descriptionMS.slice(0, -1); 
this.ls.set("descriptionMS", this.descriptionMS)
// GET SUPPLEMENTS OPTIONAL
if(res.data.response.rateOptionalSupplementResponseList != null && res.data.response.rateOptionalSupplementResponseList != 0) {
  this.listRequeOpcionalesE = res.data.response.rateOptionalSupplementResponseList
}
              var responseHotel = {
              response: res.data.response.hotelDetailResponse
            }
            this.ls.set('DetailHotelInfo', {data: responseHotel});

   if(resObject.data.response.iataCode != null) {
      this.lackingIata = resObject.data.response.iataCode
      this.ls.set("iataL", this.lackingIata)
   } 
    if(resObject.data.response.agreement != null) {
      this.lackingAgreement = resObject.data.response.agreement
      this.ls.set("agreementL", this.lackingIata)

   } 
   this.ls.set('emailManquant', resObject.data.response.email[0])
   this.roomContractTypeNameW = resObject.data.response.roomContractTypeName
    if(resObject.data.response.roomContractTypeName == "Tarifa Negociada" || resObject.data.response.roomContractTypeName == "Negotiated Rate") {
                this.tabActive = 1
            }
            if(resObject.data.response.roomContractTypeName == "Tarifa Pública" || resObject.data.response.roomContractTypeName == "Public Rate") {
                this.tabActive = 2
            }
        const profile = this.ls.get('Profile').data;

              
          this.data.confirmationNumber = this.numConfirWS,
          this.data.profileType = profile.profileType,
          this.data.hasEditCancelPermissions = true,
          this.data.fullReservationData = true
        
var d1 = resObject.data.response.arrivalDate
var d2 = resObject.data.response.departureDate
this.data1.roomType= "";
this.data1.selectedRooms= [1];
this.data1.brandCode= resObject.data.response.brandCode;
this.data1.hotelName= resObject.data.response.hotelName;
this.data1.beautiDateInput =  resObject.data.response.arrivalDate;
this.data1.beautiDateOutput = resObject.data.response.departureDate;
              this.data1.hotelCode= resObject.data.response.hotelCode;
              this.data1.arrivalDate= resObject.data.response.arrivalDate;
              this.data1.departureDate= resObject.data.response.departureDate;
              this.data1.currencyCode= resObject.data.response.currencyCode;
              this.curC = resObject.data.response.currencyCode
              this.data1.totalAdults= resObject.data.response.totalAdults;
              this.adultos = this.data1.totalAdults
              this.data1.totalChildren= resObject.data.response.totalChildren;
              this.menores = this.data1.totalChildren
              this.data1.totalInfants= resObject.data.response.totalInfants;
              this.infantes = this.data1.totalInfants
              this.sumPersonas = this.infantes + this.menores + this.adultos
              this.data1.totalRooms= resObject.data.response.totalRooms;
              this.data1.agreementCode= "";
              this.data1.iataCode= "";
              this.data1.motivaCode=  this.motivaWS;
              this.data1.discountCode= this.descuento;
              this.data1.promoCode = resObject.data.response.promoCode;
              if(resObject.data.response.promoCode == null) {
                  this.data1.promoCode = ""
              }
              this.promocion = this.data1.promoCode
              this.data1.profileType= profile.profileType;
              this.data1.showPublicRates= ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showPublicRates);
              this.data1.showRates= ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showRates);
              this.data1.contractCode= resObject.data.response.roomContractCode;
              this.data1.roomCodeList=[resObject.data.response.roomCode]
            

   this.brandCode = resObject.data.response.brandCode
   this.hotelCode = resObject.data.response.hotelCode
   this.requirementsByCode = resObject.data.response.requirementResponseList
   this.getRequirements()
   this.ls.set("hotelCodeROWS", this.hotelCode)
   this.roomContractCode = resObject.data.response.roomContractCode
   this.ls.set("contractCodeROWS", this.roomContractCode)
   this.creditoEmpresa.folio = (resObject.data.response.cupon===null||resObject.data.response.cupon===undefined?'':resObject.data.response.cupon)
   this.vaucher.folio = (resObject.data.response.cupon===null||resObject.data.response.cupon===undefined?'':resObject.data.response.cupon)
          this.motivaWS = resObject.data.response.motivaNumber
          this.ls.set('motivaNumber', this.motivaWS)
         this.ls.set("motivaReadOnly", this.motivaWS)
this.ls.set("dailyRate",resObject.data.response.ratesResponse.ratesDetailResponseList[0].roomCostWithTaxes)
   
this.ls.set("totalCostWithTaxesF",resObject.data.response.ratesResponse.totalCostWithTaxes)

   this.hotelName = resObject.data.response.hotelName
         this.ls.set("hotelNameReadOnly", this.hotelName)
         this.ls.set("typeNameRO", resObject.data.response.roomContractTypeName)
       
         this.arrivalDate = resObject.data.response.arrivalDate
         this.arrivalCDate = resObject.data.response.arrivalDate

         this.ls.set("arrivalDateReadOnly", this.arrivalDate)
         this.departureDate = resObject.data.response.departureDate
         this.departureCDate = resObject.data.response.departureDate
       this.ls.set("departureDateReadOnly", this.departureDate)
  if (this.ls.get('Language').data == 'es') {
    this.entrada = new Date (this.arrivalDate.substring(6,10), this.arrivalDate.substring(3,5) - 1, this.arrivalDate.substring(0,2));
    this.salida = new Date (this.departureDate.substring(6,10), this.departureDate.substring(3,5) - 1, this.departureDate.substring(0,2));
  } else {  
    this.entrada = this.arrivalDate
    this.salida = this.departureDate
  }
         this.numberOfNights = resObject.data.response.numberOfNights
         this.ls.set("nightsReadOnly", this.numberOfNights)

         this.totalRooms = resObject.data.response.totalRooms
         this.ls.set("totalRoomsReadOnly", this.totalRooms)

         this.totalAdults = resObject.data.response.totalAdults
         this.totalChildren = resObject.data.response.totalChildren
         this.totalInfants = resObject.data.response.totalInfants
         this.totalGuests = resObject.data.response.totalAdults + resObject.data.response.totalChildren + resObject.data.response.totalInfants
         this.ls.set("totalGuestsReadOnly", {data: {
           totalAdults: this.totalAdults,
           totalChildren: this.totalChildren,
           totalInfants: this.totalInfants
         }})
     if(resObject.data.response.discountCode == null) {
          this.codDiscount = ""
          this.ls.set("discountCodeRO", this.codDiscount)
          this.desTe = ""
        if(resObject.data.response.promoCode == null) {
          this.promocion = ""
          this.desTe = ""

          this.ls.set("promoCodeRO", this.promocion)
        } else {
          this.promocion = resObject.data.response.promoCode
          this.ls.set("promoCodeRO", this.promocion)
          this.desTe = resObject.data.response.promoCode

        }
     
        } else {
          this.codDiscount = resObject.data.response.discountCode
          this.ls.set("discountCodeRO", this.codDiscount)
          this.desTe = resObject.data.response.discountCode

        }
        this.descuento = this.codDiscount
        if(resObject.data.response.fatherSurname == null) {
            var fatherSurname = ""
        } else {
          var fatherSurname = resObject.data.response.fatherSurname
          this.fatherSurname = resObject.data.response.fatherSurname
        }
        if(resObject.data.response.motherSurname == null) {
            var motherSurname = ""
        } else {
          var motherSurname = resObject.data.response.motherSurname
          this.motherSurname =resObject.data.response.motherSurname
        }

        // Companion name
           if(resObject.data.response.companionName == null) {
            var companionName = ""
        } else {
          var companionName = resObject.data.response.companionName
        }
   if(resObject.data.response.companionFatherSurname == null) {
            var companionFatherSurname = ""
        } else {
          var companionFatherSurname = resObject.data.response.companionFatherSurname
        }
        if(resObject.data.response.companionMotherSurname == null) {
            var companionMotherSurname = ""
        } else {
          var companionMotherSurname = resObject.data.response.companionMotherSurname
        }
        this.realName = resObject.data.response.name 
        this.middleName = resObject.data.response.middleName
        this.fatherSurname = fatherSurname
        this.motherSurname = motherSurname
        this.name = resObject.data.response.name.concat(" " + fatherSurname).concat(" " + motherSurname)
         var fullCompanionName = companionName.concat(" " + companionFatherSurname).concat(" " + companionMotherSurname)
     
      var namesRO = {
            name : resObject.data.response.name,
            fatherSurname: fatherSurname,
            motherSurname: motherSurname,
            fullName: this.name
          }
          var companionRO = {

            companionName: resObject.data.response.companionName,
            companionFatherSurname: companionFatherSurname,
            companionMotherSurname: companionMotherSurname,
            fullName: fullCompanionName
          }
         this.ls.set("nameReadOnly", namesRO)
         this.ls.set("companionReadOnly", companionRO)
         this.ratesResponse = resObject.data.response.ratesResponse
        this.guestProfileId = resObject.data.response.guestID
        if (this.guestProfileId != null && this.guestProfileId != '') {
          this.guestProfile()
        }
        if(resObject.data.response.fiestaRewardsNumber != null && resObject.data.response.fiestaRewardsNumber != "") {
          this.fiestaRewardsNumber = resObject.data.response.fiestaRewardsNumber.toUpperCase()
          this.consultFiestaRewards();
          this.banMemFR = true;
        }
             if(resObject.data.response.apreciareClubNumber!= null && resObject.data.response.apreciareClubNumber != "") {
         
        this.apreciareClubNumber = resObject.data.response.apreciareClubNumber.toUpperCase()

        }
        
        this.roomCode = resObject.data.response.roomCode
        this.amenityListWS = resObject.data.response.hotelDetailResponse.amenityList
        this.brandImage = resObject.data.response.hotelDetailResponse.brandImage
        this.brandName = resObject.data.response.brandName
        this.posCode = resObject.data.response.poscode
        this.hotelAddress = resObject.data.response.hotelDetailResponse.hotelAddress
        this.hotelFax = resObject.data.response.hotelDetailResponse.hotelFax
        this.hotelImage = resObject.data.response.hotelDetailResponse.hotelMailImage
        this.hotelName = resObject.data.response.hotelDetailResponse.hotelName 
        this.roomCode = resObject.data.response.roomCode 
        this.costCenter = resObject.data.response.costCenter
        this.employeeNumber = resObject.data.response.employeeNumber
        this.telephone22 = resObject.data.response.hotelDetailResponse.hotelPhone
        if(resObject.data.response.companionName != null) {

          this.acompananteFirstName = resObject.data.response.companionName
        }
        if(resObject.data.response.companionFatherSurname != null) {

          this.companionFatherSurname = resObject.data.response.companionFatherSurname
        }
        if(resObject.data.response.companionMotherSurname != null) {

          this.companionMotherSurname = resObject.data.response.companionMotherSurname
        }
      

        for(var i = 0; i < resObject.data.response.hotelDetailResponse.roomDetailResponseList.length; i++) {
            if(resObject.data.response.hotelDetailResponse.roomDetailResponseList[i].roomCode == this.roomCode) {

              this.roomImage =  resObject.data.response.hotelDetailResponse.roomDetailResponseList[i].roomImage
              this.roomName = resObject.data.response.hotelDetailResponse.roomDetailResponseList[i].roomName
            }
        }
        for(var i = 0; i < resObject.data.response.hotelDetailResponse.roomDetailResponseList.length; i++) {
          if(resObject.data.response.roomCode == resObject.data.response.hotelDetailResponse.roomDetailResponseList[i].roomCode) {
           this.roomName = resObject.data.response.hotelDetailResponse.roomDetailResponseList[i].roomName
          }
        }
        
        if(this.roomName == "" && this.$store.getters.gettingLang == "es") { 
          this.roomName = "Contenido no disponible"
        } else {

        }
        
        if(this.roomName == "" && this.$store.getters.gettingLang == "en") {
          this.roomName = "Content not available"
        } else {}
        this.ls.set("roomNameRO", this.roomName)
        this.contractTypeForPol = resObject.data.response.roomContractTypeCode 
        this.ls.set("contractTypeRO", this.contractTypeForPol)

        this.totalStay = resObject.data.response.ratesResponse.totalCost//WithTaxes
       this.totalStay = GlobalFunctions.numberFormat(this.totalStay, 2, '.', ',')
        this.ls.set("totalStayRO", this.totalStay)
        this.currencyM = resObject.data.response.currencyCode
        this.totalCostWithoutTaxes =resObject.data.response.ratesResponse.totalCostWithoutTaxes
        this.totalTaxes = resObject.data.response.ratesResponse.totalTaxes
      if(resObject.data.response.benefitsAndRestrictions == null) {
      this.ben = []

      } else {
      this.ben = resObject.data.response.benefitsAndRestrictions

      }
  
      //Beneficios y restricciones
      if (resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList.length > 0) {
        this.rateDescription = (resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].rateDescription===null||resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].rateDescription === undefined?'':resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].rateDescription);
        this.briefD = (resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].rateName===null||resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].rateName===undefined?'':resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].rateName);
        this.bene = (resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].benefits===null||resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].benefits===undefined?'':resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].benefits);
        this.restrictionsFWS = (resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].restrictions===null||resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].restrictions===undefined?'':resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0].restrictions);
      }

      //Emails
      this.emailAlter = resObject.data.response.email

      // START KB41067
      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_GUEST + this.ls.get("Profile").data.profileType,
        {
          withCredentials: true,
          credentials: 'include',
          headers: {
              Authorization: "Bearer " + token,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
        })
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
           
            for (var i = 0; i < resObject.data.response.length; i++) {
             if(this.guestProfileId == resObject.data.response[i].guestProfileId){
               this.emailAlternative = resObject.data.response[i].emailAlternative;
             }
              }
          }
          
        })
        .catch(error => {
        });
      // END KB41067


            this.payMe = resObject.data.response.paymentResponse.paymentMethod
            if(this.payMe == "Tarjeta" || this.payMe == "Token" || this.payMe == "Card") {
              this.isCreditCard = 1
            } else {
              this.isCreditCard = 0

            }
        // Token and credit card
         if((resObject.data.response.paymentResponse.paymentMethod == "Tarjeta" || resObject.data.response.paymentResponse.paymentMethod == "Card")) {
            this.credito.tarjetaSeleccionada = resObject.data.response.paymentResponse.creditCard.cardType
            this.credito.tipoDeMascara = resObject.data.response.paymentResponse.creditCard.cardNumber
            this.credito.numero = resObject.data.response.paymentResponse.creditCard.cardNumber
            this.credito.nombre = resObject.data.response.paymentResponse.creditCard.cardHolderName
            this.credito.expiracion = resObject.data.response.paymentResponse.creditCard.expirationDate.replace('/', '/20')
            this.fechaExpiracionTarCred = resObject.data.response.paymentResponse.creditCard.expirationDate.replace('/', '/20')
            this.iconoActivo = 1
            this.banBan = true;
            this.a()

         } else if((resObject.data.response.paymentResponse.voucher.voucherNumber == "Crédito" || resObject.data.response.paymentResponse.voucher.voucherNumber == "Credit")&&(resObject.data.response.paymentResponse.paymentMethod == "Prepaid_Reservation" || resObject.data.response.paymentResponse.paymentMethod == "Reservación Prepagada")) {
                this.iconoActivo = 4
            this.a() 
         } else if((resObject.data.response.paymentResponse.voucher.voucherNumber == "Tiempo Límite" || resObject.data.response.paymentResponse.voucher.voucherNumber == "Hold Time")&&(resObject.data.response.paymentResponse.paymentMethod == "Prepaid_Reservation" || resObject.data.response.paymentResponse.paymentMethod == "Reservación Prepagada")) {
   this.iconoActivo = 3
            this.a() 
         } else {
           this.iconoActivo = 0
            this.a() 
   
         }
         this.politicaViajeRazonSocial();
        this.configAvailibility();
        this.discounts();
this.consultaMetodosPago()
this.setDataPersonalH1()
          }
        })
        .catch(error => {
          // Error server
          if (
            error.response.status == 404 &&
            error.response.data.errorCode == "RSP_RESERV_SEARCH_CODE_02"
          ) {
            this.noResultsBody = error.response.data.message;
            this.noResults = true;
          }
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });

      },
      outsideRoom(e) {
        this.room = true;
      },
      outsideRooms(e) {
        this.rooms = true;
      },
      clearTipo() {
        if (this.device == 'desktop') {
          this.rooms = true
        } else {
          this.showRoomTypeMobile = false
        }
        this.selected = [];
      },
      clearTipoModal() {
        if (this.device == 'desktop') {
          this.rooms = true
        } else {
          this.showRoomTypeMobile = false
        }
        this.selectedModal = [];
      },
      // buscador
      filteredListRazonesVoucher() {
        return this.vaucher.razonesLista = this.vaucher.razones
      },
      filteredListPoliticasVoucher() {
        return this.vaucher.politicasLista = this.vaucher.politicas
      },
      filteredListRazonesCredito() {
        return this.credito.razonesLista = this.credito.razones
      },
      filteredListPoliticasCredito() {
        return this.credito.politicasLista = this.credito.politicas
      },
      filteredListRazonesToken() {
        return this.token.razonesLista = this.token.razones
      },
      filteredListPoliticasToken() {
        return this.token.politicasLista = this.token.politicas
      },
      filteredListRazonesTiempo() {
        return this.tiempoLimite.razonesLista = this.tiempoLimite.razones
      },
      filteredListPoliticasTiempo() {
        return this.tiempoLimite.politicasLista = this.tiempoLimite.politicas
      },
      filteredListRazonesCreditoEmpresa() {
        return this.creditoEmpresa.razonesLista = this.creditoEmpresa.razones
      },
      filteredListPoliticasCreditoEmpresa() {
        return this.creditoEmpresa.politicasLista = this.creditoEmpresa.politicas
      },
      filteredListCredito() {
        return this.credito.tarjetasLista = this.credito.tarjetas
      },
      filteredListToken() {
        return this.token.tarjetasLista = this.token.tarjetas
      },
      cambiaValue(perfil) {
        return this.habitacion1.search = perfil;
      },
      cambiaTitulo(titulo) {
        return this.habitacion1.tituloDado = titulo;
      },
      cambiaPais(pais) {
        return this.habitacion1.paisSeleccionado = pais;
      },
      cambiaEstado(estado) {
        return this.habitacion1.estadoSeleccionado = estado;
      },
      cambiaHoraIn(horaIn) {
        return this.habitacion1.horaInSeleccionado = horaIn;
      },
      cambiaHoraOut(horaOut) {
        return this.habitacion1.horaOutSeleccionado = horaOut;
      },
      // tipos de habitacions
      handleType(e) {
        if (e.target.checked == false) {
          return this.habitacion1.typePreferent = '';
        } else if(this.$store.getters.gettingLang == "es") {
          this.allRoomTypesT = "Todas las preferencias de habitación"
          return this.habitacion1.typePreferent = 'Todas las preferencias de habitación';
        } else {
          this.allRoomTypesT = "All room types"

            return this.habitacion1.typePreferent = 'All room types';

        }
      },

 
      handleTypeSelect(e, type) {
        if (e.target.checked == false) {

          if(this.habitacion1.selected.length == 1) {
                for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
                  if(this.habitacion1.selected[0] == this.habitacion1.typeRoomsPreferents[ii].id) {
            return     this.habitacion1.typePreferent =     this.habitacion1.typeRoomsPreferents[ii].name
                  }
                }  
            
          }
          if(this.habitacion1.selected.length == 0) {
                return     this.habitacion1.typePreferent = ''
          }
           if(this.habitacion1.selected.length > 1 && this.$store.getters.gettingLang == 'es') {

            return this.habitacion1.typePreferent = 'Ver preferencias de habitación seleccionadas';
          } 
          
            if(this.habitacion1.selected > 1 && this.$store.getters.gettingLang == 'en') {

            return this.habitacion1.typePreferent = 'See selected room types';
          } 
        } else {
          if (this.habitacion1.selected.length > 1) {
            
       if(this.$store.getters.gettingLang == 'es') {

            this.habitacion1.typePreferent =  'Ver preferencias de habitación seleccionadas';
          } else {
            this.habitacion1.typePreferent =  'See selected room types';

          }
          } else {
            this.habitacion1.typePreferent = type;
          }
        }
      },
      handleTypeModal(e) {
        if (e.target.checked == false) {
          return this.tipoHabitacion = '';
        } else {
          if(this.$store.getters.gettingLang == 'es') {
            return this.tipoHabitacion = 'Todas las preferencias de habitación';
          } else {
            return this.tipoHabitacion = 'All room types';
          }
        }
      },
      handleTypeSelectModal(e, type) {
        if (this.selectedModal.length == 1) {
          let room = this.typeRooms.find( room => room.id === this.selectedModal[0]);
          this.tipoHabitacion = room.name;
        } else if(this.selectedModal.length > 1) {
          if(this.$store.getters.gettingLang == 'es') {

            this.tipoHabitacion =  'Ver preferencias de habitación seleccionadas';
          } else {
            this.tipoHabitacion =  'See selected room types';

          }
        } else if(this.selectedModal.length < 1) {
          this.tipoHabitacion = '';
        } 
      },
      // tipos de preferencia extra
      handleTypeExtra(e) {
        if (e.target.checked == false) {
          return this.habitacion1.typePreferentExtra = ''
        } else if(this.$store.getters.gettingLang == "es") {
          this.extraPreferencesT = "Todas las preferencias extras"
          return this.habitacion1.typePreferentExtra = 'Todas las preferencias extras';
        } else {
          this.extraPreferencesT = "All extra preferences"
          return this.habitacion1.typePreferentExtra = 'All extra preferences';
        }
      },
      handleTypeSelectExtra(e, type) {
        if (e.target.checked == false) {
 if(this.habitacion1.selectedExtra.length == 1) {
                for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
                  if(this.habitacion1.selectedExtra[0] == this.habitacion1.typeExtrasPreferents[ii].id) {
            return     this.habitacion1.typePreferentExtra =     this.habitacion1.typeExtrasPreferents[ii].name
                  }
                }  
            
          }
          if(this.habitacion1.selectedExtra.length == 0) {
                return     this.habitacion1.typePreferentExtra = ''
          }


         if(this.habitacion1.selectedExtra.length > 1 && this.$store.getters.gettingLang == 'es') {

            return this.habitacion1.typePreferentExtra = 'Ver preferencias extras seleccionadas';
          } else
          {
          return this.habitacion1.typePreferentExtra = ''

          } 
          
            if(this.habitacion1.selectedExtra > 1 && this.$store.getters.gettingLang == 'en') {

            return this.habitacion1.typePreferentExtra = 'See selected extra preferences';
          }  else
          {
          return this.habitacion1.typePreferentExtra = ''

          } 
        } else {
          if (this.habitacion1.selectedExtra.length > 1) {
             if(this.$store.getters.gettingLang == 'es') {

            this.habitacion1.typePreferentExtra =  'Ver preferencias extras seleccionadas';
          } else {
            this.habitacion1.typePreferentExtra =  'See selected extra preferences';

          }
          } else {
            this.habitacion1.typePreferentExtra = type;
          }
        }
      },
      // Cerrar inputs
      outsideSearch(e) {
        this.habitacion1.buscador = false;
      },
      outsideTitulo(e) {
        this.habitacion1.titulo = false;
      },
      outsidePais(e) {
        this.habitacion1.pais = false;
      },
      outsideEstado(e) {
        this.habitacion1.estado = false;
      },
      outsideHoraIn(e) {
        this.habitacion1.horaIn = false;
      },
      outsideHoraOut(e) {
        this.habitacion1.horaOut = false;
      },
      outsideRoomPreferents(e) {
        this.seeRoomsP()
        this.habitacion1.roomPreferences = true;
      },
      openRoomPreferentType() {
        this.habitacion1.showRoomTypeMobile = true;
      },
      aplicarRoomtype() {
        this.habitacion1.showRoomTypeMobile = false;
      },
      outsidePreferentsExtra(e) {
        this.seeRoomsE()
        this.habitacion1.extraPreferences = true;
      },
      openExtraPreferentType() {
        this.habitacion1.showExtraTypeMobile = true;
      },
      aplicarExtratype() {
        this.habitacion1.showExtraTypeMobile = false;
      },
      /*Eventos para cambios en el ancho de la pagina*/
      getWindowWidth: function (event) {
        this.windowWidth = document.documentElement.clientWidth;
        this.windowWidth > 736 ? this.device = 'desktop' : this.device = 'mobile';
      },
      // Metodo de pago
      // buscador
      cambiaValuePoliticaVoucher(politica, code) {
        this.vaucher.politicaSeleccionadaCode = code;
        this.banSelectedPoliticaVaucher =  true;
        return this.vaucher.politicaSeleccionada = politica;
      },
      cambiaValueRazonVoucher(razon, code) {
        this.vaucher.razonSeleccionadaCode = code;
        return this.vaucher.razonSeleccionada = razon;
      },
      cambiaValuePoliticaCredito(politica) {
        this.banSelectedPoliticaCredito =  true;
        return this.credito.politicaSeleccionada = politica;
      },
      cambiaValueRazonCredito(razon) {
        return this.credito.razonSeleccionada = razon;
      },
      cambiaValuePoliticaToken(politica) {
        this.banSelectedPoliticaToken = true;
        return this.token.politicaSeleccionada = politica;
      },
      cambiaValueRazonToken(razon) {
        return this.token.razonSeleccionada = razon;
      },
      cambiaValuePoliticaTiempo(politica) {
        this.banSelectedPoliticaTiempoLimite =  true;
        return this.tiempoLimite.politicaSeleccionada = politica;
      },
      cambiaValueRazonTiempo(razon) {
        return this.tiempoLimite.razonSeleccionada = razon;
      },
      cambiaValuePoliticaCreditoEmpresa(politica, code) {
        this.creditoEmpresa.politicaSeleccionadaCode = code;
        this.banSelectedPoliticaCreditoEmpresa =  true;
        return this.creditoEmpresa.politicaSeleccionada = politica;
      },
      cambiaValueRazonCreditoEmpresa(razon, code) {
        this.creditoEmpresa.razonSeleccionadaCode = code;
        return this.creditoEmpresa.razonSeleccionada = razon;
      },
      cambiaCredito(tipoTarjeta, a) {
        return this.credito.tarjetaSeleccionada = tipoTarjeta;
      },
      cambiarMascara(tipoTarjeta) {
        switch (tipoTarjeta) {
          case 1:
            return this.credito.tipoDeMascara = '#### ###### #####'
            break;
          case 2:
            return this.credito.tipoDeMascara = '#### ###### ####'
            break;
          default:
            return this.credito.tipoDeMascara = '#### #### #### ####'
            break;
        }
      },
      cambiaToken(tipoTarjeta) {
        return this.token.tarjetaSeleccionada = tipoTarjeta;
      },
      // Cerrar inputs
      outsideSearchPoliticaVoucher(e) {
        this.vaucher.tipoPolitica = false;
      },
      outsideSearchRazonVoucher(e) {
        this.vaucher.tipoRazon = false;
      },
      outsideSearchPoliticaCredito(e) {
        this.credito.tipoPolitica = false;
      },
      outsideSearchRazonCredito(e) {
        this.credito.tipoRazon = false;
      },
      outsideSearchPoliticaToken(e) {
        this.token.tipoPolitica = false;
      },
      outsideSearchRazonToken(e) {
        this.token.tipoRazon = false;
      },
      outsideSearchPoliticaTiempo(e) {
        this.tiempoLimite.tipoPolitica = false;
      },
      outsideSearchRazonTiempo(e) {
        this.tiempoLimite.tipoRazon = false;
      },
      outsideSearchPoliticaCreditoEmpresa(e) {
        this.creditoEmpresa.tipoPolitica = false;
      },
      outsideSearchRazonCreditoEmpresa(e) {
        this.creditoEmpresa.tipoRazon = false;
      },
      outsideCredito(e) {
        this.credito.tipoTarjeta = false;
      },
      outsideToken(e) {
        this.token.tipoTarjeta = false;
      },
    },
    watch: {
      langues() {
 
      },
      apreciareClubNumber() {
          if(this.apreciareClubNumber != "" && this.apreciareClubNumber != null) {
                var upper = this.apreciareClubNumber.toUpperCase()
                this.apreciareClubNumber = upper
          }
           let str = "";
            if (!this.validRegex.test(this.apreciareClubNumber)) {
              str = this.apreciareClubNumber.substring(0, this.apreciareClubNumber.length - 1);
              this.apreciareClubNumber = str;
            }
      },
      fiestaRewardsNumber() {
        this.enableRewards = false;
        this.banMemFR = false;
        this.banLoaderFR = false;
      },
      selectAllExtra() {
          if(this.selectAllExtra) {
 
                 if(this.$store.getters.gettingLang == 'es') {
             this.habitacion1.typePreferentExtra =  'Todas las preferencias extras'
        }
         if( this.$store.getters.gettingLang == 'en') {
         this.habitacion1.typePreferentExtra = 'All extra preferences';
        }
          }
      },
      selectAll() {
          if(this.selectAll) {
      if(this.$store.getters.gettingLang == 'es') {
             this.habitacion1.typePreferent = 'Todas las preferencias de habitación'
        }
         if( this.$store.getters.gettingLang == 'en') {
         this.habitacion1.typePreferent = 'All room types'
        }
          }
      },
      fechaExpiracionTarCred(){
        this.credito.expiracion = this.fechaExpiracionTarCred;
        if (this.fechaExpiracionTarCred.length === 7) {
          var mes = this.fechaExpiracionTarCred.substring(0, 2);
          var ano = this.fechaExpiracionTarCred.substring(3, 7);
          this.validDateExpirationTarCred = GlobalFunctions.IsValidDateExpiration(mes, ano);
          this.banTarCredExp = this.validDateExpirationTarCred.banDate;
        } else {
          this.banTarCredExp = true;
        }
      },
      fechaExpiracionToken(){
        this.token.expiracion = this.fechaExpiracionToken;
        if (this.fechaExpiracionToken.length === 7) {
          var mes = this.fechaExpiracionToken.substring(0, 2);
          var ano = this.fechaExpiracionToken.substring(3, 7);
          this.validDateExpirationToken = GlobalFunctions.IsValidDateExpiration(mes, ano);
          this.banTokenExp = this.validDateExpirationToken.banDate;
        } else {
          this.banTokenExp = true;
        }
      },
      adultos() {
        var ad =  this.ls.get("totalGuestsReadOnly")
        ad.data.totalAdults = this.adultos
                this.ls.set("totalGuestsReadOnly", ad )
        this.personas = this.adultos + this.menores + this.infantes
      },
      menores() {
        var ad =  this.ls.get("totalGuestsReadOnly")
        ad.data.totalChildren = this.menores
        this.ls.set("totalGuestsReadOnly", ad )
        this.personas = this.adultos + this.menores + this.infantes
       if((this.menores + this.infantes) > 2) {
         
         this.isModalMayorInfantes = true
         this.menores -= 1
       }
      },
      infantes() {
var ad =  this.ls.get("totalGuestsReadOnly")
        ad.data.totalInfants = this.infantes
                this.ls.set("totalGuestsReadOnly", ad )
        this.personas = this.adultos + this.menores + this.infantes
  if((this.menores + this.infantes) > 2) {
         this.isModalMayorInfantes = true
         this.infantes -= 1
       }
     
      },
      personas() {
var ad =  this.ls.get("totalGuestsReadOnly")
        ad.data.totalGuests = this.personas
                this.ls.set("totalGuestsReadOnly",ad )
      },
      iconoActivo() {
            if(this.iconoActivo != 1 && this.iconoActivo != 2) {
               this.credito.tarjetaSeleccionada = ""
           this.credito.numero = ""
           this.credito.tipoDeMascara = ""
           this.credito.nombre= ""
           this.credito.expiracion = ""
           this.credito.tarjetaSeleccionada = ""
           this.credito.numero = ""
           this.credito.nombre = ""
           this.credito.expiracion = ""
          
            }
      },
       agreementCode() {
      
        this.validateCode()
        if(this.IATANeeded == true && (this.iata != '')) {
  this.IATANeeded = false
}

            this.agreementCode = this.agreementCode.toUpperCase();

     
      },
         iata() {
         
            this.validateCode()
            if( this.iata != '') {
              this.IATANeeded = false
            } else {
                            this.IATANeeded = true

            }

            if(this.showAgreement2 == false && this.iata == '') {
              this.IATANeeded = false
            }
            this.iata = this.iata.toUpperCase();
        
        
      },
      descuento() {
       this.ls.set('discountCodeRO', this.descuento)
          this.validateCode()
          if(this.IATANeeded == true && (this.iata != '')) {
          this.IATANeeded = false
          }
            this.descuento = this.descuento.toUpperCase();
            

      },
      motiva() {
        var ls = new SecureLS({encodingType: 'aes'});
 
          if(this.motiva == "" || this.motiva == null) {
            ls.set('unableApreciare', {data: false})
          }
          
          if(this.motiva != "" && this.motiva != null) {
            ls.set('unableApreciare', {data: true})
          }

       
        this.validateCode()
if(this.IATANeeded == true && (this.iata != '')) {
  this.IATANeeded = false
}

            this.motiva = this.motiva.toUpperCase();

      
      },
      promocion() {
      
        if(this.promocion != '') {
          this.IATANeeded = false
        }

        if(this.showAgreement2 == true && (this.promocion == '' && this.iata == '' && this.motiva == '' && this.agreementCode == '')) {
          this.IATANeeded = true

        }
        
            this.promocion = this.promocion.toUpperCase();

        this.validateCode()
   
    
      },
      entrada() {
        this.beautyDateInput = GlobalFunctions.convertBeautifulDate(this.entrada, this.ls.get('Language').data);
        if (this.dCou > 1) {
          var newEntry = new Date(this.entrada),
          dias = 1
          this.salida = newEntry.setDate(newEntry.getDate() + dias);
        }
        this.dCou++

      },
      salida() {
        this.beautyDateOutput = GlobalFunctions.convertBeautifulDate(this.salida, this.ls.get('Language').data);
        this.ls.set("extradateOutput", this.beautyDateOutput);
      },
 tryingAgain() {
        if(  this.selected.length != this.typeRooms.length &&  this.selected.length > 1 && this.$store.getters.gettingLang == 'es' ) {
              this.tipoHabitacion =  'Ver preferencias de habitación seleccionadas';

        } 
        if(  this.selected.length != this.typeRooms.length &&  this.selected.length > 1 && this.$store.getters.gettingLang == 'en' ) {
              this.tipoHabitacion =  'See selected room types';

        } 

         if(  this.selected.length == this.typeRooms.length  && this.$store.getters.gettingLang == 'es' ) {
              this.tipoHabitacion =  'Todas las preferencias de habitación';

        } 
        if(  this.selected.length == this.typeRooms.length &&   this.$store.getters.gettingLang == 'en' ) {
              this.tipoHabitacion =  'All room types';

        } 
if(  this.selected.length == 0  && this.$store.getters.gettingLang == 'es' ) {
              this.tipoHabitacion =  'Seleccionar';

        } 
        if(  this.selected.length == 0 &&   this.$store.getters.gettingLang == 'en' ) {
              this.tipoHabitacion =  'Select';

        } 
      }
    },
    computed: {
      minDate() {
      
      if(!this.groupBool)
      {
        return this.todayDate;
      }
      else{
        var date1 = moment(this.InfoGrupo.checkIn)
        var date2 = moment()
        if(date1 >  date2){

          return this.removeTimezoneFromDate(this.InfoGrupo.checkIn);
        }
        else{
          return this.todayDate;
        }
    }
    },minblockDate() {
      
     
      var fechaEntrada = new Date(this.entrada),
      dias = 1
      return fechaEntrada.setDate(fechaEntrada.getDate() + dias);
  
  },
      langues() {
          return this.$store.getters.gettingLang
      },
      isDisabledTokenizador() {
        switch (this.iconoActivo) {
          case 1: // Tarjeta de crédito
            if (this.credito.tarjetaSeleccionada.length > 2) {
              return false;
            } else {
              this.credito.numero == ''
              return true;
            }
            break;
          case 2: // Token
            if (this.token.tarjetaSeleccionada.length > 2) {
              return false;
            } else {
              return true;
            }
            break;
          default:
            return true;
            break;
        }
      },
  y() {
    if(this.$store.getters.gettingLang == "es") {
          return "y"
        } else {
          return "and"
        }
      },
        tryingAgain() {
        if(this.$store.getters.gettingLang == 'es') {
        return this.$store.getters.gettingLang
} else {
          
        return this.$store.getters.gettingLang
        }
        
        },
      dateTextIn() {
        if(this.$store.getters.gettingLang == "es") {
            return "Entrada"
        } else {
          return "Check In" 
        }
      },
       dateTextOut() {
        if(this.$store.getters.gettingLang == "es") {
            return "Salida"
        } else {
          return "Check Out" 
        }
      },
      // Habitaciones
      resetPersons() {
        return [
          this.adultos = 1,
          this.menores = 0,
          this.infantes = 0,
          this.habitaciones = 1,
          this.personas = (this.adultos + this.menores + this.infantes),
        ]
      },
      // De la modal
      selectAllModal: {
        get: function () {
          return this.selected.length == this.typeRooms.length;
        },
        set: function (value) {
          var selected = [];
          if (value) {
            this.typeRooms.forEach(function (typeRoom) {
              selected.push(typeRoom.id);
            });
          }
          this.selectedModal = selected;
        }
      },
      // Tipo de preferencia
      selectAll: {
        get: function () {
          return this.habitacion1.typeRoomsPreferents ? this.habitacion1.selected.length == this
            .habitacion1.typeRoomsPreferents.length : false;
        },
        set: function (value) {
          var selected = [];
          if (value) {
            this.habitacion1.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
              selected.push(typeRoomPreferent.id);
            });
          }
          this.habitacion1.selected = selected;
        }
      },
      // Tipo de preferencia extra
      selectAllExtra: {
        get: function () {
          return this.habitacion1.typeExtrasPreferents ? this.habitacion1.selectedExtra.length ==
            this.habitacion1.typeExtrasPreferents.length : false;
        },
        set: function (value) {
          var selectedExtra = [];
          if (value) {
            this.habitacion1.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
              selectedExtra.push(typeExtraPreferent.id);
            });
          }
          this.habitacion1.selectedExtra = selectedExtra;
        }
      },
      // Metodo de pago
      // Valida campos
      isDisabled() { 
        switch (this.iconoActivo) {
          case 0:
            if (
              this.vaucher.politicaSeleccionada.length > 2 && this.vaucher.razonSeleccionada.length > 2
              && this.vaucher.politicaSeleccionadaCode != '-1' && this.vaucher.razonSeleccionadaCode != '-1'
              && this.vaucher.politicaSeleccionadaCode != '' && this.vaucher.razonSeleccionadaCode != ''
              && this.aceptoAviso &&
              ((this.fiestaRewardsNumber.length === 0) || (this.fiestaRewardsNumber.length >= 7 && this.banMemFR))
              && this.banSelectedPoliticaVaucher) {
              return false;
            } else {
              return true;
            }
            break;
          case 1:
            if (this.credito.tarjetaSeleccionada.length > 2 &&
              this.credito.tipoDeMascara.length > 2 &&
              this.credito.numero.length > 9 &&
              this.credito.nombre.length > 2 &&
              this.credito.expiracion.length > 2 &&
              this.aceptoAviso &&
              ((this.fiestaRewardsNumber.length === 0) || (this.fiestaRewardsNumber.length >= 7 && this.banMemFR))
              && this.banSelectedPoliticaCredito) {
              return false;
            } else {
              return true;
            }
            break;
          case 2:
            if (this.token.tarjetaSeleccionada.length > 2 &&
              this.token.numero.length > 9 &&
              this.token.nombre.length > 2 &&
              this.token.expiracion.length > 2 &&
              this.aceptoAviso &&
              ((this.fiestaRewardsNumber.length === 0) || (this.fiestaRewardsNumber.length >= 7 && this.banMemFR))
              && this.banSelectedPoliticaToken) {
              return false;
            } else {
              return true;
            }
            break;
          case 3:
            if ( this.aceptoAviso &&
              ((this.fiestaRewardsNumber.length === 0) || (this.fiestaRewardsNumber.length >= 7 && this.banMemFR))
              && this.banSelectedPoliticaTiempoLimite) {
              return false;
            } else {
              return true;
            }
            break;
          case 4:
            if ( this.creditoEmpresa.politicaSeleccionada.length > 2 && this.creditoEmpresa.razonSeleccionada.length > 2
              && this.creditoEmpresa.politicaSeleccionadaCode != '-1' && this.creditoEmpresa.razonSeleccionadaCode != '-1'
              && this.creditoEmpresa.politicaSeleccionadaCode != '' && this.creditoEmpresa.razonSeleccionadaCode != ''
              && this.aceptoAviso && ((this.fiestaRewardsNumber.length === 0) || (this.fiestaRewardsNumber.length >= 7 && this.banMemFR))
              && this.banSelectedPoliticaCreditoEmpresa) {
              return false;
            } else {
              return true;
            }
            break;
          default:
            break;
        }
      }, 
      isDisabledCheckbox(){
        this.aceptoAviso = false;
        if (this.iconoActivo === 0 || this.iconoActivo === 3 || this.iconoActivo === 4) {
          return false;
        } else{
          if (((this.iconoActivo === 1 && (this.credito.numero !== '' && this.credito.expiracion !== '' && this.credito.nombre !== '' && this.credito.tarjetaSeleccionada !== ''))
          || (this.iconoActivo === 2 && (this.token.numero !== '' && this.token.expiracion !== '' && this.token.nombre !== '' && this.token.tarjetaSeleccionada !== '')))) {
            return false;
          } else{
            return true;
          }
        }
      },
    },
    filters: {
      resalt: function (value, valueFromSearch) {
        if (!value) return ''
        valueFromSearch != '' ? value = value.replace(valueFromSearch,
          '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>'
        ) : value = value;
        return value;
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/config.scss";

  @media (max-width: 736px) {
    .room, .typeRoom, .listado-container {
      max-height: unset !important;
      padding: 0;
    }
    .px-4 {
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }
  }

  .notaAzul {
    color: $colorBase2;
    font-weight: 500;
  }
    .section-full {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #fff;
    top: 0;
    right: -100%;
    z-index: 10;
    transition: all .3s !important;
    overflow: hidden;
  }
  .section-full__header {
    background: white;
    padding: 17.5px 50px;
    position: relative;
    border-bottom: 1px solid #e7e8e9;
    button {
      width: 50px;
      height: 56px;
      background: transparent;
      color: #005a83;
      border: none;
      position: absolute;
      left: 0;
      top: 0;
      padding: 0;
      border-right: solid 1px rgba(255, 255, 255, 0.2);
      span {
        font-size: 24px;
      }
      &:focus {
        outline: none;
      }
    }
    h4 {
      margin: 0;
      font-size: 17px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.24;
      letter-spacing: 0.43px;
    }
  }
  .section-full__body {
    height: calc(100% - 165px);
    padding-bottom: 58px;
    overflow: auto;
  }
  .section-full__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px;
    width: 100%;
    button {
      &:first-child {
        margin-bottom: 15px;
      }
    }
  }
  .section-full--open {
    right: 0;
    transition: all .3s !important;
  }


  .modal-body {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  #modal-1 .container-footer {
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  #modal-1 .container-padding {
    padding-left: 24px;
    padding-right: 71px;
    padding-bottom: 32px;
  }
  .v-align-elements>* {
    display: inline;
    vertical-align: middle;
  }
  .tituloDatos {
    width: fit-content;
    cursor: pointer;
    font-weight: 500;
    margin-bottom: 0;
  }
  .tituloDatos[aria-expanded="true"] {
    color: #0c5458;
  }
  .contenidoSearchCard {
    position: relative;
    .search-iconsCards {
      position: absolute;
      left: 5px;
      margin-top: 9px;
      font-size: 18px;
      color: #005a83;
      height: 34px;
    }
    .elipseCards {
      padding-left: 35px !important;
    }
  }
  .addIcon {
    margin-top: 11px;
    margin-right: 5px;
    font-size: $font-size-exlarge;
    color: $colorBase2;
    right: 0;
    z-index: 3;
  }
  // input:read-only,
  // input:read-only:focus {
  //   cursor: not-allowed;
  //   outline: none;
  //   -webkit-box-shadow: none;
  //   box-shadow: none;
  //   border: solid 1px #cacaca;
  //   background-color: #f8f8f8;
  // }
  // .form-element input {
  //   margin-top: 4px;
  // }
  .remove-top-radius {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .no-border-bottom {
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-bottom: 0 !important;
  }
  .typeRoom.card {
    margin-left: 0;
  }
  .oculto {
    display: none !important;
  }
  .card-body {
    padding: 32px 24px 0px;
  }
  // scss var for title is on 18px and h1 is on 28px
  .title {
    font-size: 20px;
  }
  // Remove unwanted space
  p.card-text,
  h3,
  h4 {
    margin-bottom: 0;
  }
  // Remove unwanted space
  hr {
    margin-top: 0;
    margin-bottom: 0;
  }
  label.checkbox {
    cursor: pointer;
    input {
      cursor: pointer;
    }
  }
  i.fix-margin {
    margin-left: -0.2rem;
  }
  .PC-text--size14 {
    font-size: $font-size-base;
  }
  .contentContacto {
    display: flex;
    position: relative;
    min-height: 70vh;
  }
  .contacto {
    width: 100%;
    margin-top: 57px;
    padding-top: 32px;
    .card-body {
      min-height: 181px;
      .card-title {
        font-size: $font-size-large;
      }
    }
    .estancia {
      font-size: $font-size-biglarge;
      font-weight: bold;
    }
  }
  .modify-reservation {
    max-width: 770px;
    .card-header {
      background-color: #d1ecf1;
    }
    .referencia {
      color: $colorBase2;
    }
  }
  @media only screen and (max-width: 991px) {
    .card-body {
      padding: 32px 16px 40px;
    }
  }
</style>